var _toConsumableArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@myplay/all"] = t() : e["@myplay/all"] = t();
}(this, function () {
  return function () {
    var e = {
        9669: function _(e, t, r) {
          e.exports = r(1609);
        },
        7970: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(6026),
            s = r(4097),
            o = r(5327),
            i = r(3685),
            u = r(5687),
            c = r(938).http,
            f = r(938).https,
            d = r(7310),
            p = r(9796),
            l = r(8593),
            h = r(5061),
            m = r(481),
            v = /https:?/;
          e.exports = function (e) {
            return new Promise(function (t, r) {
              var w = function w(e) {
                  t(e);
                },
                g = function g(e) {
                  r(e);
                },
                y = e.data,
                b = e.headers;
              if (b["User-Agent"] || b["user-agent"] || (b["User-Agent"] = "axios/" + l.version), y && !n.isStream(y)) {
                if (Buffer.isBuffer(y)) ;else if (n.isArrayBuffer(y)) y = Buffer.from(new Uint8Array(y));else {
                  if (!n.isString(y)) return g(h("Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream", e));
                  y = Buffer.from(y, "utf-8");
                }
                b["Content-Length"] = y.length;
              }
              var k = void 0;
              e.auth && (k = (e.auth.username || "") + ":" + (e.auth.password || ""));
              var x = s(e.baseURL, e.url),
                T = d.parse(x),
                E = T.protocol || "http:";
              if (!k && T.auth) {
                var _ = T.auth.split(":");
                k = (_[0] || "") + ":" + (_[1] || "");
              }
              k && delete b.Authorization;
              var C = v.test(E),
                S = C ? e.httpsAgent : e.httpAgent,
                R = {
                  path: o(T.path, e.params, e.paramsSerializer).replace(/^\?/, ""),
                  method: e.method.toUpperCase(),
                  headers: b,
                  agent: S,
                  agents: {
                    http: e.httpAgent,
                    https: e.httpsAgent
                  },
                  auth: k
                };
              e.socketPath ? R.socketPath = e.socketPath : (R.hostname = T.hostname, R.port = T.port);
              var D,
                P = e.proxy;
              if (!P && !1 !== P) {
                var I = E.slice(0, -1) + "_proxy",
                  O = {
                    TARGET_ENV: "PRODUCTION"
                  }[I] || {
                    TARGET_ENV: "PRODUCTION"
                  }[I.toUpperCase()];
                if (O) {
                  var N = d.parse(O),
                    q = {
                      TARGET_ENV: "PRODUCTION"
                    }.no_proxy || {
                      TARGET_ENV: "PRODUCTION"
                    }.NO_PROXY,
                    A = !0;
                  if (q && (A = !q.split(",").map(function (e) {
                    return e.trim();
                  }).some(function (e) {
                    return !!e && ("*" === e || "." === e[0] && T.hostname.substr(T.hostname.length - e.length) === e || T.hostname === e);
                  })), A && (P = {
                    host: N.hostname,
                    port: N.port
                  }, N.auth)) {
                    var M = N.auth.split(":");
                    P.auth = {
                      username: M[0],
                      password: M[1]
                    };
                  }
                }
              }
              if (P && (R.hostname = P.host, R.host = P.host, R.headers.host = T.hostname + (T.port ? ":" + T.port : ""), R.port = P.port, R.path = E + "//" + T.hostname + (T.port ? ":" + T.port : "") + R.path, P.auth)) {
                var U = Buffer.from(P.auth.username + ":" + P.auth.password, "utf8").toString("base64");
                R.headers["Proxy-Authorization"] = "Basic " + U;
              }
              var L = C && (!P || v.test(P.protocol));
              e.transport ? D = e.transport : 0 === e.maxRedirects ? D = L ? u : i : (e.maxRedirects && (R.maxRedirects = e.maxRedirects), D = L ? f : c), e.maxContentLength && e.maxContentLength > -1 && (R.maxBodyLength = e.maxContentLength);
              var F = D.request(R, function (t) {
                if (!F.aborted) {
                  var r = t;
                  switch (t.headers["content-encoding"]) {
                    case "gzip":
                    case "compress":
                    case "deflate":
                      r = 204 === t.statusCode ? r : r.pipe(p.createUnzip()), delete t.headers["content-encoding"];
                  }
                  var n = t.req || F,
                    s = {
                      status: t.statusCode,
                      statusText: t.statusMessage,
                      headers: t.headers,
                      config: e,
                      request: n
                    };
                  if ("stream" === e.responseType) s.data = r, a(w, g, s);else {
                    var o = [];
                    r.on("data", function (t) {
                      o.push(t), e.maxContentLength > -1 && Buffer.concat(o).length > e.maxContentLength && (r.destroy(), g(h("maxContentLength size of " + e.maxContentLength + " exceeded", e, null, n)));
                    }), r.on("error", function (t) {
                      F.aborted || g(m(t, e, null, n));
                    }), r.on("end", function () {
                      var t = Buffer.concat(o);
                      "arraybuffer" !== e.responseType && (t = t.toString(e.responseEncoding)), s.data = t, a(w, g, s);
                    });
                  }
                }
              });
              F.on("error", function (t) {
                F.aborted || g(m(t, e, null, F));
              }), e.timeout && F.setTimeout(e.timeout, function () {
                F.abort(), g(h("timeout of " + e.timeout + "ms exceeded", e, "ECONNABORTED", F));
              }), e.cancelToken && e.cancelToken.promise.then(function (e) {
                F.aborted || (F.abort(), g(e));
              }), n.isStream(y) ? y.on("error", function (t) {
                g(m(t, e, null, F));
              }).pipe(F) : F.end(y);
            });
          };
        },
        5448: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(6026),
            s = r(5327),
            o = r(4097),
            i = r(4109),
            u = r(7985),
            c = r(5061);
          e.exports = function (e) {
            return new Promise(function (t, f) {
              var d = e.data,
                p = e.headers;
              n.isFormData(d) && delete p["Content-Type"];
              var l = new XMLHttpRequest();
              if (e.auth) {
                var h = e.auth.username || "",
                  m = e.auth.password || "";
                p.Authorization = "Basic " + btoa(h + ":" + m);
              }
              var v = o(e.baseURL, e.url);
              if (l.open(e.method.toUpperCase(), s(v, e.params, e.paramsSerializer), !0), l.timeout = e.timeout, l.onreadystatechange = function () {
                if (l && 4 === l.readyState && (0 !== l.status || l.responseURL && 0 === l.responseURL.indexOf("file:"))) {
                  var r = "getAllResponseHeaders" in l ? i(l.getAllResponseHeaders()) : null,
                    n = {
                      data: e.responseType && "text" !== e.responseType ? l.response : l.responseText,
                      status: l.status,
                      statusText: l.statusText,
                      headers: r,
                      config: e,
                      request: l
                    };
                  a(t, f, n), l = null;
                }
              }, l.onabort = function () {
                l && (f(c("Request aborted", e, "ECONNABORTED", l)), l = null);
              }, l.onerror = function () {
                f(c("Network Error", e, null, l)), l = null;
              }, l.ontimeout = function () {
                var t = "timeout of " + e.timeout + "ms exceeded";
                e.timeoutErrorMessage && (t = e.timeoutErrorMessage), f(c(t, e, "ECONNABORTED", l)), l = null;
              }, n.isStandardBrowserEnv()) {
                var w = r(4372),
                  g = (e.withCredentials || u(v)) && e.xsrfCookieName ? w.read(e.xsrfCookieName) : void 0;
                g && (p[e.xsrfHeaderName] = g);
              }
              if ("setRequestHeader" in l && n.forEach(p, function (e, t) {
                void 0 === d && "content-type" === t.toLowerCase() ? delete p[t] : l.setRequestHeader(t, e);
              }), n.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), e.responseType) try {
                l.responseType = e.responseType;
              } catch (t) {
                if ("json" !== e.responseType) throw t;
              }
              "function" == typeof e.onDownloadProgress && l.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && l.upload && l.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
                l && (l.abort(), f(e), l = null);
              }), void 0 === d && (d = null), l.send(d);
            });
          };
        },
        1609: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(1849),
            s = r(321),
            o = r(7185);
          function i(e) {
            var t = new s(e),
              r = a(s.prototype.request, t);
            return n.extend(r, s.prototype, t), n.extend(r, t), r;
          }
          var u = i(r(5655));
          u.Axios = s, u.create = function (e) {
            return i(o(u.defaults, e));
          }, u.Cancel = r(5263), u.CancelToken = r(4972), u.isCancel = r(6502), u.all = function (e) {
            return Promise.all(e);
          }, u.spread = r(8713), e.exports = u, e.exports["default"] = u;
        },
        5263: function _(e) {
          "use strict";

          function t(e) {
            this.message = e;
          }
          t.prototype.toString = function () {
            return "Cancel" + (this.message ? ": " + this.message : "");
          }, t.prototype.__CANCEL__ = !0, e.exports = t;
        },
        4972: function _(e, t, r) {
          "use strict";

          var n = r(5263);
          function a(e) {
            if ("function" != typeof e) throw new TypeError("executor must be a function.");
            var t;
            this.promise = new Promise(function (e) {
              t = e;
            });
            var r = this;
            e(function (e) {
              r.reason || (r.reason = new n(e), t(r.reason));
            });
          }
          a.prototype.throwIfRequested = function () {
            if (this.reason) throw this.reason;
          }, a.source = function () {
            var e;
            return {
              token: new a(function (t) {
                e = t;
              }),
              cancel: e
            };
          }, e.exports = a;
        },
        6502: function _(e) {
          "use strict";

          e.exports = function (e) {
            return !(!e || !e.__CANCEL__);
          };
        },
        321: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(5327),
            s = r(782),
            o = r(3572),
            i = r(7185);
          function u(e) {
            this.defaults = e, this.interceptors = {
              request: new s(),
              response: new s()
            };
          }
          u.prototype.request = function (e) {
            "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = i(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
            var t = [o, void 0],
              r = Promise.resolve(e);
            for (this.interceptors.request.forEach(function (e) {
              t.unshift(e.fulfilled, e.rejected);
            }), this.interceptors.response.forEach(function (e) {
              t.push(e.fulfilled, e.rejected);
            }); t.length;) r = r.then(t.shift(), t.shift());
            return r;
          }, u.prototype.getUri = function (e) {
            return e = i(this.defaults, e), a(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
          }, n.forEach(["delete", "get", "head", "options"], function (e) {
            u.prototype[e] = function (t, r) {
              return this.request(n.merge(r || {}, {
                method: e,
                url: t
              }));
            };
          }), n.forEach(["post", "put", "patch"], function (e) {
            u.prototype[e] = function (t, r, a) {
              return this.request(n.merge(a || {}, {
                method: e,
                url: t,
                data: r
              }));
            };
          }), e.exports = u;
        },
        782: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          function a() {
            this.handlers = [];
          }
          a.prototype.use = function (e, t) {
            return this.handlers.push({
              fulfilled: e,
              rejected: t
            }), this.handlers.length - 1;
          }, a.prototype.eject = function (e) {
            this.handlers[e] && (this.handlers[e] = null);
          }, a.prototype.forEach = function (e) {
            n.forEach(this.handlers, function (t) {
              null !== t && e(t);
            });
          }, e.exports = a;
        },
        4097: function _(e, t, r) {
          "use strict";

          var n = r(1793),
            a = r(7303);
          e.exports = function (e, t) {
            return e && !n(t) ? a(e, t) : t;
          };
        },
        5061: function _(e, t, r) {
          "use strict";

          var n = r(481);
          e.exports = function (e, t, r, a, s) {
            var o = new Error(e);
            return n(o, t, r, a, s);
          };
        },
        3572: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(8527),
            s = r(6502),
            o = r(5655);
          function i(e) {
            e.cancelToken && e.cancelToken.throwIfRequested();
          }
          e.exports = function (e) {
            return i(e), e.headers = e.headers || {}, e.data = a(e.data, e.headers, e.transformRequest), e.headers = n.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
              delete e.headers[t];
            }), (e.adapter || o.adapter)(e).then(function (t) {
              return i(e), t.data = a(t.data, t.headers, e.transformResponse), t;
            }, function (t) {
              return s(t) || (i(e), t && t.response && (t.response.data = a(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
            });
          };
        },
        481: function _(e) {
          "use strict";

          e.exports = function (e, t, r, n, a) {
            return e.config = t, r && (e.code = r), e.request = n, e.response = a, e.isAxiosError = !0, e.toJSON = function () {
              return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code
              };
            }, e;
          };
        },
        7185: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          e.exports = function (e, t) {
            t = t || {};
            var r = {},
              a = ["url", "method", "params", "data"],
              s = ["headers", "auth", "proxy"],
              o = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
            n.forEach(a, function (e) {
              void 0 !== t[e] && (r[e] = t[e]);
            }), n.forEach(s, function (a) {
              n.isObject(t[a]) ? r[a] = n.deepMerge(e[a], t[a]) : void 0 !== t[a] ? r[a] = t[a] : n.isObject(e[a]) ? r[a] = n.deepMerge(e[a]) : void 0 !== e[a] && (r[a] = e[a]);
            }), n.forEach(o, function (n) {
              void 0 !== t[n] ? r[n] = t[n] : void 0 !== e[n] && (r[n] = e[n]);
            });
            var i = a.concat(s).concat(o),
              u = Object.keys(t).filter(function (e) {
                return -1 === i.indexOf(e);
              });
            return n.forEach(u, function (n) {
              void 0 !== t[n] ? r[n] = t[n] : void 0 !== e[n] && (r[n] = e[n]);
            }), r;
          };
        },
        6026: function _(e, t, r) {
          "use strict";

          var n = r(5061);
          e.exports = function (e, t, r) {
            var a = r.config.validateStatus;
            !a || a(r.status) ? e(r) : t(n("Request failed with status code " + r.status, r.config, null, r.request, r));
          };
        },
        8527: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          e.exports = function (e, t, r) {
            return n.forEach(r, function (r) {
              e = r(e, t);
            }), e;
          };
        },
        5655: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = r(6016),
            s = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
          function o(e, t) {
            !n.isUndefined(e) && n.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
          }
          var i,
            u = {
              adapter: ("undefined" != typeof XMLHttpRequest ? i = r(5448) : "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process) && (i = r(7970)), i),
              transformRequest: [function (e, t) {
                return a(t, "Accept"), a(t, "Content-Type"), n.isFormData(e) || n.isArrayBuffer(e) || n.isBuffer(e) || n.isStream(e) || n.isFile(e) || n.isBlob(e) ? e : n.isArrayBufferView(e) ? e.buffer : n.isURLSearchParams(e) ? (o(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : n.isObject(e) ? (o(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
              }],
              transformResponse: [function (e) {
                if ("string" == typeof e) try {
                  e = JSON.parse(e);
                } catch (e) {}
                return e;
              }],
              timeout: 0,
              xsrfCookieName: "XSRF-TOKEN",
              xsrfHeaderName: "X-XSRF-TOKEN",
              maxContentLength: -1,
              validateStatus: function validateStatus(e) {
                return e >= 200 && e < 300;
              },
              headers: {
                common: {
                  Accept: "application/json, text/plain, */*"
                }
              }
            };
          n.forEach(["delete", "get", "head"], function (e) {
            u.headers[e] = {};
          }), n.forEach(["post", "put", "patch"], function (e) {
            u.headers[e] = n.merge(s);
          }), e.exports = u;
        },
        1849: function _(e) {
          "use strict";

          e.exports = function (e, t) {
            return function () {
              for (var r = new Array(arguments.length), n = 0; n < r.length; n++) r[n] = arguments[n];
              return e.apply(t, r);
            };
          };
        },
        5327: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          function a(e) {
            return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
          }
          e.exports = function (e, t, r) {
            if (!t) return e;
            var s;
            if (r) s = r(t);else if (n.isURLSearchParams(t)) s = t.toString();else {
              var o = [];
              n.forEach(t, function (e, t) {
                null != e && (n.isArray(e) ? t += "[]" : e = [e], n.forEach(e, function (e) {
                  n.isDate(e) ? e = e.toISOString() : n.isObject(e) && (e = JSON.stringify(e)), o.push(a(t) + "=" + a(e));
                }));
              }), s = o.join("&");
            }
            if (s) {
              var i = e.indexOf("#");
              -1 !== i && (e = e.slice(0, i)), e += (-1 === e.indexOf("?") ? "?" : "&") + s;
            }
            return e;
          };
        },
        7303: function _(e) {
          "use strict";

          e.exports = function (e, t) {
            return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
          };
        },
        4372: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          e.exports = n.isStandardBrowserEnv() ? {
            write: function write(e, t, r, a, s, o) {
              var i = [];
              i.push(e + "=" + encodeURIComponent(t)), n.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), n.isString(a) && i.push("path=" + a), n.isString(s) && i.push("domain=" + s), !0 === o && i.push("secure"), document.cookie = i.join("; ");
            },
            read: function read(e) {
              var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
              return t ? decodeURIComponent(t[3]) : null;
            },
            remove: function remove(e) {
              this.write(e, "", Date.now() - 864e5);
            }
          } : {
            write: function write() {},
            read: function read() {
              return null;
            },
            remove: function remove() {}
          };
        },
        1793: function _(e) {
          "use strict";

          e.exports = function (e) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
          };
        },
        7985: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          e.exports = n.isStandardBrowserEnv() ? function () {
            var e,
              t = /(msie|trident)/i.test(navigator.userAgent),
              r = document.createElement("a");
            function a(e) {
              var n = e;
              return t && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
                href: r.href,
                protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
                host: r.host,
                search: r.search ? r.search.replace(/^\?/, "") : "",
                hash: r.hash ? r.hash.replace(/^#/, "") : "",
                hostname: r.hostname,
                port: r.port,
                pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
              };
            }
            return e = a(window.location.href), function (t) {
              var r = n.isString(t) ? a(t) : t;
              return r.protocol === e.protocol && r.host === e.host;
            };
          }() : function () {
            return !0;
          };
        },
        6016: function _(e, t, r) {
          "use strict";

          var n = r(4867);
          e.exports = function (e, t) {
            n.forEach(e, function (r, n) {
              n !== t && n.toUpperCase() === t.toUpperCase() && (e[t] = r, delete e[n]);
            });
          };
        },
        4109: function _(e, t, r) {
          "use strict";

          var n = r(4867),
            a = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
          e.exports = function (e) {
            var t,
              r,
              s,
              o = {};
            return e ? (n.forEach(e.split("\n"), function (e) {
              if (s = e.indexOf(":"), t = n.trim(e.substr(0, s)).toLowerCase(), r = n.trim(e.substr(s + 1)), t) {
                if (o[t] && a.indexOf(t) >= 0) return;
                o[t] = "set-cookie" === t ? (o[t] ? o[t] : []).concat([r]) : o[t] ? o[t] + ", " + r : r;
              }
            }), o) : o;
          };
        },
        8713: function _(e) {
          "use strict";

          e.exports = function (e) {
            return function (t) {
              return e.apply(null, t);
            };
          };
        },
        4867: function _(e, t, r) {
          "use strict";

          var n = r(1849),
            a = Object.prototype.toString;
          function s(e) {
            return "[object Array]" === a.call(e);
          }
          function o(e) {
            return void 0 === e;
          }
          function i(e) {
            return null !== e && "object" == typeof e;
          }
          function u(e) {
            return "[object Function]" === a.call(e);
          }
          function c(e, t) {
            if (null != e) if ("object" != typeof e && (e = [e]), s(e)) for (var r = 0, n = e.length; r < n; r++) t.call(null, e[r], r, e);else for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.call(null, e[a], a, e);
          }
          e.exports = {
            isArray: s,
            isArrayBuffer: function isArrayBuffer(e) {
              return "[object ArrayBuffer]" === a.call(e);
            },
            isBuffer: function isBuffer(e) {
              return null !== e && !o(e) && null !== e.constructor && !o(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
            },
            isFormData: function isFormData(e) {
              return "undefined" != typeof FormData && e instanceof FormData;
            },
            isArrayBufferView: function isArrayBufferView(e) {
              return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
            },
            isString: function isString(e) {
              return "string" == typeof e;
            },
            isNumber: function isNumber(e) {
              return "number" == typeof e;
            },
            isObject: i,
            isUndefined: o,
            isDate: function isDate(e) {
              return "[object Date]" === a.call(e);
            },
            isFile: function isFile(e) {
              return "[object File]" === a.call(e);
            },
            isBlob: function isBlob(e) {
              return "[object Blob]" === a.call(e);
            },
            isFunction: u,
            isStream: function isStream(e) {
              return i(e) && u(e.pipe);
            },
            isURLSearchParams: function isURLSearchParams(e) {
              return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
            },
            isStandardBrowserEnv: function isStandardBrowserEnv() {
              return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
            },
            forEach: c,
            merge: function e() {
              var t = {};
              function r(r, n) {
                "object" == typeof t[n] && "object" == typeof r ? t[n] = e(t[n], r) : t[n] = r;
              }
              for (var n = 0, a = arguments.length; n < a; n++) c(arguments[n], r);
              return t;
            },
            deepMerge: function e() {
              var t = {};
              function r(r, n) {
                "object" == typeof t[n] && "object" == typeof r ? t[n] = e(t[n], r) : t[n] = "object" == typeof r ? e({}, r) : r;
              }
              for (var n = 0, a = arguments.length; n < a; n++) c(arguments[n], r);
              return t;
            },
            extend: function extend(e, t, r) {
              return c(t, function (t, a) {
                e[a] = r && "function" == typeof t ? n(t, r) : t;
              }), e;
            },
            trim: function trim(e) {
              return e.replace(/^\s*/, "").replace(/\s*$/, "");
            }
          };
        },
        1227: function _(e, t, r) {
          t.formatArgs = function (t) {
            if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
            var r = "color: " + this.color;
            t.splice(1, 0, r, "color: inherit");
            var n = 0,
              a = 0;
            t[0].replace(/%[a-zA-Z%]/g, function (e) {
              "%%" !== e && (n++, "%c" === e && (a = n));
            }), t.splice(a, 0, r);
          }, t.save = function (e) {
            try {
              e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
            } catch (e) {}
          }, t.load = function () {
            var e;
            try {
              e = t.storage.getItem("debug");
            } catch (e) {}
            return !e && "undefined" != typeof process && "env" in process && (e = {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG), e;
          }, t.useColors = function () {
            return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type && !window.process.__nwjs) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
          }, t.storage = function () {
            try {
              return localStorage;
            } catch (e) {}
          }(), t.destroy = function () {
            var e = !1;
            return function () {
              e || (e = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
            };
          }(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || function () {}, e.exports = r(2447)(t);
          var n = e.exports.formatters;
          n.j = function (e) {
            try {
              return JSON.stringify(e);
            } catch (e) {
              return "[UnexpectedJSONParseError]: " + e.message;
            }
          };
        },
        2447: function _(e, t, r) {
          e.exports = function (e) {
            function t(e) {
              var r,
                a,
                s,
                o = null;
              function i() {
                for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
                  e[_key] = arguments[_key];
                }
                if (!i.enabled) return;
                var n = i,
                  a = Number(new Date()),
                  s = a - (r || a);
                n.diff = s, n.prev = r, n.curr = a, r = a, e[0] = t.coerce(e[0]), "string" != typeof e[0] && e.unshift("%O");
                var o = 0;
                e[0] = e[0].replace(/%([a-zA-Z%])/g, function (r, a) {
                  if ("%%" === r) return "%";
                  o++;
                  var s = t.formatters[a];
                  if ("function" == typeof s) {
                    var _t2 = e[o];
                    r = s.call(n, _t2), e.splice(o, 1), o--;
                  }
                  return r;
                }), t.formatArgs.call(n, e), (n.log || t.log).apply(n, e);
              }
              return i.namespace = e, i.useColors = t.useColors(), i.color = t.selectColor(e), i.extend = n, i.destroy = t.destroy, Object.defineProperty(i, "enabled", {
                enumerable: !0,
                configurable: !1,
                get: function get() {
                  return null !== o ? o : (a !== t.namespaces && (a = t.namespaces, s = t.enabled(e)), s);
                },
                set: function set(e) {
                  o = e;
                }
              }), "function" == typeof t.init && t.init(i), i;
            }
            function n(e, r) {
              var n = t(this.namespace + (void 0 === r ? ":" : r) + e);
              return n.log = this.log, n;
            }
            function a(e) {
              return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
            }
            return t.debug = t, t["default"] = t, t.coerce = function (e) {
              return e instanceof Error ? e.stack || e.message : e;
            }, t.disable = function () {
              var e = [].concat(_toConsumableArray(t.names.map(a)), _toConsumableArray(t.skips.map(a).map(function (e) {
                return "-" + e;
              }))).join(",");
              return t.enable(""), e;
            }, t.enable = function (e) {
              var r;
              t.save(e), t.namespaces = e, t.names = [], t.skips = [];
              var n = ("string" == typeof e ? e : "").split(/[\s,]+/),
                a = n.length;
              for (r = 0; r < a; r++) n[r] && ("-" === (e = n[r].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.slice(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
            }, t.enabled = function (e) {
              if ("*" === e[e.length - 1]) return !0;
              var r, n;
              for (r = 0, n = t.skips.length; r < n; r++) if (t.skips[r].test(e)) return !1;
              for (r = 0, n = t.names.length; r < n; r++) if (t.names[r].test(e)) return !0;
              return !1;
            }, t.humanize = r(7824), t.destroy = function () {
              console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
            }, Object.keys(e).forEach(function (r) {
              t[r] = e[r];
            }), t.names = [], t.skips = [], t.formatters = {}, t.selectColor = function (e) {
              var r = 0;
              for (var _t3 = 0; _t3 < e.length; _t3++) r = (r << 5) - r + e.charCodeAt(_t3), r |= 0;
              return t.colors[Math.abs(r) % t.colors.length];
            }, t.enable(t.load()), t;
          };
        },
        5158: function _(e, t, r) {
          "undefined" == typeof process || "renderer" === process.type || !0 === process.browser || process.__nwjs ? e.exports = r(1227) : e.exports = r(39);
        },
        39: function _(e, t, r) {
          var n = r(6224),
            a = r(3837);
          t.init = function (e) {
            e.inspectOpts = {};
            var r = Object.keys(t.inspectOpts);
            for (var _n2 = 0; _n2 < r.length; _n2++) e.inspectOpts[r[_n2]] = t.inspectOpts[r[_n2]];
          }, t.log = function () {
            return process.stderr.write(a.format.apply(a, arguments) + "\n");
          }, t.formatArgs = function (r) {
            var n = this.namespace,
              a = this.useColors;
            if (a) {
              var _t4 = this.color,
                _a2 = "[3" + (_t4 < 8 ? _t4 : "8;5;" + _t4),
                _s2 = "  ".concat(_a2, ";1m").concat(n, " \x1B[0m");
              r[0] = _s2 + r[0].split("\n").join("\n" + _s2), r.push(_a2 + "m+" + e.exports.humanize(this.diff) + "[0m");
            } else r[0] = (t.inspectOpts.hideDate ? "" : new Date().toISOString() + " ") + n + " " + r[0];
          }, t.save = function (e) {
            e || delete {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG;
          }, t.load = function () {
            return {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG;
          }, t.useColors = function () {
            return "colors" in t.inspectOpts ? Boolean(t.inspectOpts.colors) : n.isatty(process.stderr.fd);
          }, t.destroy = a.deprecate(function () {}, "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."), t.colors = [6, 2, 3, 4, 5, 1];
          try {
            var _e2 = r(2130);
            _e2 && (_e2.stderr || _e2).level >= 2 && (t.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
          } catch (e) {}
          t.inspectOpts = Object.keys({
            TARGET_ENV: "PRODUCTION"
          }).filter(function (e) {
            return /^debug_/i.test(e);
          }).reduce(function (e, t) {
            var r = t.substring(6).toLowerCase().replace(/_([a-z])/g, function (e, t) {
              return t.toUpperCase();
            });
            var n = {
              TARGET_ENV: "PRODUCTION"
            }[t];
            return n = !!/^(yes|on|true|enabled)$/i.test(n) || !/^(no|off|false|disabled)$/i.test(n) && ("null" === n ? null : Number(n)), e[r] = n, e;
          }, {}), e.exports = r(2447)(t);
          var s = e.exports.formatters;
          s.o = function (e) {
            return this.inspectOpts.colors = this.useColors, a.inspect(e, this.inspectOpts).split("\n").map(function (e) {
              return e.trim();
            }).join(" ");
          }, s.O = function (e) {
            return this.inspectOpts.colors = this.useColors, a.inspect(e, this.inspectOpts);
          };
        },
        2702: function _(e) {
          var t;
          t = function t() {
            "use strict";

            function e(e) {
              return "function" == typeof e;
            }
            var t = Array.isArray ? Array.isArray : function (e) {
                return "[object Array]" === Object.prototype.toString.call(e);
              },
              r = 0,
              n = void 0,
              a = void 0,
              s = function s(e, t) {
                p[r] = e, p[r + 1] = t, 2 === (r += 2) && (a ? a(l) : g());
              },
              o = "undefined" != typeof window ? window : void 0,
              i = o || {},
              u = i.MutationObserver || i.WebKitMutationObserver,
              c = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
              f = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
            function d() {
              var e = setTimeout;
              return function () {
                return e(l, 1);
              };
            }
            var p = new Array(1e3);
            function l() {
              for (var e = 0; e < r; e += 2) (0, p[e])(p[e + 1]), p[e] = void 0, p[e + 1] = void 0;
              r = 0;
            }
            var h,
              m,
              v,
              w,
              g = void 0;
            function y(e, t) {
              var r = this,
                n = new this.constructor(x);
              void 0 === n[k] && A(n);
              var a = r._state;
              if (a) {
                var o = arguments[a - 1];
                s(function () {
                  return N(a, n, o, r._result);
                });
              } else I(r, n, e, t);
              return n;
            }
            function b(e) {
              if (e && "object" == typeof e && e.constructor === this) return e;
              var t = new this(x);
              return S(t, e), t;
            }
            c ? g = function g() {
              return process.nextTick(l);
            } : u ? (m = 0, v = new u(l), w = document.createTextNode(""), v.observe(w, {
              characterData: !0
            }), g = function g() {
              w.data = m = ++m % 2;
            }) : f ? ((h = new MessageChannel()).port1.onmessage = l, g = function g() {
              return h.port2.postMessage(0);
            }) : g = void 0 === o ? function () {
              try {
                var e = Function("return this")().require("vertx");
                return void 0 !== (n = e.runOnLoop || e.runOnContext) ? function () {
                  n(l);
                } : d();
              } catch (e) {
                return d();
              }
            }() : d();
            var k = Math.random().toString(36).substring(2);
            function x() {}
            var T = void 0,
              E = 1,
              _ = 2;
            function C(t, r, n) {
              r.constructor === t.constructor && n === y && r.constructor.resolve === b ? function (e, t) {
                t._state === E ? D(e, t._result) : t._state === _ ? P(e, t._result) : I(t, void 0, function (t) {
                  return S(e, t);
                }, function (t) {
                  return P(e, t);
                });
              }(t, r) : void 0 === n ? D(t, r) : e(n) ? function (e, t, r) {
                s(function (e) {
                  var n = !1,
                    a = function (r, a, s, o) {
                      try {
                        r.call(a, function (r) {
                          n || (n = !0, t !== r ? S(e, r) : D(e, r));
                        }, function (t) {
                          n || (n = !0, P(e, t));
                        });
                      } catch (e) {
                        return e;
                      }
                    }(r, t, 0, 0, e._label);
                  !n && a && (n = !0, P(e, a));
                }, e);
              }(t, r, n) : D(t, r);
            }
            function S(e, t) {
              if (e === t) P(e, new TypeError("You cannot resolve a promise with itself"));else if (a = typeof (n = t), null === n || "object" !== a && "function" !== a) D(e, t);else {
                var r = void 0;
                try {
                  r = t.then;
                } catch (t) {
                  return void P(e, t);
                }
                C(e, t, r);
              }
              var n, a;
            }
            function R(e) {
              e._onerror && e._onerror(e._result), O(e);
            }
            function D(e, t) {
              e._state === T && (e._result = t, e._state = E, 0 !== e._subscribers.length && s(O, e));
            }
            function P(e, t) {
              e._state === T && (e._state = _, e._result = t, s(R, e));
            }
            function I(e, t, r, n) {
              var a = e._subscribers,
                o = a.length;
              e._onerror = null, a[o] = t, a[o + E] = r, a[o + _] = n, 0 === o && e._state && s(O, e);
            }
            function O(e) {
              var t = e._subscribers,
                r = e._state;
              if (0 !== t.length) {
                for (var n = void 0, a = void 0, s = e._result, o = 0; o < t.length; o += 3) n = t[o], a = t[o + r], n ? N(r, n, a, s) : a(s);
                e._subscribers.length = 0;
              }
            }
            function N(t, r, n, a) {
              var s = e(n),
                o = void 0,
                i = void 0,
                u = !0;
              if (s) {
                try {
                  o = n(a);
                } catch (e) {
                  u = !1, i = e;
                }
                if (r === o) return void P(r, new TypeError("A promises callback cannot return that same promise."));
              } else o = a;
              r._state !== T || (s && u ? S(r, o) : !1 === u ? P(r, i) : t === E ? D(r, o) : t === _ && P(r, o));
            }
            var q = 0;
            function A(e) {
              e[k] = q++, e._state = void 0, e._result = void 0, e._subscribers = [];
            }
            var M = function () {
                function e(e, r) {
                  this._instanceConstructor = e, this.promise = new e(x), this.promise[k] || A(this.promise), t(r) ? (this.length = r.length, this._remaining = r.length, this._result = new Array(this.length), 0 === this.length ? D(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(r), 0 === this._remaining && D(this.promise, this._result))) : P(this.promise, new Error("Array Methods must be provided an Array"));
                }
                return e.prototype._enumerate = function (e) {
                  for (var t = 0; this._state === T && t < e.length; t++) this._eachEntry(e[t], t);
                }, e.prototype._eachEntry = function (e, t) {
                  var r = this._instanceConstructor,
                    n = r.resolve;
                  if (n === b) {
                    var a = void 0,
                      s = void 0,
                      o = !1;
                    try {
                      a = e.then;
                    } catch (e) {
                      o = !0, s = e;
                    }
                    if (a === y && e._state !== T) this._settledAt(e._state, t, e._result);else if ("function" != typeof a) this._remaining--, this._result[t] = e;else if (r === U) {
                      var i = new r(x);
                      o ? P(i, s) : C(i, e, a), this._willSettleAt(i, t);
                    } else this._willSettleAt(new r(function (t) {
                      return t(e);
                    }), t);
                  } else this._willSettleAt(n(e), t);
                }, e.prototype._settledAt = function (e, t, r) {
                  var n = this.promise;
                  n._state === T && (this._remaining--, e === _ ? P(n, r) : this._result[t] = r), 0 === this._remaining && D(n, this._result);
                }, e.prototype._willSettleAt = function (e, t) {
                  var r = this;
                  I(e, void 0, function (e) {
                    return r._settledAt(E, t, e);
                  }, function (e) {
                    return r._settledAt(_, t, e);
                  });
                }, e;
              }(),
              U = function () {
                function t(e) {
                  this[k] = q++, this._result = this._state = void 0, this._subscribers = [], x !== e && ("function" != typeof e && function () {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                  }(), this instanceof t ? function (e, t) {
                    try {
                      t(function (t) {
                        S(e, t);
                      }, function (t) {
                        P(e, t);
                      });
                    } catch (t) {
                      P(e, t);
                    }
                  }(this, e) : function () {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                  }());
                }
                return t.prototype["catch"] = function (e) {
                  return this.then(null, e);
                }, t.prototype["finally"] = function (t) {
                  var r = this,
                    n = r.constructor;
                  return e(t) ? r.then(function (e) {
                    return n.resolve(t()).then(function () {
                      return e;
                    });
                  }, function (e) {
                    return n.resolve(t()).then(function () {
                      throw e;
                    });
                  }) : r.then(t, t);
                }, t;
              }();
            return U.prototype.then = y, U.all = function (e) {
              return new M(this, e).promise;
            }, U.race = function (e) {
              var r = this;
              return t(e) ? new r(function (t, n) {
                for (var a = e.length, s = 0; s < a; s++) r.resolve(e[s]).then(t, n);
              }) : new r(function (e, t) {
                return t(new TypeError("You must pass an array to race."));
              });
            }, U.resolve = b, U.reject = function (e) {
              var t = new this(x);
              return P(t, e), t;
            }, U._setScheduler = function (e) {
              a = e;
            }, U._setAsap = function (e) {
              s = e;
            }, U._asap = s, U.polyfill = function () {
              var e = void 0;
              if ("undefined" != typeof global) e = global;else if ("undefined" != typeof self) e = self;else try {
                e = Function("return this")();
              } catch (e) {
                throw new Error("polyfill failed because global object is unavailable in this environment");
              }
              var t = e.Promise;
              if (t) {
                var r = null;
                try {
                  r = Object.prototype.toString.call(t.resolve());
                } catch (e) {}
                if ("[object Promise]" === r && !t.cast) return;
              }
              e.Promise = U;
            }, U.Promise = U, U;
          }, e.exports = t();
        },
        938: function _(e, t, r) {
          var n = r(7310),
            a = r(3685),
            s = r(5687),
            o = r(9491),
            i = r(2781).Writable,
            u = r(8830)("follow-redirects"),
            c = {
              GET: !0,
              HEAD: !0,
              OPTIONS: !0,
              TRACE: !0
            },
            f = Object.create(null);
          function d(e, t) {
            i.call(this), e.headers = e.headers || {}, this._options = e, this._redirectCount = 0, this._redirects = [], this._requestBodyLength = 0, this._requestBodyBuffers = [], e.host && (e.hostname || (e.hostname = e.host), delete e.host), t && this.on("response", t);
            var r = this;
            if (this._onNativeResponse = function (e) {
              r._processResponse(e);
            }, !e.pathname && e.path) {
              var n = e.path.indexOf("?");
              n < 0 ? e.pathname = e.path : (e.pathname = e.path.substring(0, n), e.search = e.path.substring(n));
            }
            this._performRequest();
          }
          function p(e) {
            var t = {
                maxRedirects: 21,
                maxBodyLength: 10485760
              },
              r = {};
            return Object.keys(e).forEach(function (a) {
              var s = a + ":",
                i = r[s] = e[a],
                c = t[a] = Object.create(i);
              c.request = function (e, a) {
                return "string" == typeof e ? (e = n.parse(e)).maxRedirects = t.maxRedirects : e = Object.assign({
                  protocol: s,
                  maxRedirects: t.maxRedirects,
                  maxBodyLength: t.maxBodyLength
                }, e), e.nativeProtocols = r, o.equal(e.protocol, s, "protocol mismatch"), u("options", e), new d(e, a);
              }, c.get = function (e, t) {
                var r = c.request(e, t);
                return r.end(), r;
              };
            }), t;
          }
          ["abort", "aborted", "error", "socket", "timeout"].forEach(function (e) {
            f[e] = function (t) {
              this._redirectable.emit(e, t);
            };
          }), d.prototype = Object.create(i.prototype), d.prototype.write = function (e, t, r) {
            if (!("string" == typeof e || "object" == typeof e && "length" in e)) throw new Error("data should be a string, Buffer or Uint8Array");
            "function" == typeof t && (r = t, t = null), 0 !== e.length ? this._requestBodyLength + e.length <= this._options.maxBodyLength ? (this._requestBodyLength += e.length, this._requestBodyBuffers.push({
              data: e,
              encoding: t
            }), this._currentRequest.write(e, t, r)) : (this.emit("error", new Error("Request body larger than maxBodyLength limit")), this.abort()) : r && r();
          }, d.prototype.end = function (e, t, r) {
            "function" == typeof e ? (r = e, e = t = null) : "function" == typeof t && (r = t, t = null);
            var n = this._currentRequest;
            this.write(e || "", t, function () {
              n.end(null, null, r);
            });
          }, d.prototype.setHeader = function (e, t) {
            this._options.headers[e] = t, this._currentRequest.setHeader(e, t);
          }, d.prototype.removeHeader = function (e) {
            delete this._options.headers[e], this._currentRequest.removeHeader(e);
          }, ["abort", "flushHeaders", "getHeader", "setNoDelay", "setSocketKeepAlive", "setTimeout"].forEach(function (e) {
            d.prototype[e] = function (t, r) {
              return this._currentRequest[e](t, r);
            };
          }), ["aborted", "connection", "socket"].forEach(function (e) {
            Object.defineProperty(d.prototype, e, {
              get: function get() {
                return this._currentRequest[e];
              }
            });
          }), d.prototype._performRequest = function () {
            var e = this._options.protocol,
              t = this._options.nativeProtocols[e];
            if (t) {
              if (this._options.agents) {
                var r = e.substr(0, e.length - 1);
                this._options.agent = this._options.agents[r];
              }
              var a = this._currentRequest = t.request(this._options, this._onNativeResponse);
              for (var s in this._currentUrl = n.format(this._options), a._redirectable = this, f) s && a.on(s, f[s]);
              if (this._isRedirect) {
                var o = 0,
                  i = this._requestBodyBuffers;
                !function e() {
                  if (o < i.length) {
                    var t = i[o++];
                    a.write(t.data, t.encoding, e);
                  } else a.end();
                }();
              }
            } else this.emit("error", new Error("Unsupported protocol " + e));
          }, d.prototype._processResponse = function (e) {
            this._options.trackRedirects && this._redirects.push({
              url: this._currentUrl,
              headers: e.headers,
              statusCode: e.statusCode
            });
            var t = e.headers.location;
            if (t && !1 !== this._options.followRedirects && e.statusCode >= 300 && e.statusCode < 400) {
              if (++this._redirectCount > this._options.maxRedirects) return void this.emit("error", new Error("Max redirects exceeded."));
              var r,
                a = this._options.headers;
              if (307 !== e.statusCode && !(this._options.method in c)) for (r in this._options.method = "GET", this._requestBodyBuffers = [], a) /^content-/i.test(r) && delete a[r];
              if (!this._isRedirect) for (r in a) /^host$/i.test(r) && delete a[r];
              var s = n.resolve(this._currentUrl, t);
              u("redirecting to", s), Object.assign(this._options, n.parse(s)), this._isRedirect = !0, this._performRequest(), e.destroy();
            } else e.responseUrl = this._currentUrl, e.redirects = this._redirects, this.emit("response", e), this._requestBodyBuffers = [];
          }, e.exports = p({
            http: a,
            https: s
          }), e.exports.wrap = p;
        },
        7462: function _(e, t, r) {
          function n() {
            var e;
            try {
              e = t.storage.debug;
            } catch (e) {}
            return !e && "undefined" != typeof process && "env" in process && (e = {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG), e;
          }
          (t = e.exports = r(8761)).log = function () {
            return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
          }, t.formatArgs = function (e) {
            var r = this.useColors;
            if (e[0] = (r ? "%c" : "") + this.namespace + (r ? " %c" : " ") + e[0] + (r ? "%c " : " ") + "+" + t.humanize(this.diff), r) {
              var n = "color: " + this.color;
              e.splice(1, 0, n, "color: inherit");
              var a = 0,
                s = 0;
              e[0].replace(/%[a-zA-Z%]/g, function (e) {
                "%%" !== e && (a++, "%c" === e && (s = a));
              }), e.splice(s, 0, n);
            }
          }, t.save = function (e) {
            try {
              null == e ? t.storage.removeItem("debug") : t.storage.debug = e;
            } catch (e) {}
          }, t.load = n, t.useColors = function () {
            return !("undefined" == typeof window || !window.process || "renderer" !== window.process.type) || ("undefined" == typeof navigator || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && ("undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
          }, t.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
            try {
              return window.localStorage;
            } catch (e) {}
          }(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.formatters.j = function (e) {
            try {
              return JSON.stringify(e);
            } catch (e) {
              return "[UnexpectedJSONParseError]: " + e.message;
            }
          }, t.enable(n());
        },
        8761: function _(e, t, r) {
          function n(e) {
            var r;
            function n() {
              if (n.enabled) {
                var e = n,
                  a = +new Date(),
                  s = a - (r || a);
                e.diff = s, e.prev = r, e.curr = a, r = a;
                for (var o = new Array(arguments.length), i = 0; i < o.length; i++) o[i] = arguments[i];
                o[0] = t.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
                var u = 0;
                o[0] = o[0].replace(/%([a-zA-Z%])/g, function (r, n) {
                  if ("%%" === r) return r;
                  u++;
                  var a = t.formatters[n];
                  if ("function" == typeof a) {
                    var s = o[u];
                    r = a.call(e, s), o.splice(u, 1), u--;
                  }
                  return r;
                }), t.formatArgs.call(e, o), (n.log || t.log || console.log.bind(console)).apply(e, o);
              }
            }
            return n.namespace = e, n.enabled = t.enabled(e), n.useColors = t.useColors(), n.color = function (e) {
              var r,
                n = 0;
              for (r in e) n = (n << 5) - n + e.charCodeAt(r), n |= 0;
              return t.colors[Math.abs(n) % t.colors.length];
            }(e), n.destroy = a, "function" == typeof t.init && t.init(n), t.instances.push(n), n;
          }
          function a() {
            var e = t.instances.indexOf(this);
            return -1 !== e && (t.instances.splice(e, 1), !0);
          }
          (t = e.exports = n.debug = n["default"] = n).coerce = function (e) {
            return e instanceof Error ? e.stack || e.message : e;
          }, t.disable = function () {
            t.enable("");
          }, t.enable = function (e) {
            var r;
            t.save(e), t.names = [], t.skips = [];
            var n = ("string" == typeof e ? e : "").split(/[\s,]+/),
              a = n.length;
            for (r = 0; r < a; r++) n[r] && ("-" === (e = n[r].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.substr(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
            for (r = 0; r < t.instances.length; r++) {
              var s = t.instances[r];
              s.enabled = t.enabled(s.namespace);
            }
          }, t.enabled = function (e) {
            if ("*" === e[e.length - 1]) return !0;
            var r, n;
            for (r = 0, n = t.skips.length; r < n; r++) if (t.skips[r].test(e)) return !1;
            for (r = 0, n = t.names.length; r < n; r++) if (t.names[r].test(e)) return !0;
            return !1;
          }, t.humanize = r(6898), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
        },
        8830: function _(e, t, r) {
          "undefined" == typeof process || "renderer" === process.type ? e.exports = r(7462) : e.exports = r(5287);
        },
        5287: function _(e, t, r) {
          var n = r(6224),
            a = r(3837);
          (t = e.exports = r(8761)).init = function (e) {
            e.inspectOpts = {};
            for (var r = Object.keys(t.inspectOpts), n = 0; n < r.length; n++) e.inspectOpts[r[n]] = t.inspectOpts[r[n]];
          }, t.log = function () {
            return process.stderr.write(a.format.apply(a, arguments) + "\n");
          }, t.formatArgs = function (e) {
            var r = this.namespace;
            if (this.useColors) {
              var n = this.color,
                a = "[3" + (n < 8 ? n : "8;5;" + n),
                s = "  " + a + ";1m" + r + " [0m";
              e[0] = s + e[0].split("\n").join("\n" + s), e.push(a + "m+" + t.humanize(this.diff) + "[0m");
            } else e[0] = (t.inspectOpts.hideDate ? "" : new Date().toISOString() + " ") + r + " " + e[0];
          }, t.save = function (e) {
            null == e && delete {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG;
          }, t.load = o, t.useColors = function () {
            return "colors" in t.inspectOpts ? Boolean(t.inspectOpts.colors) : n.isatty(process.stderr.fd);
          }, t.colors = [6, 2, 3, 4, 5, 1];
          try {
            var s = r(2130);
            s && s.level >= 2 && (t.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221]);
          } catch (e) {}
          function o() {
            return {
              TARGET_ENV: "PRODUCTION"
            }.DEBUG;
          }
          t.inspectOpts = Object.keys({
            TARGET_ENV: "PRODUCTION"
          }).filter(function (e) {
            return /^debug_/i.test(e);
          }).reduce(function (e, t) {
            var r = t.substring(6).toLowerCase().replace(/_([a-z])/g, function (e, t) {
                return t.toUpperCase();
              }),
              n = {
                TARGET_ENV: "PRODUCTION"
              }[t];
            return n = !!/^(yes|on|true|enabled)$/i.test(n) || !/^(no|off|false|disabled)$/i.test(n) && ("null" === n ? null : Number(n)), e[r] = n, e;
          }, {}), t.formatters.o = function (e) {
            return this.inspectOpts.colors = this.useColors, a.inspect(e, this.inspectOpts).split("\n").map(function (e) {
              return e.trim();
            }).join(" ");
          }, t.formatters.O = function (e) {
            return this.inspectOpts.colors = this.useColors, a.inspect(e, this.inspectOpts);
          }, t.enable(o());
        },
        6898: function _(e) {
          var t = 1e3,
            r = 60 * t,
            n = 60 * r,
            a = 24 * n;
          function s(e, t, r) {
            if (!(e < t)) return e < 1.5 * t ? Math.floor(e / t) + " " + r : Math.ceil(e / t) + " " + r + "s";
          }
          e.exports = function (e, o) {
            o = o || {};
            var i,
              u = typeof e;
            if ("string" === u && e.length > 0) return function (e) {
              if (!((e = String(e)).length > 100)) {
                var s = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);
                if (s) {
                  var o = parseFloat(s[1]);
                  switch ((s[2] || "ms").toLowerCase()) {
                    case "years":
                    case "year":
                    case "yrs":
                    case "yr":
                    case "y":
                      return 315576e5 * o;
                    case "days":
                    case "day":
                    case "d":
                      return o * a;
                    case "hours":
                    case "hour":
                    case "hrs":
                    case "hr":
                    case "h":
                      return o * n;
                    case "minutes":
                    case "minute":
                    case "mins":
                    case "min":
                    case "m":
                      return o * r;
                    case "seconds":
                    case "second":
                    case "secs":
                    case "sec":
                    case "s":
                      return o * t;
                    case "milliseconds":
                    case "millisecond":
                    case "msecs":
                    case "msec":
                    case "ms":
                      return o;
                    default:
                      return;
                  }
                }
              }
            }(e);
            if ("number" === u && !1 === isNaN(e)) return o["long"] ? s(i = e, a, "day") || s(i, n, "hour") || s(i, r, "minute") || s(i, t, "second") || i + " ms" : function (e) {
              return e >= a ? Math.round(e / a) + "d" : e >= n ? Math.round(e / n) + "h" : e >= r ? Math.round(e / r) + "m" : e >= t ? Math.round(e / t) + "s" : e + "ms";
            }(e);
            throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
          };
        },
        6560: function _(e) {
          "use strict";

          e.exports = function (e, t) {
            t = t || process.argv;
            var r = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
              n = t.indexOf(r + e),
              a = t.indexOf("--");
            return -1 !== n && (-1 === a || n < a);
          };
        },
        3704: function _(e, t, r) {
          var n, a, s, o, i;
          o = this, i = function i(e) {
            var t = !1,
              r = !1,
              n = !1,
              a = !1,
              s = "escape years months weeks days hours minutes seconds milliseconds general".split(" "),
              o = [{
                type: "seconds",
                targets: [{
                  type: "minutes",
                  value: 60
                }, {
                  type: "hours",
                  value: 3600
                }, {
                  type: "days",
                  value: 86400
                }, {
                  type: "weeks",
                  value: 604800
                }, {
                  type: "months",
                  value: 2678400
                }, {
                  type: "years",
                  value: 31536e3
                }]
              }, {
                type: "minutes",
                targets: [{
                  type: "hours",
                  value: 60
                }, {
                  type: "days",
                  value: 1440
                }, {
                  type: "weeks",
                  value: 10080
                }, {
                  type: "months",
                  value: 44640
                }, {
                  type: "years",
                  value: 525600
                }]
              }, {
                type: "hours",
                targets: [{
                  type: "days",
                  value: 24
                }, {
                  type: "weeks",
                  value: 168
                }, {
                  type: "months",
                  value: 744
                }, {
                  type: "years",
                  value: 8760
                }]
              }, {
                type: "days",
                targets: [{
                  type: "weeks",
                  value: 7
                }, {
                  type: "months",
                  value: 31
                }, {
                  type: "years",
                  value: 365
                }]
              }, {
                type: "months",
                targets: [{
                  type: "years",
                  value: 12
                }]
              }];
            function i(e, t) {
              return !(t.length > e.length) && -1 !== e.indexOf(t);
            }
            function u(e) {
              for (var t = ""; e;) t += "0", e -= 1;
              return t;
            }
            function c(e, t) {
              var r = e + "+" + w(E(t).sort(), function (e) {
                return e + ":" + t[e];
              }).join(",");
              return c.cache[r] || (c.cache[r] = Intl.NumberFormat(e, t)), c.cache[r];
            }
            function f(e, t, s) {
              var o,
                i,
                d,
                p = t.useToLocaleString,
                l = t.useGrouping,
                h = l && t.grouping.slice(),
                m = t.maximumSignificantDigits,
                v = t.minimumIntegerDigits || 1,
                w = t.fractionDigits || 0,
                g = t.groupingSeparator,
                y = t.decimalSeparator;
              if (p && s) {
                var b,
                  k = {
                    minimumIntegerDigits: v,
                    useGrouping: l
                  };
                return w && (k.maximumFractionDigits = w, k.minimumFractionDigits = w), m && e > 0 && (k.maximumSignificantDigits = m), n ? (a || ((b = T({}, t)).useGrouping = !1, b.decimalSeparator = ".", e = parseFloat(f(e, b), 10)), c(s, k).format(e)) : (r || ((b = T({}, t)).useGrouping = !1, b.decimalSeparator = ".", e = parseFloat(f(e, b), 10)), e.toLocaleString(s, k));
              }
              var x = (m ? e.toPrecision(m + 1) : e.toFixed(w + 1)).split("e");
              d = x[1] || "", i = (x = x[0].split("."))[1] || "";
              var E = (o = x[0] || "").length,
                _ = i.length,
                C = E + _,
                S = o + i;
              (m && C === m + 1 || !m && _ === w + 1) && ((S = function (e) {
                for (var t = e.split("").reverse(), r = 0, n = !0; n && r < t.length;) r ? "9" === t[r] ? t[r] = "0" : (t[r] = (parseInt(t[r], 10) + 1).toString(), n = !1) : (parseInt(t[r], 10) < 5 && (n = !1), t[r] = "0"), r += 1;
                return n && t.push("1"), t.reverse().join("");
              }(S)).length === C + 1 && (E += 1), _ && (S = S.slice(0, -1)), o = S.slice(0, E), i = S.slice(E)), m && (i = i.replace(/0*$/, ""));
              var R = parseInt(d, 10);
              R > 0 ? i.length <= R ? (o += i += u(R - i.length), i = "") : (o += i.slice(0, R), i = i.slice(R)) : R < 0 && (i = u(Math.abs(R) - o.length) + o + i, o = "0"), m || ((i = i.slice(0, w)).length < w && (i += u(w - i.length)), o.length < v && (o = u(v - o.length) + o));
              var D,
                P = "";
              if (l) for (x = o; x.length;) h.length && (D = h.shift()), P && (P = g + P), P = x.slice(-D) + P, x = x.slice(0, -D);else P = o;
              return i && (P = P + y + i), P;
            }
            function d(e, t) {
              return e.label.length > t.label.length ? -1 : e.label.length < t.label.length ? 1 : 0;
            }
            c.cache = {};
            var p = {
              durationLabelsStandard: {
                S: "millisecond",
                SS: "milliseconds",
                s: "second",
                ss: "seconds",
                m: "minute",
                mm: "minutes",
                h: "hour",
                hh: "hours",
                d: "day",
                dd: "days",
                w: "week",
                ww: "weeks",
                M: "month",
                MM: "months",
                y: "year",
                yy: "years"
              },
              durationLabelsShort: {
                S: "msec",
                SS: "msecs",
                s: "sec",
                ss: "secs",
                m: "min",
                mm: "mins",
                h: "hr",
                hh: "hrs",
                d: "dy",
                dd: "dys",
                w: "wk",
                ww: "wks",
                M: "mo",
                MM: "mos",
                y: "yr",
                yy: "yrs"
              },
              durationTimeTemplates: {
                HMS: "h:mm:ss",
                HM: "h:mm",
                MS: "m:ss"
              },
              durationLabelTypes: [{
                type: "standard",
                string: "__"
              }, {
                type: "short",
                string: "_"
              }],
              durationPluralKey: function durationPluralKey(e, t, r) {
                return 1 === t && null === r ? e : e + e;
              }
            };
            function l(e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            }
            function h(e) {
              return "[object Object]" === Object.prototype.toString.call(e);
            }
            function m(e, t) {
              var r,
                n = 0,
                a = e && e.length || 0;
              for ("function" != typeof t && (r = t, t = function t(e) {
                return e === r;
              }); n < a;) {
                if (t(e[n])) return e[n];
                n += 1;
              }
            }
            function v(e, t) {
              var r = 0,
                n = e.length;
              if (e && n) for (; r < n;) {
                if (!1 === t(e[r], r)) return;
                r += 1;
              }
            }
            function w(e, t) {
              var r = 0,
                n = e.length,
                a = [];
              if (!e || !n) return a;
              for (; r < n;) a[r] = t(e[r], r), r += 1;
              return a;
            }
            function g(e, t) {
              return w(e, function (e) {
                return e[t];
              });
            }
            function y(e) {
              var t = [];
              return v(e, function (e) {
                e && t.push(e);
              }), t;
            }
            function b(e) {
              var t = [];
              return v(e, function (e) {
                m(t, e) || t.push(e);
              }), t;
            }
            function k(e, t) {
              var r = [];
              return v(e, function (e) {
                v(t, function (t) {
                  e === t && r.push(e);
                });
              }), b(r);
            }
            function x(e, t) {
              var r = [];
              return v(e, function (n, a) {
                if (!t(n)) return r = e.slice(a), !1;
              }), r;
            }
            function T(e, t) {
              for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
              return e;
            }
            function E(e) {
              var t = [];
              for (var r in e) e.hasOwnProperty(r) && t.push(r);
              return t;
            }
            function _(e, t) {
              var r = 0,
                n = e.length;
              if (!e || !n) return !1;
              for (; r < n;) {
                if (!0 === t(e[r], r)) return !0;
                r += 1;
              }
              return !1;
            }
            function C(e) {
              return "3.6" === e(3.55, "en", {
                useGrouping: !1,
                minimumIntegerDigits: 1,
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              });
            }
            function S(e) {
              var t = !0;
              return !!((t = (t = (t = t && "1" === e(1, "en", {
                minimumIntegerDigits: 1
              })) && "01" === e(1, "en", {
                minimumIntegerDigits: 2
              })) && "001" === e(1, "en", {
                minimumIntegerDigits: 3
              })) && (t = (t = (t = (t = t && "100" === e(99.99, "en", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
              })) && "100.0" === e(99.99, "en", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
              })) && "99.99" === e(99.99, "en", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })) && "99.990" === e(99.99, "en", {
                maximumFractionDigits: 3,
                minimumFractionDigits: 3
              })) && (t = (t = (t = (t = (t = t && "100" === e(99.99, "en", {
                maximumSignificantDigits: 1
              })) && "100" === e(99.99, "en", {
                maximumSignificantDigits: 2
              })) && "100" === e(99.99, "en", {
                maximumSignificantDigits: 3
              })) && "99.99" === e(99.99, "en", {
                maximumSignificantDigits: 4
              })) && "99.99" === e(99.99, "en", {
                maximumSignificantDigits: 5
              })) && (t = (t = t && "1,000" === e(1e3, "en", {
                useGrouping: !0
              })) && "1000" === e(1e3, "en", {
                useGrouping: !1
              })));
            }
            function R() {
              var e,
                t = [].slice.call(arguments),
                r = {};
              if (v(t, function (t, n) {
                if (!n) {
                  if (!l(t)) throw "Expected array as the first argument to durationsFormat.";
                  e = t;
                }
                "string" != typeof t && "function" != typeof t ? "number" != typeof t ? h(t) && T(r, t) : r.precision = t : r.template = t;
              }), !e || !e.length) return [];
              r.returnMomentTypes = !0;
              var n,
                a = w(e, function (e) {
                  return e.format(r);
                }),
                o = k(s, b(g((n = [], v(a, function (e) {
                  n = n.concat(e);
                }), n), "type"))),
                i = r.largest;
              return i && (o = o.slice(0, i)), r.returnMomentTypes = !1, r.outputTypes = o, w(e, function (e) {
                return e.format(r);
              });
            }
            function D() {
              var r = [].slice.call(arguments),
                a = T({}, this.format.defaults),
                u = this.asMilliseconds(),
                c = this.asMonths();
              "function" == typeof this.isValid && !1 === this.isValid() && (u = 0, c = 0);
              var C = u < 0,
                S = e.duration(Math.abs(u), "milliseconds"),
                R = e.duration(Math.abs(c), "months");
              v(r, function (e) {
                "string" != typeof e && "function" != typeof e ? "number" != typeof e ? h(e) && T(a, e) : a.precision = e : a.template = e;
              });
              var D = {
                  years: "y",
                  months: "M",
                  weeks: "w",
                  days: "d",
                  hours: "h",
                  minutes: "m",
                  seconds: "s",
                  milliseconds: "S"
                },
                P = {
                  escape: /\[(.+?)\]/,
                  years: /\*?[Yy]+/,
                  months: /\*?M+/,
                  weeks: /\*?[Ww]+/,
                  days: /\*?[Dd]+/,
                  hours: /\*?[Hh]+/,
                  minutes: /\*?m+/,
                  seconds: /\*?s+/,
                  milliseconds: /\*?S+/,
                  general: /.+?/
                };
              a.types = s;
              var I = function I(e) {
                  return m(s, function (t) {
                    return P[t].test(e);
                  });
                },
                O = new RegExp(w(s, function (e) {
                  return P[e].source;
                }).join("|"), "g");
              a.duration = this;
              var N = "function" == typeof a.template ? a.template.apply(a) : a.template,
                q = a.outputTypes,
                A = a.returnMomentTypes,
                M = a.largest,
                U = [];
              q || (l(a.stopTrim) && (a.stopTrim = a.stopTrim.join("")), a.stopTrim && v(a.stopTrim.match(O), function (e) {
                var t = I(e);
                "escape" !== t && "general" !== t && U.push(t);
              }));
              var L = e.localeData();
              L || (L = {}), v(E(p), function (e) {
                "function" != typeof p[e] ? L["_" + e] || (L["_" + e] = p[e]) : L[e] || (L[e] = p[e]);
              }), v(E(L._durationTimeTemplates), function (e) {
                N = N.replace("_" + e + "_", L._durationTimeTemplates[e]);
              });
              var F = a.userLocale || e.locale(),
                B = a.useLeftUnits,
                V = a.usePlural,
                G = a.precision,
                Y = a.forceLength,
                j = a.useGrouping,
                H = a.trunc,
                W = a.useSignificantDigits && G > 0,
                z = W ? a.precision : 0,
                $ = z,
                Z = a.minValue,
                J = !1,
                X = a.maxValue,
                K = !1,
                Q = a.useToLocaleString,
                ee = a.groupingSeparator,
                te = a.decimalSeparator,
                re = a.grouping;
              Q = Q && (t || n);
              var ne = a.trim;
              l(ne) && (ne = ne.join(" ")), null === ne && (M || X || W) && (ne = "all"), null !== ne && !0 !== ne && "left" !== ne && "right" !== ne || (ne = "large"), !1 === ne && (ne = "");
              var ae = function ae(e) {
                  return e.test(ne);
                },
                se = /both/,
                oe = /^all|[^sm]all/,
                ie = M > 0 || _([/large/, se, oe], ae),
                ue = _([/small/, se, oe], ae),
                ce = _([/mid/, oe], ae),
                fe = _([/final/, oe], ae),
                de = w(N.match(O), function (e, t) {
                  var r = I(e);
                  return "*" === e.slice(0, 1) && (e = e.slice(1), "escape" !== r && "general" !== r && U.push(r)), {
                    index: t,
                    length: e.length,
                    text: "",
                    token: "escape" === r ? e.replace(P.escape, "$1") : e,
                    type: "escape" === r || "general" === r ? null : r
                  };
                }),
                pe = {
                  index: 0,
                  length: 0,
                  token: "",
                  text: "",
                  type: null
                },
                le = [];
              B && de.reverse(), v(de, function (e) {
                if (e.type) return (pe.type || pe.text) && le.push(pe), void (pe = e);
                B ? pe.text = e.token + pe.text : pe.text += e.token;
              }), (pe.type || pe.text) && le.push(pe), B && le.reverse();
              var he = k(s, b(y(g(le, "type"))));
              if (!he.length) return g(le, "text").join("");
              he = w(he, function (e, t) {
                var r,
                  n = t + 1 === he.length,
                  s = !t;
                r = "years" === e || "months" === e ? R.as(e) : S.as(e);
                var o = Math.floor(r),
                  i = r - o,
                  u = m(le, function (t) {
                    return e === t.type;
                  });
                return s && X && r > X && (K = !0), n && Z && Math.abs(a.duration.as(e)) < Z && (J = !0), s && null === Y && u.length > 1 && (Y = !0), S.subtract(o, e), R.subtract(o, e), {
                  rawValue: r,
                  wholeValue: o,
                  decimalValue: n ? i : 0,
                  isSmallest: n,
                  isLargest: s,
                  type: e,
                  tokenLength: u.length
                };
              });
              var me,
                ve = H ? Math.floor : Math.round,
                we = function we(e, t) {
                  var r = Math.pow(10, t);
                  return ve(e * r) / r;
                },
                ge = !1,
                ye = !1,
                be = function be(e, t) {
                  var r = {
                    useGrouping: j,
                    groupingSeparator: ee,
                    decimalSeparator: te,
                    grouping: re,
                    useToLocaleString: Q
                  };
                  return W && (z <= 0 ? (e.rawValue = 0, e.wholeValue = 0, e.decimalValue = 0) : (r.maximumSignificantDigits = z, e.significantDigits = z)), K && !ye && (e.isLargest ? (e.wholeValue = X, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), J && !ye && (e.isSmallest ? (e.wholeValue = Z, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), e.isSmallest || e.significantDigits && e.significantDigits - e.wholeValue.toString().length <= 0 ? G < 0 ? e.value = we(e.wholeValue, G) : 0 === G ? e.value = ve(e.wholeValue + e.decimalValue) : W ? (e.value = H ? we(e.rawValue, z - e.wholeValue.toString().length) : e.rawValue, e.wholeValue && (z -= e.wholeValue.toString().length)) : (r.fractionDigits = G, e.value = H ? e.wholeValue + we(e.decimalValue, G) : e.wholeValue + e.decimalValue) : W && e.wholeValue ? (e.value = Math.round(we(e.wholeValue, e.significantDigits - e.wholeValue.toString().length)), z -= e.wholeValue.toString().length) : e.value = e.wholeValue, e.tokenLength > 1 && (Y || ge) && (r.minimumIntegerDigits = e.tokenLength, ye && r.maximumSignificantDigits < e.tokenLength && delete r.maximumSignificantDigits), !ge && (e.value > 0 || "" === ne || m(U, e.type) || m(q, e.type)) && (ge = !0), e.formattedValue = f(e.value, r, F), r.useGrouping = !1, r.decimalSeparator = ".", e.formattedValueEn = f(e.value, r, "en"), 2 === e.tokenLength && "milliseconds" === e.type && (e.formattedValueMS = f(e.value, {
                    minimumIntegerDigits: 3,
                    useGrouping: !1
                  }, "en").slice(0, 2)), e;
                };
              if ((he = y(he = w(he, be))).length > 1) {
                var ke = function ke(e) {
                  return m(he, function (t) {
                    return t.type === e;
                  });
                };
                v(o, function (e) {
                  var t = ke(e.type);
                  t && v(e.targets, function (e) {
                    var r = ke(e.type);
                    r && parseInt(t.formattedValueEn, 10) === e.value && (t.rawValue = 0, t.wholeValue = 0, t.decimalValue = 0, r.rawValue += 1, r.wholeValue += 1, r.decimalValue = 0, r.formattedValueEn = r.wholeValue.toString(), ye = !0);
                  });
                });
              }
              return ye && (ge = !1, z = $, he = y(he = w(he, be))), !q || K && !a.trim ? (ie && (he = x(he, function (e) {
                return !e.isSmallest && !e.wholeValue && !m(U, e.type);
              })), M && he.length && (he = he.slice(0, M)), ue && he.length > 1 && (me = function me(e) {
                return !e.wholeValue && !m(U, e.type) && !e.isLargest;
              }, he = x(he.slice().reverse(), me).reverse()), ce && (he = y(he = w(he, function (e, t) {
                return t > 0 && t < he.length - 1 && !e.wholeValue ? null : e;
              }))), !fe || 1 !== he.length || he[0].wholeValue || !H && he[0].isSmallest && he[0].rawValue < Z || (he = [])) : he = y(he = w(he, function (e) {
                return m(q, function (t) {
                  return e.type === t;
                }) ? e : null;
              })), A ? he : (v(le, function (e) {
                var t = D[e.type],
                  r = m(he, function (t) {
                    return t.type === e.type;
                  });
                if (t && r) {
                  var n = r.formattedValueEn.split(".");
                  n[0] = parseInt(n[0], 10), n[1] ? n[1] = parseFloat("0." + n[1], 10) : n[1] = null;
                  var a = L.durationPluralKey(t, n[0], n[1]),
                    s = function (e, t) {
                      var r = [];
                      return v(E(t), function (n) {
                        if ("_durationLabels" === n.slice(0, 15)) {
                          var a = n.slice(15).toLowerCase();
                          v(E(t[n]), function (s) {
                            s.slice(0, 1) === e && r.push({
                              type: a,
                              key: s,
                              label: t[n][s]
                            });
                          });
                        }
                      }), r;
                    }(t, L),
                    o = !1,
                    u = {};
                  v(L._durationLabelTypes, function (t) {
                    var r = m(s, function (e) {
                      return e.type === t.type && e.key === a;
                    });
                    r && (u[r.type] = r.label, i(e.text, t.string) && (e.text = e.text.replace(t.string, r.label), o = !0));
                  }), V && !o && (s.sort(d), v(s, function (t) {
                    return u[t.type] === t.label ? !i(e.text, t.label) && void 0 : i(e.text, t.label) ? (e.text = e.text.replace(t.label, u[t.type]), !1) : void 0;
                  }));
                }
              }), (le = w(le, function (e) {
                if (!e.type) return e.text;
                var t = m(he, function (t) {
                  return t.type === e.type;
                });
                if (!t) return "";
                var r = "";
                return B && (r += e.text), (C && K || !C && J) && (r += "< ", K = !1, J = !1), (C && J || !C && K) && (r += "> ", K = !1, J = !1), C && (t.value > 0 || "" === ne || m(U, t.type) || m(q, t.type)) && (r += "-", C = !1), "milliseconds" === e.type && t.formattedValueMS ? r += t.formattedValueMS : r += t.formattedValue, B || (r += e.text), r;
              })).join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, ""));
            }
            function P() {
              var e = this.duration,
                t = function t(_t5) {
                  return e._data[_t5];
                },
                r = m(this.types, t),
                n = function (e, t) {
                  for (var r = e.length; r -= 1;) if (t(e[r])) return e[r];
                }(this.types, t);
              switch (r) {
                case "milliseconds":
                  return "S __";
                case "seconds":
                case "minutes":
                  return "*_MS_";
                case "hours":
                  return "_HMS_";
                case "days":
                  if (r === n) return "d __";
                case "weeks":
                  return r === n ? "w __" : (null === this.trim && (this.trim = "both"), "w __, d __, h __");
                case "months":
                  if (r === n) return "M __";
                case "years":
                  return r === n ? "y __" : (null === this.trim && (this.trim = "both"), "y __, M __, d __");
                default:
                  return null === this.trim && (this.trim = "both"), "y __, d __, h __, m __, s __";
              }
            }
            function I(e) {
              if (!e) throw "Moment Duration Format init cannot find moment instance.";
              e.duration.format = R, e.duration.fn.format = D, e.duration.fn.format.defaults = {
                trim: null,
                stopTrim: null,
                largest: null,
                maxValue: null,
                minValue: null,
                precision: 0,
                trunc: !1,
                forceLength: null,
                userLocale: null,
                usePlural: !0,
                useLeftUnits: !1,
                useGrouping: !0,
                useSignificantDigits: !1,
                template: P,
                useToLocaleString: !0,
                groupingSeparator: ",",
                decimalSeparator: ".",
                grouping: [3]
              }, e.updateLocale("en", p);
            }
            var O = function O(e, t, r) {
              return e.toLocaleString(t, r);
            };
            t = function () {
              try {
                0 .toLocaleString("i");
              } catch (e) {
                return "RangeError" === e.name;
              }
              return !1;
            }() && S(O), r = t && C(O);
            var N = function N(e, t, r) {
              if ("undefined" != typeof window && window && window.Intl && window.Intl.NumberFormat) return window.Intl.NumberFormat(t, r).format(e);
            };
            return n = S(N), a = n && C(N), I(e), I;
          }, a = [r(381)], void 0 === (s = "function" == typeof (n = i) ? n.apply(t, a) : n) || (e.exports = s), o && (o.momentDurationFormatSetup = o.moment ? i(o.moment) : i);
        },
        381: function _(e, t, r) {
          (e = r.nmd(e)).exports = function () {
            "use strict";

            var t, r;
            function n() {
              return t.apply(null, arguments);
            }
            function a(e) {
              return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
            }
            function s(e) {
              return null != e && "[object Object]" === Object.prototype.toString.call(e);
            }
            function o(e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }
            function i(e) {
              if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
              var t;
              for (t in e) if (o(e, t)) return !1;
              return !0;
            }
            function u(e) {
              return void 0 === e;
            }
            function c(e) {
              return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
            }
            function f(e) {
              return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
            }
            function d(e, t) {
              var r,
                n = [],
                a = e.length;
              for (r = 0; r < a; ++r) n.push(t(e[r], r));
              return n;
            }
            function p(e, t) {
              for (var r in t) o(t, r) && (e[r] = t[r]);
              return o(t, "toString") && (e.toString = t.toString), o(t, "valueOf") && (e.valueOf = t.valueOf), e;
            }
            function l(e, t, r, n) {
              return Nt(e, t, r, n, !0).utc();
            }
            function h(e) {
              return null == e._pf && (e._pf = {
                empty: !1,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: !1,
                invalidEra: null,
                invalidMonth: null,
                invalidFormat: !1,
                userInvalidated: !1,
                iso: !1,
                parsedDateParts: [],
                era: null,
                meridiem: null,
                rfc2822: !1,
                weekdayMismatch: !1
              }), e._pf;
            }
            function m(e) {
              if (null == e._isValid) {
                var t = h(e),
                  n = r.call(t.parsedDateParts, function (e) {
                    return null != e;
                  }),
                  a = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
                if (e._strict && (a = a && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return a;
                e._isValid = a;
              }
              return e._isValid;
            }
            function v(e) {
              var t = l(NaN);
              return null != e ? p(h(t), e) : h(t).userInvalidated = !0, t;
            }
            r = Array.prototype.some ? Array.prototype.some : function (e) {
              var t,
                r = Object(this),
                n = r.length >>> 0;
              for (t = 0; t < n; t++) if (t in r && e.call(this, r[t], t, r)) return !0;
              return !1;
            };
            var w = n.momentProperties = [],
              g = !1;
            function y(e, t) {
              var r,
                n,
                a,
                s = w.length;
              if (u(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), u(t._i) || (e._i = t._i), u(t._f) || (e._f = t._f), u(t._l) || (e._l = t._l), u(t._strict) || (e._strict = t._strict), u(t._tzm) || (e._tzm = t._tzm), u(t._isUTC) || (e._isUTC = t._isUTC), u(t._offset) || (e._offset = t._offset), u(t._pf) || (e._pf = h(t)), u(t._locale) || (e._locale = t._locale), s > 0) for (r = 0; r < s; r++) u(a = t[n = w[r]]) || (e[n] = a);
              return e;
            }
            function b(e) {
              y(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === g && (g = !0, n.updateOffset(this), g = !1);
            }
            function k(e) {
              return e instanceof b || null != e && null != e._isAMomentObject;
            }
            function x(e) {
              !1 === n.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
            }
            function T(e, t) {
              var r = !0;
              return p(function () {
                if (null != n.deprecationHandler && n.deprecationHandler(null, e), r) {
                  var a,
                    s,
                    i,
                    u = [],
                    c = arguments.length;
                  for (s = 0; s < c; s++) {
                    if (a = "", "object" == typeof arguments[s]) {
                      for (i in a += "\n[" + s + "] ", arguments[0]) o(arguments[0], i) && (a += i + ": " + arguments[0][i] + ", ");
                      a = a.slice(0, -2);
                    } else a = arguments[s];
                    u.push(a);
                  }
                  x(e + "\nArguments: " + Array.prototype.slice.call(u).join("") + "\n" + new Error().stack), r = !1;
                }
                return t.apply(this, arguments);
              }, t);
            }
            var E,
              _ = {};
            function C(e, t) {
              null != n.deprecationHandler && n.deprecationHandler(e, t), _[e] || (x(t), _[e] = !0);
            }
            function S(e) {
              return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
            }
            function R(e, t) {
              var r,
                n = p({}, e);
              for (r in t) o(t, r) && (s(e[r]) && s(t[r]) ? (n[r] = {}, p(n[r], e[r]), p(n[r], t[r])) : null != t[r] ? n[r] = t[r] : delete n[r]);
              for (r in e) o(e, r) && !o(t, r) && s(e[r]) && (n[r] = p({}, n[r]));
              return n;
            }
            function D(e) {
              null != e && this.set(e);
            }
            n.suppressDeprecationWarnings = !1, n.deprecationHandler = null, E = Object.keys ? Object.keys : function (e) {
              var t,
                r = [];
              for (t in e) o(e, t) && r.push(t);
              return r;
            };
            function P(e, t, r) {
              var n = "" + Math.abs(e),
                a = t - n.length;
              return (e >= 0 ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + n;
            }
            var I = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
              O = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
              N = {},
              q = {};
            function A(e, t, r, n) {
              var a = n;
              "string" == typeof n && (a = function a() {
                return this[n]();
              }), e && (q[e] = a), t && (q[t[0]] = function () {
                return P(a.apply(this, arguments), t[1], t[2]);
              }), r && (q[r] = function () {
                return this.localeData().ordinal(a.apply(this, arguments), e);
              });
            }
            function M(e, t) {
              return e.isValid() ? (t = U(t, e.localeData()), N[t] = N[t] || function (e) {
                var t,
                  r,
                  n,
                  a = e.match(I);
                for (t = 0, r = a.length; t < r; t++) q[a[t]] ? a[t] = q[a[t]] : a[t] = (n = a[t]).match(/\[[\s\S]/) ? n.replace(/^\[|\]$/g, "") : n.replace(/\\/g, "");
                return function (t) {
                  var n,
                    s = "";
                  for (n = 0; n < r; n++) s += S(a[n]) ? a[n].call(t, e) : a[n];
                  return s;
                };
              }(t), N[t](e)) : e.localeData().invalidDate();
            }
            function U(e, t) {
              var r = 5;
              function n(e) {
                return t.longDateFormat(e) || e;
              }
              for (O.lastIndex = 0; r >= 0 && O.test(e);) e = e.replace(O, n), O.lastIndex = 0, r -= 1;
              return e;
            }
            var L = {};
            function F(e, t) {
              var r = e.toLowerCase();
              L[r] = L[r + "s"] = L[t] = e;
            }
            function B(e) {
              return "string" == typeof e ? L[e] || L[e.toLowerCase()] : void 0;
            }
            function V(e) {
              var t,
                r,
                n = {};
              for (r in e) o(e, r) && (t = B(r)) && (n[t] = e[r]);
              return n;
            }
            var G = {};
            function Y(e, t) {
              G[e] = t;
            }
            function j(e) {
              return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
            }
            function H(e) {
              return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
            }
            function W(e) {
              var t = +e,
                r = 0;
              return 0 !== t && isFinite(t) && (r = H(t)), r;
            }
            function z(e, t) {
              return function (r) {
                return null != r ? (Z(this, e, r), n.updateOffset(this, t), this) : $(this, e);
              };
            }
            function $(e, t) {
              return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
            }
            function Z(e, t, r) {
              e.isValid() && !isNaN(r) && ("FullYear" === t && j(e.year()) && 1 === e.month() && 29 === e.date() ? (r = W(r), e._d["set" + (e._isUTC ? "UTC" : "") + t](r, e.month(), Pe(r, e.month()))) : e._d["set" + (e._isUTC ? "UTC" : "") + t](r));
            }
            var J,
              X = /\d/,
              K = /\d\d/,
              Q = /\d{3}/,
              ee = /\d{4}/,
              te = /[+-]?\d{6}/,
              re = /\d\d?/,
              ne = /\d\d\d\d?/,
              ae = /\d\d\d\d\d\d?/,
              se = /\d{1,3}/,
              oe = /\d{1,4}/,
              ie = /[+-]?\d{1,6}/,
              ue = /\d+/,
              ce = /[+-]?\d+/,
              fe = /Z|[+-]\d\d:?\d\d/gi,
              de = /Z|[+-]\d\d(?::?\d\d)?/gi,
              pe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
            function le(e, t, r) {
              J[e] = S(t) ? t : function (e, n) {
                return e && r ? r : t;
              };
            }
            function he(e, t) {
              return o(J, e) ? J[e](t._strict, t._locale) : new RegExp(me(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, r, n, a) {
                return t || r || n || a;
              })));
            }
            function me(e) {
              return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            }
            J = {};
            var ve = {};
            function we(e, t) {
              var r,
                n,
                a = t;
              for ("string" == typeof e && (e = [e]), c(t) && (a = function a(e, r) {
                r[t] = W(e);
              }), n = e.length, r = 0; r < n; r++) ve[e[r]] = a;
            }
            function ge(e, t) {
              we(e, function (e, r, n, a) {
                n._w = n._w || {}, t(e, n._w, n, a);
              });
            }
            function ye(e, t, r) {
              null != t && o(ve, e) && ve[e](t, r._a, r, e);
            }
            var be,
              ke = 0,
              xe = 1,
              Te = 2,
              Ee = 3,
              _e = 4,
              Ce = 5,
              Se = 6,
              Re = 7,
              De = 8;
            function Pe(e, t) {
              if (isNaN(e) || isNaN(t)) return NaN;
              var r,
                n = (t % (r = 12) + r) % r;
              return e += (t - n) / 12, 1 === n ? j(e) ? 29 : 28 : 31 - n % 7 % 2;
            }
            be = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
              var t;
              for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
              return -1;
            }, A("M", ["MM", 2], "Mo", function () {
              return this.month() + 1;
            }), A("MMM", 0, 0, function (e) {
              return this.localeData().monthsShort(this, e);
            }), A("MMMM", 0, 0, function (e) {
              return this.localeData().months(this, e);
            }), F("month", "M"), Y("month", 8), le("M", re), le("MM", re, K), le("MMM", function (e, t) {
              return t.monthsShortRegex(e);
            }), le("MMMM", function (e, t) {
              return t.monthsRegex(e);
            }), we(["M", "MM"], function (e, t) {
              t[xe] = W(e) - 1;
            }), we(["MMM", "MMMM"], function (e, t, r, n) {
              var a = r._locale.monthsParse(e, n, r._strict);
              null != a ? t[xe] = a : h(r).invalidMonth = e;
            });
            var Ie = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
              Oe = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
              Ne = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
              qe = pe,
              Ae = pe;
            function Me(e, t, r) {
              var n,
                a,
                s,
                o = e.toLocaleLowerCase();
              if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n) s = l([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(s, "").toLocaleLowerCase(), this._longMonthsParse[n] = this.months(s, "").toLocaleLowerCase();
              return r ? "MMM" === t ? -1 !== (a = be.call(this._shortMonthsParse, o)) ? a : null : -1 !== (a = be.call(this._longMonthsParse, o)) ? a : null : "MMM" === t ? -1 !== (a = be.call(this._shortMonthsParse, o)) || -1 !== (a = be.call(this._longMonthsParse, o)) ? a : null : -1 !== (a = be.call(this._longMonthsParse, o)) || -1 !== (a = be.call(this._shortMonthsParse, o)) ? a : null;
            }
            function Ue(e, t) {
              var r;
              if (!e.isValid()) return e;
              if ("string" == typeof t) if (/^\d+$/.test(t)) t = W(t);else if (!c(t = e.localeData().monthsParse(t))) return e;
              return r = Math.min(e.date(), Pe(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, r), e;
            }
            function Le(e) {
              return null != e ? (Ue(this, e), n.updateOffset(this, !0), this) : $(this, "Month");
            }
            function Fe() {
              function e(e, t) {
                return t.length - e.length;
              }
              var t,
                r,
                n = [],
                a = [],
                s = [];
              for (t = 0; t < 12; t++) r = l([2e3, t]), n.push(this.monthsShort(r, "")), a.push(this.months(r, "")), s.push(this.months(r, "")), s.push(this.monthsShort(r, ""));
              for (n.sort(e), a.sort(e), s.sort(e), t = 0; t < 12; t++) n[t] = me(n[t]), a[t] = me(a[t]);
              for (t = 0; t < 24; t++) s[t] = me(s[t]);
              this._monthsRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")", "i");
            }
            function Be(e) {
              return j(e) ? 366 : 365;
            }
            A("Y", 0, 0, function () {
              var e = this.year();
              return e <= 9999 ? P(e, 4) : "+" + e;
            }), A(0, ["YY", 2], 0, function () {
              return this.year() % 100;
            }), A(0, ["YYYY", 4], 0, "year"), A(0, ["YYYYY", 5], 0, "year"), A(0, ["YYYYYY", 6, !0], 0, "year"), F("year", "y"), Y("year", 1), le("Y", ce), le("YY", re, K), le("YYYY", oe, ee), le("YYYYY", ie, te), le("YYYYYY", ie, te), we(["YYYYY", "YYYYYY"], ke), we("YYYY", function (e, t) {
              t[ke] = 2 === e.length ? n.parseTwoDigitYear(e) : W(e);
            }), we("YY", function (e, t) {
              t[ke] = n.parseTwoDigitYear(e);
            }), we("Y", function (e, t) {
              t[ke] = parseInt(e, 10);
            }), n.parseTwoDigitYear = function (e) {
              return W(e) + (W(e) > 68 ? 1900 : 2e3);
            };
            var Ve = z("FullYear", !0);
            function Ge(e, t, r, n, a, s, o) {
              var i;
              return e < 100 && e >= 0 ? (i = new Date(e + 400, t, r, n, a, s, o), isFinite(i.getFullYear()) && i.setFullYear(e)) : i = new Date(e, t, r, n, a, s, o), i;
            }
            function Ye(e) {
              var t, r;
              return e < 100 && e >= 0 ? ((r = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
            }
            function je(e, t, r) {
              var n = 7 + t - r;
              return -(7 + Ye(e, 0, n).getUTCDay() - t) % 7 + n - 1;
            }
            function He(e, t, r, n, a) {
              var s,
                o,
                i = 1 + 7 * (t - 1) + (7 + r - n) % 7 + je(e, n, a);
              return i <= 0 ? o = Be(s = e - 1) + i : i > Be(e) ? (s = e + 1, o = i - Be(e)) : (s = e, o = i), {
                year: s,
                dayOfYear: o
              };
            }
            function We(e, t, r) {
              var n,
                a,
                s = je(e.year(), t, r),
                o = Math.floor((e.dayOfYear() - s - 1) / 7) + 1;
              return o < 1 ? n = o + ze(a = e.year() - 1, t, r) : o > ze(e.year(), t, r) ? (n = o - ze(e.year(), t, r), a = e.year() + 1) : (a = e.year(), n = o), {
                week: n,
                year: a
              };
            }
            function ze(e, t, r) {
              var n = je(e, t, r),
                a = je(e + 1, t, r);
              return (Be(e) - n + a) / 7;
            }
            A("w", ["ww", 2], "wo", "week"), A("W", ["WW", 2], "Wo", "isoWeek"), F("week", "w"), F("isoWeek", "W"), Y("week", 5), Y("isoWeek", 5), le("w", re), le("ww", re, K), le("W", re), le("WW", re, K), ge(["w", "ww", "W", "WW"], function (e, t, r, n) {
              t[n.substr(0, 1)] = W(e);
            });
            function $e(e, t) {
              return e.slice(t, 7).concat(e.slice(0, t));
            }
            A("d", 0, "do", "day"), A("dd", 0, 0, function (e) {
              return this.localeData().weekdaysMin(this, e);
            }), A("ddd", 0, 0, function (e) {
              return this.localeData().weekdaysShort(this, e);
            }), A("dddd", 0, 0, function (e) {
              return this.localeData().weekdays(this, e);
            }), A("e", 0, 0, "weekday"), A("E", 0, 0, "isoWeekday"), F("day", "d"), F("weekday", "e"), F("isoWeekday", "E"), Y("day", 11), Y("weekday", 11), Y("isoWeekday", 11), le("d", re), le("e", re), le("E", re), le("dd", function (e, t) {
              return t.weekdaysMinRegex(e);
            }), le("ddd", function (e, t) {
              return t.weekdaysShortRegex(e);
            }), le("dddd", function (e, t) {
              return t.weekdaysRegex(e);
            }), ge(["dd", "ddd", "dddd"], function (e, t, r, n) {
              var a = r._locale.weekdaysParse(e, n, r._strict);
              null != a ? t.d = a : h(r).invalidWeekday = e;
            }), ge(["d", "e", "E"], function (e, t, r, n) {
              t[n] = W(e);
            });
            var Ze = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
              Je = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
              Xe = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
              Ke = pe,
              Qe = pe,
              et = pe;
            function tt(e, t, r) {
              var n,
                a,
                s,
                o = e.toLocaleLowerCase();
              if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n) s = l([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(s, "").toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(s, "").toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(s, "").toLocaleLowerCase();
              return r ? "dddd" === t ? -1 !== (a = be.call(this._weekdaysParse, o)) ? a : null : "ddd" === t ? -1 !== (a = be.call(this._shortWeekdaysParse, o)) ? a : null : -1 !== (a = be.call(this._minWeekdaysParse, o)) ? a : null : "dddd" === t ? -1 !== (a = be.call(this._weekdaysParse, o)) || -1 !== (a = be.call(this._shortWeekdaysParse, o)) || -1 !== (a = be.call(this._minWeekdaysParse, o)) ? a : null : "ddd" === t ? -1 !== (a = be.call(this._shortWeekdaysParse, o)) || -1 !== (a = be.call(this._weekdaysParse, o)) || -1 !== (a = be.call(this._minWeekdaysParse, o)) ? a : null : -1 !== (a = be.call(this._minWeekdaysParse, o)) || -1 !== (a = be.call(this._weekdaysParse, o)) || -1 !== (a = be.call(this._shortWeekdaysParse, o)) ? a : null;
            }
            function rt() {
              function e(e, t) {
                return t.length - e.length;
              }
              var t,
                r,
                n,
                a,
                s,
                o = [],
                i = [],
                u = [],
                c = [];
              for (t = 0; t < 7; t++) r = l([2e3, 1]).day(t), n = me(this.weekdaysMin(r, "")), a = me(this.weekdaysShort(r, "")), s = me(this.weekdays(r, "")), o.push(n), i.push(a), u.push(s), c.push(n), c.push(a), c.push(s);
              o.sort(e), i.sort(e), u.sort(e), c.sort(e), this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
            }
            function nt() {
              return this.hours() % 12 || 12;
            }
            function at(e, t) {
              A(e, 0, 0, function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), t);
              });
            }
            function st(e, t) {
              return t._meridiemParse;
            }
            A("H", ["HH", 2], 0, "hour"), A("h", ["hh", 2], 0, nt), A("k", ["kk", 2], 0, function () {
              return this.hours() || 24;
            }), A("hmm", 0, 0, function () {
              return "" + nt.apply(this) + P(this.minutes(), 2);
            }), A("hmmss", 0, 0, function () {
              return "" + nt.apply(this) + P(this.minutes(), 2) + P(this.seconds(), 2);
            }), A("Hmm", 0, 0, function () {
              return "" + this.hours() + P(this.minutes(), 2);
            }), A("Hmmss", 0, 0, function () {
              return "" + this.hours() + P(this.minutes(), 2) + P(this.seconds(), 2);
            }), at("a", !0), at("A", !1), F("hour", "h"), Y("hour", 13), le("a", st), le("A", st), le("H", re), le("h", re), le("k", re), le("HH", re, K), le("hh", re, K), le("kk", re, K), le("hmm", ne), le("hmmss", ae), le("Hmm", ne), le("Hmmss", ae), we(["H", "HH"], Ee), we(["k", "kk"], function (e, t, r) {
              var n = W(e);
              t[Ee] = 24 === n ? 0 : n;
            }), we(["a", "A"], function (e, t, r) {
              r._isPm = r._locale.isPM(e), r._meridiem = e;
            }), we(["h", "hh"], function (e, t, r) {
              t[Ee] = W(e), h(r).bigHour = !0;
            }), we("hmm", function (e, t, r) {
              var n = e.length - 2;
              t[Ee] = W(e.substr(0, n)), t[_e] = W(e.substr(n)), h(r).bigHour = !0;
            }), we("hmmss", function (e, t, r) {
              var n = e.length - 4,
                a = e.length - 2;
              t[Ee] = W(e.substr(0, n)), t[_e] = W(e.substr(n, 2)), t[Ce] = W(e.substr(a)), h(r).bigHour = !0;
            }), we("Hmm", function (e, t, r) {
              var n = e.length - 2;
              t[Ee] = W(e.substr(0, n)), t[_e] = W(e.substr(n));
            }), we("Hmmss", function (e, t, r) {
              var n = e.length - 4,
                a = e.length - 2;
              t[Ee] = W(e.substr(0, n)), t[_e] = W(e.substr(n, 2)), t[Ce] = W(e.substr(a));
            });
            var ot = z("Hours", !0);
            var it,
              ut = {
                calendar: {
                  sameDay: "[Today at] LT",
                  nextDay: "[Tomorrow at] LT",
                  nextWeek: "dddd [at] LT",
                  lastDay: "[Yesterday at] LT",
                  lastWeek: "[Last] dddd [at] LT",
                  sameElse: "L"
                },
                longDateFormat: {
                  LTS: "h:mm:ss A",
                  LT: "h:mm A",
                  L: "MM/DD/YYYY",
                  LL: "MMMM D, YYYY",
                  LLL: "MMMM D, YYYY h:mm A",
                  LLLL: "dddd, MMMM D, YYYY h:mm A"
                },
                invalidDate: "Invalid date",
                ordinal: "%d",
                dayOfMonthOrdinalParse: /\d{1,2}/,
                relativeTime: {
                  future: "in %s",
                  past: "%s ago",
                  s: "a few seconds",
                  ss: "%d seconds",
                  m: "a minute",
                  mm: "%d minutes",
                  h: "an hour",
                  hh: "%d hours",
                  d: "a day",
                  dd: "%d days",
                  w: "a week",
                  ww: "%d weeks",
                  M: "a month",
                  MM: "%d months",
                  y: "a year",
                  yy: "%d years"
                },
                months: Ie,
                monthsShort: Oe,
                week: {
                  dow: 0,
                  doy: 6
                },
                weekdays: Ze,
                weekdaysMin: Xe,
                weekdaysShort: Je,
                meridiemParse: /[ap]\.?m?\.?/i
              },
              ct = {},
              ft = {};
            function dt(e, t) {
              var r,
                n = Math.min(e.length, t.length);
              for (r = 0; r < n; r += 1) if (e[r] !== t[r]) return r;
              return n;
            }
            function pt(e) {
              return e ? e.toLowerCase().replace("_", "-") : e;
            }
            function lt(t) {
              var r = null;
              if (void 0 === ct[t] && e && e.exports && function (e) {
                return null != e.match("^[^/\\\\]*$");
              }(t)) try {
                r = it._abbr, Object(function () {
                  var e = new Error("Cannot find module 'undefined'");
                  throw e.code = "MODULE_NOT_FOUND", e;
                }()), ht(r);
              } catch (e) {
                ct[t] = null;
              }
              return ct[t];
            }
            function ht(e, t) {
              var r;
              return e && ((r = u(t) ? vt(e) : mt(e, t)) ? it = r : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), it._abbr;
            }
            function mt(e, t) {
              if (null !== t) {
                var r,
                  n = ut;
                if (t.abbr = e, null != ct[e]) C("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), n = ct[e]._config;else if (null != t.parentLocale) if (null != ct[t.parentLocale]) n = ct[t.parentLocale]._config;else {
                  if (null == (r = lt(t.parentLocale))) return ft[t.parentLocale] || (ft[t.parentLocale] = []), ft[t.parentLocale].push({
                    name: e,
                    config: t
                  }), null;
                  n = r._config;
                }
                return ct[e] = new D(R(n, t)), ft[e] && ft[e].forEach(function (e) {
                  mt(e.name, e.config);
                }), ht(e), ct[e];
              }
              return delete ct[e], null;
            }
            function vt(e) {
              var t;
              if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return it;
              if (!a(e)) {
                if (t = lt(e)) return t;
                e = [e];
              }
              return function (e) {
                for (var t, r, n, a, s = 0; s < e.length;) {
                  for (t = (a = pt(e[s]).split("-")).length, r = (r = pt(e[s + 1])) ? r.split("-") : null; t > 0;) {
                    if (n = lt(a.slice(0, t).join("-"))) return n;
                    if (r && r.length >= t && dt(a, r) >= t - 1) break;
                    t--;
                  }
                  s++;
                }
                return it;
              }(e);
            }
            function wt(e) {
              var t,
                r = e._a;
              return r && -2 === h(e).overflow && (t = r[xe] < 0 || r[xe] > 11 ? xe : r[Te] < 1 || r[Te] > Pe(r[ke], r[xe]) ? Te : r[Ee] < 0 || r[Ee] > 24 || 24 === r[Ee] && (0 !== r[_e] || 0 !== r[Ce] || 0 !== r[Se]) ? Ee : r[_e] < 0 || r[_e] > 59 ? _e : r[Ce] < 0 || r[Ce] > 59 ? Ce : r[Se] < 0 || r[Se] > 999 ? Se : -1, h(e)._overflowDayOfYear && (t < ke || t > Te) && (t = Te), h(e)._overflowWeeks && -1 === t && (t = Re), h(e)._overflowWeekday && -1 === t && (t = De), h(e).overflow = t), e;
            }
            var gt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
              yt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
              bt = /Z|[+-]\d\d(?::?\d\d)?/,
              kt = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
              xt = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
              Tt = /^\/?Date\((-?\d+)/i,
              Et = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
              _t = {
                UT: 0,
                GMT: 0,
                EDT: -240,
                EST: -300,
                CDT: -300,
                CST: -360,
                MDT: -360,
                MST: -420,
                PDT: -420,
                PST: -480
              };
            function Ct(e) {
              var t,
                r,
                n,
                a,
                s,
                o,
                i = e._i,
                u = gt.exec(i) || yt.exec(i),
                c = kt.length,
                f = xt.length;
              if (u) {
                for (h(e).iso = !0, t = 0, r = c; t < r; t++) if (kt[t][1].exec(u[1])) {
                  a = kt[t][0], n = !1 !== kt[t][2];
                  break;
                }
                if (null == a) return void (e._isValid = !1);
                if (u[3]) {
                  for (t = 0, r = f; t < r; t++) if (xt[t][1].exec(u[3])) {
                    s = (u[2] || " ") + xt[t][0];
                    break;
                  }
                  if (null == s) return void (e._isValid = !1);
                }
                if (!n && null != s) return void (e._isValid = !1);
                if (u[4]) {
                  if (!bt.exec(u[4])) return void (e._isValid = !1);
                  o = "Z";
                }
                e._f = a + (s || "") + (o || ""), It(e);
              } else e._isValid = !1;
            }
            function St(e) {
              var t = parseInt(e, 10);
              return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
            }
            function Rt(e) {
              var t,
                r,
                n,
                a,
                s,
                o,
                i,
                u,
                c = Et.exec(e._i.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
              if (c) {
                if (r = c[4], n = c[3], a = c[2], s = c[5], o = c[6], i = c[7], u = [St(r), Oe.indexOf(n), parseInt(a, 10), parseInt(s, 10), parseInt(o, 10)], i && u.push(parseInt(i, 10)), t = u, !function (e, t, r) {
                  return !e || Je.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() || (h(r).weekdayMismatch = !0, r._isValid = !1, !1);
                }(c[1], t, e)) return;
                e._a = t, e._tzm = function (e, t, r) {
                  if (e) return _t[e];
                  if (t) return 0;
                  var n = parseInt(r, 10),
                    a = n % 100;
                  return (n - a) / 100 * 60 + a;
                }(c[8], c[9], c[10]), e._d = Ye.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), h(e).rfc2822 = !0;
              } else e._isValid = !1;
            }
            function Dt(e, t, r) {
              return null != e ? e : null != t ? t : r;
            }
            function Pt(e) {
              var t,
                r,
                a,
                s,
                o,
                i = [];
              if (!e._d) {
                for (a = function (e) {
                  var t = new Date(n.now());
                  return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
                }(e), e._w && null == e._a[Te] && null == e._a[xe] && function (e) {
                  var t, r, n, a, s, o, i, u, c;
                  null != (t = e._w).GG || null != t.W || null != t.E ? (s = 1, o = 4, r = Dt(t.GG, e._a[ke], We(qt(), 1, 4).year), n = Dt(t.W, 1), ((a = Dt(t.E, 1)) < 1 || a > 7) && (u = !0)) : (s = e._locale._week.dow, o = e._locale._week.doy, c = We(qt(), s, o), r = Dt(t.gg, e._a[ke], c.year), n = Dt(t.w, c.week), null != t.d ? ((a = t.d) < 0 || a > 6) && (u = !0) : null != t.e ? (a = t.e + s, (t.e < 0 || t.e > 6) && (u = !0)) : a = s), n < 1 || n > ze(r, s, o) ? h(e)._overflowWeeks = !0 : null != u ? h(e)._overflowWeekday = !0 : (i = He(r, n, a, s, o), e._a[ke] = i.year, e._dayOfYear = i.dayOfYear);
                }(e), null != e._dayOfYear && (o = Dt(e._a[ke], a[ke]), (e._dayOfYear > Be(o) || 0 === e._dayOfYear) && (h(e)._overflowDayOfYear = !0), r = Ye(o, 0, e._dayOfYear), e._a[xe] = r.getUTCMonth(), e._a[Te] = r.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = i[t] = a[t];
                for (; t < 7; t++) e._a[t] = i[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
                24 === e._a[Ee] && 0 === e._a[_e] && 0 === e._a[Ce] && 0 === e._a[Se] && (e._nextDay = !0, e._a[Ee] = 0), e._d = (e._useUTC ? Ye : Ge).apply(null, i), s = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Ee] = 24), e._w && void 0 !== e._w.d && e._w.d !== s && (h(e).weekdayMismatch = !0);
              }
            }
            function It(e) {
              if (e._f !== n.ISO_8601) {
                if (e._f !== n.RFC_2822) {
                  e._a = [], h(e).empty = !0;
                  var t,
                    r,
                    a,
                    s,
                    o,
                    i,
                    u,
                    c = "" + e._i,
                    f = c.length,
                    d = 0;
                  for (u = (a = U(e._f, e._locale).match(I) || []).length, t = 0; t < u; t++) s = a[t], (r = (c.match(he(s, e)) || [])[0]) && ((o = c.substr(0, c.indexOf(r))).length > 0 && h(e).unusedInput.push(o), c = c.slice(c.indexOf(r) + r.length), d += r.length), q[s] ? (r ? h(e).empty = !1 : h(e).unusedTokens.push(s), ye(s, r, e)) : e._strict && !r && h(e).unusedTokens.push(s);
                  h(e).charsLeftOver = f - d, c.length > 0 && h(e).unusedInput.push(c), e._a[Ee] <= 12 && !0 === h(e).bigHour && e._a[Ee] > 0 && (h(e).bigHour = void 0), h(e).parsedDateParts = e._a.slice(0), h(e).meridiem = e._meridiem, e._a[Ee] = function (e, t, r) {
                    var n;
                    return null == r ? t : null != e.meridiemHour ? e.meridiemHour(t, r) : null != e.isPM ? ((n = e.isPM(r)) && t < 12 && (t += 12), n || 12 !== t || (t = 0), t) : t;
                  }(e._locale, e._a[Ee], e._meridiem), null !== (i = h(e).era) && (e._a[ke] = e._locale.erasConvertYear(i, e._a[ke])), Pt(e), wt(e);
                } else Rt(e);
              } else Ct(e);
            }
            function Ot(e) {
              var t = e._i,
                r = e._f;
              return e._locale = e._locale || vt(e._l), null === t || void 0 === r && "" === t ? v({
                nullInput: !0
              }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), k(t) ? new b(wt(t)) : (f(t) ? e._d = t : a(r) ? function (e) {
                var t,
                  r,
                  n,
                  a,
                  s,
                  o,
                  i = !1,
                  u = e._f.length;
                if (0 === u) return h(e).invalidFormat = !0, void (e._d = new Date(NaN));
                for (a = 0; a < u; a++) s = 0, o = !1, t = y({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[a], It(t), m(t) && (o = !0), s += h(t).charsLeftOver, s += 10 * h(t).unusedTokens.length, h(t).score = s, i ? s < n && (n = s, r = t) : (null == n || s < n || o) && (n = s, r = t, o && (i = !0));
                p(e, r || t);
              }(e) : r ? It(e) : function (e) {
                var t = e._i;
                u(t) ? e._d = new Date(n.now()) : f(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function (e) {
                  var t = Tt.exec(e._i);
                  null === t ? (Ct(e), !1 === e._isValid && (delete e._isValid, Rt(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : n.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
                }(e) : a(t) ? (e._a = d(t.slice(0), function (e) {
                  return parseInt(e, 10);
                }), Pt(e)) : s(t) ? function (e) {
                  if (!e._d) {
                    var t = V(e._i),
                      r = void 0 === t.day ? t.date : t.day;
                    e._a = d([t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond], function (e) {
                      return e && parseInt(e, 10);
                    }), Pt(e);
                  }
                }(e) : c(t) ? e._d = new Date(t) : n.createFromInputFallback(e);
              }(e), m(e) || (e._d = null), e));
            }
            function Nt(e, t, r, n, o) {
              var u,
                c = {};
              return !0 !== t && !1 !== t || (n = t, t = void 0), !0 !== r && !1 !== r || (n = r, r = void 0), (s(e) && i(e) || a(e) && 0 === e.length) && (e = void 0), c._isAMomentObject = !0, c._useUTC = c._isUTC = o, c._l = r, c._i = e, c._f = t, c._strict = n, (u = new b(wt(Ot(c))))._nextDay && (u.add(1, "d"), u._nextDay = void 0), u;
            }
            function qt(e, t, r, n) {
              return Nt(e, t, r, n, !1);
            }
            n.createFromInputFallback = T("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
              e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
            }), n.ISO_8601 = function () {}, n.RFC_2822 = function () {};
            var At = T("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
                var e = qt.apply(null, arguments);
                return this.isValid() && e.isValid() ? e < this ? this : e : v();
              }),
              Mt = T("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
                var e = qt.apply(null, arguments);
                return this.isValid() && e.isValid() ? e > this ? this : e : v();
              });
            function Ut(e, t) {
              var r, n;
              if (1 === t.length && a(t[0]) && (t = t[0]), !t.length) return qt();
              for (r = t[0], n = 1; n < t.length; ++n) t[n].isValid() && !t[n][e](r) || (r = t[n]);
              return r;
            }
            var Lt = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
            function Ft(e) {
              var t = V(e),
                r = t.year || 0,
                n = t.quarter || 0,
                a = t.month || 0,
                s = t.week || t.isoWeek || 0,
                i = t.day || 0,
                u = t.hour || 0,
                c = t.minute || 0,
                f = t.second || 0,
                d = t.millisecond || 0;
              this._isValid = function (e) {
                var t,
                  r,
                  n = !1,
                  a = Lt.length;
                for (t in e) if (o(e, t) && (-1 === be.call(Lt, t) || null != e[t] && isNaN(e[t]))) return !1;
                for (r = 0; r < a; ++r) if (e[Lt[r]]) {
                  if (n) return !1;
                  parseFloat(e[Lt[r]]) !== W(e[Lt[r]]) && (n = !0);
                }
                return !0;
              }(t), this._milliseconds = +d + 1e3 * f + 6e4 * c + 1e3 * u * 60 * 60, this._days = +i + 7 * s, this._months = +a + 3 * n + 12 * r, this._data = {}, this._locale = vt(), this._bubble();
            }
            function Bt(e) {
              return e instanceof Ft;
            }
            function Vt(e) {
              return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
            }
            function Gt(e, t) {
              A(e, 0, 0, function () {
                var e = this.utcOffset(),
                  r = "+";
                return e < 0 && (e = -e, r = "-"), r + P(~~(e / 60), 2) + t + P(~~e % 60, 2);
              });
            }
            Gt("Z", ":"), Gt("ZZ", ""), le("Z", de), le("ZZ", de), we(["Z", "ZZ"], function (e, t, r) {
              r._useUTC = !0, r._tzm = jt(de, e);
            });
            var Yt = /([\+\-]|\d\d)/gi;
            function jt(e, t) {
              var r,
                n,
                a = (t || "").match(e);
              return null === a ? null : 0 === (n = 60 * (r = ((a[a.length - 1] || []) + "").match(Yt) || ["-", 0, 0])[1] + W(r[2])) ? 0 : "+" === r[0] ? n : -n;
            }
            function Ht(e, t) {
              var r, a;
              return t._isUTC ? (r = t.clone(), a = (k(e) || f(e) ? e.valueOf() : qt(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + a), n.updateOffset(r, !1), r) : qt(e).local();
            }
            function Wt(e) {
              return -Math.round(e._d.getTimezoneOffset());
            }
            function zt() {
              return !!this.isValid() && this._isUTC && 0 === this._offset;
            }
            n.updateOffset = function () {};
            var $t = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
              Zt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
            function Jt(e, t) {
              var r,
                n,
                a,
                s,
                i,
                u,
                f = e,
                d = null;
              return Bt(e) ? f = {
                ms: e._milliseconds,
                d: e._days,
                M: e._months
              } : c(e) || !isNaN(+e) ? (f = {}, t ? f[t] = +e : f.milliseconds = +e) : (d = $t.exec(e)) ? (r = "-" === d[1] ? -1 : 1, f = {
                y: 0,
                d: W(d[Te]) * r,
                h: W(d[Ee]) * r,
                m: W(d[_e]) * r,
                s: W(d[Ce]) * r,
                ms: W(Vt(1e3 * d[Se])) * r
              }) : (d = Zt.exec(e)) ? (r = "-" === d[1] ? -1 : 1, f = {
                y: Xt(d[2], r),
                M: Xt(d[3], r),
                w: Xt(d[4], r),
                d: Xt(d[5], r),
                h: Xt(d[6], r),
                m: Xt(d[7], r),
                s: Xt(d[8], r)
              }) : null == f ? f = {} : "object" == typeof f && ("from" in f || "to" in f) && (s = qt(f.from), i = qt(f.to), a = s.isValid() && i.isValid() ? (i = Ht(i, s), s.isBefore(i) ? u = Kt(s, i) : ((u = Kt(i, s)).milliseconds = -u.milliseconds, u.months = -u.months), u) : {
                milliseconds: 0,
                months: 0
              }, (f = {}).ms = a.milliseconds, f.M = a.months), n = new Ft(f), Bt(e) && o(e, "_locale") && (n._locale = e._locale), Bt(e) && o(e, "_isValid") && (n._isValid = e._isValid), n;
            }
            function Xt(e, t) {
              var r = e && parseFloat(e.replace(",", "."));
              return (isNaN(r) ? 0 : r) * t;
            }
            function Kt(e, t) {
              var r = {};
              return r.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
            }
            function Qt(e, t) {
              return function (r, n) {
                var a;
                return null === n || isNaN(+n) || (C(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), a = r, r = n, n = a), er(this, Jt(r, n), e), this;
              };
            }
            function er(e, t, r, a) {
              var s = t._milliseconds,
                o = Vt(t._days),
                i = Vt(t._months);
              e.isValid() && (a = null == a || a, i && Ue(e, $(e, "Month") + i * r), o && Z(e, "Date", $(e, "Date") + o * r), s && e._d.setTime(e._d.valueOf() + s * r), a && n.updateOffset(e, o || i));
            }
            Jt.fn = Ft.prototype, Jt.invalid = function () {
              return Jt(NaN);
            };
            var tr = Qt(1, "add"),
              rr = Qt(-1, "subtract");
            function nr(e) {
              return "string" == typeof e || e instanceof String;
            }
            function ar(e) {
              return k(e) || f(e) || nr(e) || c(e) || function (e) {
                var t = a(e),
                  r = !1;
                return t && (r = 0 === e.filter(function (t) {
                  return !c(t) && nr(e);
                }).length), t && r;
              }(e) || function (e) {
                var t,
                  r,
                  n = s(e) && !i(e),
                  a = !1,
                  u = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
                  c = u.length;
                for (t = 0; t < c; t += 1) r = u[t], a = a || o(e, r);
                return n && a;
              }(e) || null == e;
            }
            function sr(e, t) {
              if (e.date() < t.date()) return -sr(t, e);
              var r = 12 * (t.year() - e.year()) + (t.month() - e.month()),
                n = e.clone().add(r, "months");
              return -(r + (t - n < 0 ? (t - n) / (n - e.clone().add(r - 1, "months")) : (t - n) / (e.clone().add(r + 1, "months") - n))) || 0;
            }
            function or(e) {
              var t;
              return void 0 === e ? this._locale._abbr : (null != (t = vt(e)) && (this._locale = t), this);
            }
            n.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", n.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
            var ir = T("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
              return void 0 === e ? this.localeData() : this.locale(e);
            });
            function ur() {
              return this._locale;
            }
            var cr = 1e3,
              fr = 6e4,
              dr = 36e5,
              pr = 126227808e5;
            function lr(e, t) {
              return (e % t + t) % t;
            }
            function hr(e, t, r) {
              return e < 100 && e >= 0 ? new Date(e + 400, t, r) - pr : new Date(e, t, r).valueOf();
            }
            function mr(e, t, r) {
              return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - pr : Date.UTC(e, t, r);
            }
            function vr(e, t) {
              return t.erasAbbrRegex(e);
            }
            function wr() {
              var e,
                t,
                r = [],
                n = [],
                a = [],
                s = [],
                o = this.eras();
              for (e = 0, t = o.length; e < t; ++e) n.push(me(o[e].name)), r.push(me(o[e].abbr)), a.push(me(o[e].narrow)), s.push(me(o[e].name)), s.push(me(o[e].abbr)), s.push(me(o[e].narrow));
              this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + a.join("|") + ")", "i");
            }
            function gr(e, t) {
              A(0, [e, e.length], 0, t);
            }
            function yr(e, t, r, n, a) {
              var s;
              return null == e ? We(this, n, a).year : (t > (s = ze(e, n, a)) && (t = s), br.call(this, e, t, r, n, a));
            }
            function br(e, t, r, n, a) {
              var s = He(e, t, r, n, a),
                o = Ye(s.year, 0, s.dayOfYear);
              return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
            }
            A("N", 0, 0, "eraAbbr"), A("NN", 0, 0, "eraAbbr"), A("NNN", 0, 0, "eraAbbr"), A("NNNN", 0, 0, "eraName"), A("NNNNN", 0, 0, "eraNarrow"), A("y", ["y", 1], "yo", "eraYear"), A("y", ["yy", 2], 0, "eraYear"), A("y", ["yyy", 3], 0, "eraYear"), A("y", ["yyyy", 4], 0, "eraYear"), le("N", vr), le("NN", vr), le("NNN", vr), le("NNNN", function (e, t) {
              return t.erasNameRegex(e);
            }), le("NNNNN", function (e, t) {
              return t.erasNarrowRegex(e);
            }), we(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, r, n) {
              var a = r._locale.erasParse(e, n, r._strict);
              a ? h(r).era = a : h(r).invalidEra = e;
            }), le("y", ue), le("yy", ue), le("yyy", ue), le("yyyy", ue), le("yo", function (e, t) {
              return t._eraYearOrdinalRegex || ue;
            }), we(["y", "yy", "yyy", "yyyy"], ke), we(["yo"], function (e, t, r, n) {
              var a;
              r._locale._eraYearOrdinalRegex && (a = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[ke] = r._locale.eraYearOrdinalParse(e, a) : t[ke] = parseInt(e, 10);
            }), A(0, ["gg", 2], 0, function () {
              return this.weekYear() % 100;
            }), A(0, ["GG", 2], 0, function () {
              return this.isoWeekYear() % 100;
            }), gr("gggg", "weekYear"), gr("ggggg", "weekYear"), gr("GGGG", "isoWeekYear"), gr("GGGGG", "isoWeekYear"), F("weekYear", "gg"), F("isoWeekYear", "GG"), Y("weekYear", 1), Y("isoWeekYear", 1), le("G", ce), le("g", ce), le("GG", re, K), le("gg", re, K), le("GGGG", oe, ee), le("gggg", oe, ee), le("GGGGG", ie, te), le("ggggg", ie, te), ge(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, r, n) {
              t[n.substr(0, 2)] = W(e);
            }), ge(["gg", "GG"], function (e, t, r, a) {
              t[a] = n.parseTwoDigitYear(e);
            }), A("Q", 0, "Qo", "quarter"), F("quarter", "Q"), Y("quarter", 7), le("Q", X), we("Q", function (e, t) {
              t[xe] = 3 * (W(e) - 1);
            }), A("D", ["DD", 2], "Do", "date"), F("date", "D"), Y("date", 9), le("D", re), le("DD", re, K), le("Do", function (e, t) {
              return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
            }), we(["D", "DD"], Te), we("Do", function (e, t) {
              t[Te] = W(e.match(re)[0]);
            });
            var kr = z("Date", !0);
            A("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), F("dayOfYear", "DDD"), Y("dayOfYear", 4), le("DDD", se), le("DDDD", Q), we(["DDD", "DDDD"], function (e, t, r) {
              r._dayOfYear = W(e);
            }), A("m", ["mm", 2], 0, "minute"), F("minute", "m"), Y("minute", 14), le("m", re), le("mm", re, K), we(["m", "mm"], _e);
            var xr = z("Minutes", !1);
            A("s", ["ss", 2], 0, "second"), F("second", "s"), Y("second", 15), le("s", re), le("ss", re, K), we(["s", "ss"], Ce);
            var Tr,
              Er,
              _r = z("Seconds", !1);
            for (A("S", 0, 0, function () {
              return ~~(this.millisecond() / 100);
            }), A(0, ["SS", 2], 0, function () {
              return ~~(this.millisecond() / 10);
            }), A(0, ["SSS", 3], 0, "millisecond"), A(0, ["SSSS", 4], 0, function () {
              return 10 * this.millisecond();
            }), A(0, ["SSSSS", 5], 0, function () {
              return 100 * this.millisecond();
            }), A(0, ["SSSSSS", 6], 0, function () {
              return 1e3 * this.millisecond();
            }), A(0, ["SSSSSSS", 7], 0, function () {
              return 1e4 * this.millisecond();
            }), A(0, ["SSSSSSSS", 8], 0, function () {
              return 1e5 * this.millisecond();
            }), A(0, ["SSSSSSSSS", 9], 0, function () {
              return 1e6 * this.millisecond();
            }), F("millisecond", "ms"), Y("millisecond", 16), le("S", se, X), le("SS", se, K), le("SSS", se, Q), Tr = "SSSS"; Tr.length <= 9; Tr += "S") le(Tr, ue);
            function Cr(e, t) {
              t[Se] = W(1e3 * ("0." + e));
            }
            for (Tr = "S"; Tr.length <= 9; Tr += "S") we(Tr, Cr);
            Er = z("Milliseconds", !1), A("z", 0, 0, "zoneAbbr"), A("zz", 0, 0, "zoneName");
            var Sr = b.prototype;
            function Rr(e) {
              return e;
            }
            Sr.add = tr, Sr.calendar = function (e, t) {
              1 === arguments.length && (arguments[0] ? ar(arguments[0]) ? (e = arguments[0], t = void 0) : function (e) {
                var t,
                  r = s(e) && !i(e),
                  n = !1,
                  a = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
                for (t = 0; t < a.length; t += 1) n = n || o(e, a[t]);
                return r && n;
              }(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
              var r = e || qt(),
                a = Ht(r, this).startOf("day"),
                u = n.calendarFormat(this, a) || "sameElse",
                c = t && (S(t[u]) ? t[u].call(this, r) : t[u]);
              return this.format(c || this.localeData().calendar(u, this, qt(r)));
            }, Sr.clone = function () {
              return new b(this);
            }, Sr.diff = function (e, t, r) {
              var n, a, s;
              if (!this.isValid()) return NaN;
              if (!(n = Ht(e, this)).isValid()) return NaN;
              switch (a = 6e4 * (n.utcOffset() - this.utcOffset()), t = B(t)) {
                case "year":
                  s = sr(this, n) / 12;
                  break;
                case "month":
                  s = sr(this, n);
                  break;
                case "quarter":
                  s = sr(this, n) / 3;
                  break;
                case "second":
                  s = (this - n) / 1e3;
                  break;
                case "minute":
                  s = (this - n) / 6e4;
                  break;
                case "hour":
                  s = (this - n) / 36e5;
                  break;
                case "day":
                  s = (this - n - a) / 864e5;
                  break;
                case "week":
                  s = (this - n - a) / 6048e5;
                  break;
                default:
                  s = this - n;
              }
              return r ? s : H(s);
            }, Sr.endOf = function (e) {
              var t, r;
              if (void 0 === (e = B(e)) || "millisecond" === e || !this.isValid()) return this;
              switch (r = this._isUTC ? mr : hr, e) {
                case "year":
                  t = r(this.year() + 1, 0, 1) - 1;
                  break;
                case "quarter":
                  t = r(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                  break;
                case "month":
                  t = r(this.year(), this.month() + 1, 1) - 1;
                  break;
                case "week":
                  t = r(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                  break;
                case "isoWeek":
                  t = r(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                  break;
                case "day":
                case "date":
                  t = r(this.year(), this.month(), this.date() + 1) - 1;
                  break;
                case "hour":
                  t = this._d.valueOf(), t += dr - lr(t + (this._isUTC ? 0 : this.utcOffset() * fr), dr) - 1;
                  break;
                case "minute":
                  t = this._d.valueOf(), t += fr - lr(t, fr) - 1;
                  break;
                case "second":
                  t = this._d.valueOf(), t += cr - lr(t, cr) - 1;
              }
              return this._d.setTime(t), n.updateOffset(this, !0), this;
            }, Sr.format = function (e) {
              e || (e = this.isUtc() ? n.defaultFormatUtc : n.defaultFormat);
              var t = M(this, e);
              return this.localeData().postformat(t);
            }, Sr.from = function (e, t) {
              return this.isValid() && (k(e) && e.isValid() || qt(e).isValid()) ? Jt({
                to: this,
                from: e
              }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
            }, Sr.fromNow = function (e) {
              return this.from(qt(), e);
            }, Sr.to = function (e, t) {
              return this.isValid() && (k(e) && e.isValid() || qt(e).isValid()) ? Jt({
                from: this,
                to: e
              }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
            }, Sr.toNow = function (e) {
              return this.to(qt(), e);
            }, Sr.get = function (e) {
              return S(this[e = B(e)]) ? this[e]() : this;
            }, Sr.invalidAt = function () {
              return h(this).overflow;
            }, Sr.isAfter = function (e, t) {
              var r = k(e) ? e : qt(e);
              return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = B(t) || "millisecond") ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf());
            }, Sr.isBefore = function (e, t) {
              var r = k(e) ? e : qt(e);
              return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = B(t) || "millisecond") ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf());
            }, Sr.isBetween = function (e, t, r, n) {
              var a = k(e) ? e : qt(e),
                s = k(t) ? t : qt(t);
              return !!(this.isValid() && a.isValid() && s.isValid()) && ("(" === (n = n || "()")[0] ? this.isAfter(a, r) : !this.isBefore(a, r)) && (")" === n[1] ? this.isBefore(s, r) : !this.isAfter(s, r));
            }, Sr.isSame = function (e, t) {
              var r,
                n = k(e) ? e : qt(e);
              return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = B(t) || "millisecond") ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf()));
            }, Sr.isSameOrAfter = function (e, t) {
              return this.isSame(e, t) || this.isAfter(e, t);
            }, Sr.isSameOrBefore = function (e, t) {
              return this.isSame(e, t) || this.isBefore(e, t);
            }, Sr.isValid = function () {
              return m(this);
            }, Sr.lang = ir, Sr.locale = or, Sr.localeData = ur, Sr.max = Mt, Sr.min = At, Sr.parsingFlags = function () {
              return p({}, h(this));
            }, Sr.set = function (e, t) {
              if ("object" == typeof e) {
                var r,
                  n = function (e) {
                    var t,
                      r = [];
                    for (t in e) o(e, t) && r.push({
                      unit: t,
                      priority: G[t]
                    });
                    return r.sort(function (e, t) {
                      return e.priority - t.priority;
                    }), r;
                  }(e = V(e)),
                  a = n.length;
                for (r = 0; r < a; r++) this[n[r].unit](e[n[r].unit]);
              } else if (S(this[e = B(e)])) return this[e](t);
              return this;
            }, Sr.startOf = function (e) {
              var t, r;
              if (void 0 === (e = B(e)) || "millisecond" === e || !this.isValid()) return this;
              switch (r = this._isUTC ? mr : hr, e) {
                case "year":
                  t = r(this.year(), 0, 1);
                  break;
                case "quarter":
                  t = r(this.year(), this.month() - this.month() % 3, 1);
                  break;
                case "month":
                  t = r(this.year(), this.month(), 1);
                  break;
                case "week":
                  t = r(this.year(), this.month(), this.date() - this.weekday());
                  break;
                case "isoWeek":
                  t = r(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                  break;
                case "day":
                case "date":
                  t = r(this.year(), this.month(), this.date());
                  break;
                case "hour":
                  t = this._d.valueOf(), t -= lr(t + (this._isUTC ? 0 : this.utcOffset() * fr), dr);
                  break;
                case "minute":
                  t = this._d.valueOf(), t -= lr(t, fr);
                  break;
                case "second":
                  t = this._d.valueOf(), t -= lr(t, cr);
              }
              return this._d.setTime(t), n.updateOffset(this, !0), this;
            }, Sr.subtract = rr, Sr.toArray = function () {
              var e = this;
              return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
            }, Sr.toObject = function () {
              var e = this;
              return {
                years: e.year(),
                months: e.month(),
                date: e.date(),
                hours: e.hours(),
                minutes: e.minutes(),
                seconds: e.seconds(),
                milliseconds: e.milliseconds()
              };
            }, Sr.toDate = function () {
              return new Date(this.valueOf());
            }, Sr.toISOString = function (e) {
              if (!this.isValid()) return null;
              var t = !0 !== e,
                r = t ? this.clone().utc() : this;
              return r.year() < 0 || r.year() > 9999 ? M(r, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : S(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", M(r, "Z")) : M(r, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
            }, Sr.inspect = function () {
              if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
              var e,
                t,
                r,
                n = "moment",
                a = "";
              return this.isLocal() || (n = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", a = "Z"), e = "[" + n + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", "-MM-DD[T]HH:mm:ss.SSS", r = a + '[")]', this.format(e + t + "-MM-DD[T]HH:mm:ss.SSS" + r);
            }, "undefined" != typeof Symbol && null != Symbol["for"] && (Sr[Symbol["for"]("nodejs.util.inspect.custom")] = function () {
              return "Moment<" + this.format() + ">";
            }), Sr.toJSON = function () {
              return this.isValid() ? this.toISOString() : null;
            }, Sr.toString = function () {
              return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
            }, Sr.unix = function () {
              return Math.floor(this.valueOf() / 1e3);
            }, Sr.valueOf = function () {
              return this._d.valueOf() - 6e4 * (this._offset || 0);
            }, Sr.creationData = function () {
              return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict
              };
            }, Sr.eraName = function () {
              var e,
                t,
                r,
                n = this.localeData().eras();
              for (e = 0, t = n.length; e < t; ++e) {
                if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until) return n[e].name;
                if (n[e].until <= r && r <= n[e].since) return n[e].name;
              }
              return "";
            }, Sr.eraNarrow = function () {
              var e,
                t,
                r,
                n = this.localeData().eras();
              for (e = 0, t = n.length; e < t; ++e) {
                if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until) return n[e].narrow;
                if (n[e].until <= r && r <= n[e].since) return n[e].narrow;
              }
              return "";
            }, Sr.eraAbbr = function () {
              var e,
                t,
                r,
                n = this.localeData().eras();
              for (e = 0, t = n.length; e < t; ++e) {
                if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until) return n[e].abbr;
                if (n[e].until <= r && r <= n[e].since) return n[e].abbr;
              }
              return "";
            }, Sr.eraYear = function () {
              var e,
                t,
                r,
                a,
                s = this.localeData().eras();
              for (e = 0, t = s.length; e < t; ++e) if (r = s[e].since <= s[e].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), s[e].since <= a && a <= s[e].until || s[e].until <= a && a <= s[e].since) return (this.year() - n(s[e].since).year()) * r + s[e].offset;
              return this.year();
            }, Sr.year = Ve, Sr.isLeapYear = function () {
              return j(this.year());
            }, Sr.weekYear = function (e) {
              return yr.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
            }, Sr.isoWeekYear = function (e) {
              return yr.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
            }, Sr.quarter = Sr.quarters = function (e) {
              return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
            }, Sr.month = Le, Sr.daysInMonth = function () {
              return Pe(this.year(), this.month());
            }, Sr.week = Sr.weeks = function (e) {
              var t = this.localeData().week(this);
              return null == e ? t : this.add(7 * (e - t), "d");
            }, Sr.isoWeek = Sr.isoWeeks = function (e) {
              var t = We(this, 1, 4).week;
              return null == e ? t : this.add(7 * (e - t), "d");
            }, Sr.weeksInYear = function () {
              var e = this.localeData()._week;
              return ze(this.year(), e.dow, e.doy);
            }, Sr.weeksInWeekYear = function () {
              var e = this.localeData()._week;
              return ze(this.weekYear(), e.dow, e.doy);
            }, Sr.isoWeeksInYear = function () {
              return ze(this.year(), 1, 4);
            }, Sr.isoWeeksInISOWeekYear = function () {
              return ze(this.isoWeekYear(), 1, 4);
            }, Sr.date = kr, Sr.day = Sr.days = function (e) {
              if (!this.isValid()) return null != e ? this : NaN;
              var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
              return null != e ? (e = function (e, t) {
                return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
              }(e, this.localeData()), this.add(e - t, "d")) : t;
            }, Sr.weekday = function (e) {
              if (!this.isValid()) return null != e ? this : NaN;
              var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
              return null == e ? t : this.add(e - t, "d");
            }, Sr.isoWeekday = function (e) {
              if (!this.isValid()) return null != e ? this : NaN;
              if (null != e) {
                var t = function (e, t) {
                  return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
                }(e, this.localeData());
                return this.day(this.day() % 7 ? t : t - 7);
              }
              return this.day() || 7;
            }, Sr.dayOfYear = function (e) {
              var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
              return null == e ? t : this.add(e - t, "d");
            }, Sr.hour = Sr.hours = ot, Sr.minute = Sr.minutes = xr, Sr.second = Sr.seconds = _r, Sr.millisecond = Sr.milliseconds = Er, Sr.utcOffset = function (e, t, r) {
              var a,
                s = this._offset || 0;
              if (!this.isValid()) return null != e ? this : NaN;
              if (null != e) {
                if ("string" == typeof e) {
                  if (null === (e = jt(de, e))) return this;
                } else Math.abs(e) < 16 && !r && (e *= 60);
                return !this._isUTC && t && (a = Wt(this)), this._offset = e, this._isUTC = !0, null != a && this.add(a, "m"), s !== e && (!t || this._changeInProgress ? er(this, Jt(e - s, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, n.updateOffset(this, !0), this._changeInProgress = null)), this;
              }
              return this._isUTC ? s : Wt(this);
            }, Sr.utc = function (e) {
              return this.utcOffset(0, e);
            }, Sr.local = function (e) {
              return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Wt(this), "m")), this;
            }, Sr.parseZone = function () {
              if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
                var e = jt(fe, this._i);
                null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
              }
              return this;
            }, Sr.hasAlignedHourOffset = function (e) {
              return !!this.isValid() && (e = e ? qt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
            }, Sr.isDST = function () {
              return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
            }, Sr.isLocal = function () {
              return !!this.isValid() && !this._isUTC;
            }, Sr.isUtcOffset = function () {
              return !!this.isValid() && this._isUTC;
            }, Sr.isUtc = zt, Sr.isUTC = zt, Sr.zoneAbbr = function () {
              return this._isUTC ? "UTC" : "";
            }, Sr.zoneName = function () {
              return this._isUTC ? "Coordinated Universal Time" : "";
            }, Sr.dates = T("dates accessor is deprecated. Use date instead.", kr), Sr.months = T("months accessor is deprecated. Use month instead", Le), Sr.years = T("years accessor is deprecated. Use year instead", Ve), Sr.zone = T("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
              return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
            }), Sr.isDSTShifted = T("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
              if (!u(this._isDSTShifted)) return this._isDSTShifted;
              var e,
                t = {};
              return y(t, this), (t = Ot(t))._a ? (e = t._isUTC ? l(t._a) : qt(t._a), this._isDSTShifted = this.isValid() && function (e, t, r) {
                var n,
                  a = Math.min(e.length, t.length),
                  s = Math.abs(e.length - t.length),
                  o = 0;
                for (n = 0; n < a; n++) (r && e[n] !== t[n] || !r && W(e[n]) !== W(t[n])) && o++;
                return o + s;
              }(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
            });
            var Dr = D.prototype;
            function Pr(e, t, r, n) {
              var a = vt(),
                s = l().set(n, t);
              return a[r](s, e);
            }
            function Ir(e, t, r) {
              if (c(e) && (t = e, e = void 0), e = e || "", null != t) return Pr(e, t, r, "month");
              var n,
                a = [];
              for (n = 0; n < 12; n++) a[n] = Pr(e, n, r, "month");
              return a;
            }
            function Or(e, t, r, n) {
              "boolean" == typeof e ? (c(t) && (r = t, t = void 0), t = t || "") : (r = t = e, e = !1, c(t) && (r = t, t = void 0), t = t || "");
              var a,
                s = vt(),
                o = e ? s._week.dow : 0,
                i = [];
              if (null != r) return Pr(t, (r + o) % 7, n, "day");
              for (a = 0; a < 7; a++) i[a] = Pr(t, (a + o) % 7, n, "day");
              return i;
            }
            Dr.calendar = function (e, t, r) {
              var n = this._calendar[e] || this._calendar.sameElse;
              return S(n) ? n.call(t, r) : n;
            }, Dr.longDateFormat = function (e) {
              var t = this._longDateFormat[e],
                r = this._longDateFormat[e.toUpperCase()];
              return t || !r ? t : (this._longDateFormat[e] = r.match(I).map(function (e) {
                return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
              }).join(""), this._longDateFormat[e]);
            }, Dr.invalidDate = function () {
              return this._invalidDate;
            }, Dr.ordinal = function (e) {
              return this._ordinal.replace("%d", e);
            }, Dr.preparse = Rr, Dr.postformat = Rr, Dr.relativeTime = function (e, t, r, n) {
              var a = this._relativeTime[r];
              return S(a) ? a(e, t, r, n) : a.replace(/%d/i, e);
            }, Dr.pastFuture = function (e, t) {
              var r = this._relativeTime[e > 0 ? "future" : "past"];
              return S(r) ? r(t) : r.replace(/%s/i, t);
            }, Dr.set = function (e) {
              var t, r;
              for (r in e) o(e, r) && (S(t = e[r]) ? this[r] = t : this["_" + r] = t);
              this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
            }, Dr.eras = function (e, t) {
              var r,
                a,
                s,
                o = this._eras || vt("en")._eras;
              for (r = 0, a = o.length; r < a; ++r) switch ("string" == typeof o[r].since && (s = n(o[r].since).startOf("day"), o[r].since = s.valueOf()), typeof o[r].until) {
                case "undefined":
                  o[r].until = 1 / 0;
                  break;
                case "string":
                  s = n(o[r].until).startOf("day").valueOf(), o[r].until = s.valueOf();
              }
              return o;
            }, Dr.erasParse = function (e, t, r) {
              var n,
                a,
                s,
                o,
                i,
                u = this.eras();
              for (e = e.toUpperCase(), n = 0, a = u.length; n < a; ++n) if (s = u[n].name.toUpperCase(), o = u[n].abbr.toUpperCase(), i = u[n].narrow.toUpperCase(), r) switch (t) {
                case "N":
                case "NN":
                case "NNN":
                  if (o === e) return u[n];
                  break;
                case "NNNN":
                  if (s === e) return u[n];
                  break;
                case "NNNNN":
                  if (i === e) return u[n];
              } else if ([s, o, i].indexOf(e) >= 0) return u[n];
            }, Dr.erasConvertYear = function (e, t) {
              var r = e.since <= e.until ? 1 : -1;
              return void 0 === t ? n(e.since).year() : n(e.since).year() + (t - e.offset) * r;
            }, Dr.erasAbbrRegex = function (e) {
              return o(this, "_erasAbbrRegex") || wr.call(this), e ? this._erasAbbrRegex : this._erasRegex;
            }, Dr.erasNameRegex = function (e) {
              return o(this, "_erasNameRegex") || wr.call(this), e ? this._erasNameRegex : this._erasRegex;
            }, Dr.erasNarrowRegex = function (e) {
              return o(this, "_erasNarrowRegex") || wr.call(this), e ? this._erasNarrowRegex : this._erasRegex;
            }, Dr.months = function (e, t) {
              return e ? a(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Ne).test(t) ? "format" : "standalone"][e.month()] : a(this._months) ? this._months : this._months.standalone;
            }, Dr.monthsShort = function (e, t) {
              return e ? a(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Ne.test(t) ? "format" : "standalone"][e.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
            }, Dr.monthsParse = function (e, t, r) {
              var n, a, s;
              if (this._monthsParseExact) return Me.call(this, e, t, r);
              for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
                if (a = l([2e3, n]), r && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(a, "").replace(".", "") + "$", "i"), this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(a, "").replace(".", "") + "$", "i")), r || this._monthsParse[n] || (s = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""), this._monthsParse[n] = new RegExp(s.replace(".", ""), "i")), r && "MMMM" === t && this._longMonthsParse[n].test(e)) return n;
                if (r && "MMM" === t && this._shortMonthsParse[n].test(e)) return n;
                if (!r && this._monthsParse[n].test(e)) return n;
              }
            }, Dr.monthsRegex = function (e) {
              return this._monthsParseExact ? (o(this, "_monthsRegex") || Fe.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = Ae), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
            }, Dr.monthsShortRegex = function (e) {
              return this._monthsParseExact ? (o(this, "_monthsRegex") || Fe.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = qe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
            }, Dr.week = function (e) {
              return We(e, this._week.dow, this._week.doy).week;
            }, Dr.firstDayOfYear = function () {
              return this._week.doy;
            }, Dr.firstDayOfWeek = function () {
              return this._week.dow;
            }, Dr.weekdays = function (e, t) {
              var r = a(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
              return !0 === e ? $e(r, this._week.dow) : e ? r[e.day()] : r;
            }, Dr.weekdaysMin = function (e) {
              return !0 === e ? $e(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
            }, Dr.weekdaysShort = function (e) {
              return !0 === e ? $e(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
            }, Dr.weekdaysParse = function (e, t, r) {
              var n, a, s;
              if (this._weekdaysParseExact) return tt.call(this, e, t, r);
              for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
                if (a = l([2e3, 1]).day(n), r && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(a, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[n] || (s = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""), this._weekdaysParse[n] = new RegExp(s.replace(".", ""), "i")), r && "dddd" === t && this._fullWeekdaysParse[n].test(e)) return n;
                if (r && "ddd" === t && this._shortWeekdaysParse[n].test(e)) return n;
                if (r && "dd" === t && this._minWeekdaysParse[n].test(e)) return n;
                if (!r && this._weekdaysParse[n].test(e)) return n;
              }
            }, Dr.weekdaysRegex = function (e) {
              return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Ke), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
            }, Dr.weekdaysShortRegex = function (e) {
              return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Qe), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
            }, Dr.weekdaysMinRegex = function (e) {
              return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = et), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
            }, Dr.isPM = function (e) {
              return "p" === (e + "").toLowerCase().charAt(0);
            }, Dr.meridiem = function (e, t, r) {
              return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
            }, ht("en", {
              eras: [{
                since: "0001-01-01",
                until: 1 / 0,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
              }, {
                since: "0000-12-31",
                until: -1 / 0,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
              }],
              dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
              ordinal: function ordinal(e) {
                var t = e % 10;
                return e + (1 === W(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
              }
            }), n.lang = T("moment.lang is deprecated. Use moment.locale instead.", ht), n.langData = T("moment.langData is deprecated. Use moment.localeData instead.", vt);
            var Nr = Math.abs;
            function qr(e, t, r, n) {
              var a = Jt(t, r);
              return e._milliseconds += n * a._milliseconds, e._days += n * a._days, e._months += n * a._months, e._bubble();
            }
            function Ar(e) {
              return e < 0 ? Math.floor(e) : Math.ceil(e);
            }
            function Mr(e) {
              return 4800 * e / 146097;
            }
            function Ur(e) {
              return 146097 * e / 4800;
            }
            function Lr(e) {
              return function () {
                return this.as(e);
              };
            }
            var Fr = Lr("ms"),
              Br = Lr("s"),
              Vr = Lr("m"),
              Gr = Lr("h"),
              Yr = Lr("d"),
              jr = Lr("w"),
              Hr = Lr("M"),
              Wr = Lr("Q"),
              zr = Lr("y");
            function $r(e) {
              return function () {
                return this.isValid() ? this._data[e] : NaN;
              };
            }
            var Zr = $r("milliseconds"),
              Jr = $r("seconds"),
              Xr = $r("minutes"),
              Kr = $r("hours"),
              Qr = $r("days"),
              en = $r("months"),
              tn = $r("years");
            var rn = Math.round,
              nn = {
                ss: 44,
                s: 45,
                m: 45,
                h: 22,
                d: 26,
                w: null,
                M: 11
              };
            function an(e, t, r, n, a) {
              return a.relativeTime(t || 1, !!r, e, n);
            }
            var sn = Math.abs;
            function on(e) {
              return (e > 0) - (e < 0) || +e;
            }
            function un() {
              if (!this.isValid()) return this.localeData().invalidDate();
              var e,
                t,
                r,
                n,
                a,
                s,
                o,
                i,
                u = sn(this._milliseconds) / 1e3,
                c = sn(this._days),
                f = sn(this._months),
                d = this.asSeconds();
              return d ? (e = H(u / 60), t = H(e / 60), u %= 60, e %= 60, r = H(f / 12), f %= 12, n = u ? u.toFixed(3).replace(/\.?0+$/, "") : "", a = d < 0 ? "-" : "", s = on(this._months) !== on(d) ? "-" : "", o = on(this._days) !== on(d) ? "-" : "", i = on(this._milliseconds) !== on(d) ? "-" : "", a + "P" + (r ? s + r + "Y" : "") + (f ? s + f + "M" : "") + (c ? o + c + "D" : "") + (t || e || u ? "T" : "") + (t ? i + t + "H" : "") + (e ? i + e + "M" : "") + (u ? i + n + "S" : "")) : "P0D";
            }
            var cn = Ft.prototype;
            return cn.isValid = function () {
              return this._isValid;
            }, cn.abs = function () {
              var e = this._data;
              return this._milliseconds = Nr(this._milliseconds), this._days = Nr(this._days), this._months = Nr(this._months), e.milliseconds = Nr(e.milliseconds), e.seconds = Nr(e.seconds), e.minutes = Nr(e.minutes), e.hours = Nr(e.hours), e.months = Nr(e.months), e.years = Nr(e.years), this;
            }, cn.add = function (e, t) {
              return qr(this, e, t, 1);
            }, cn.subtract = function (e, t) {
              return qr(this, e, t, -1);
            }, cn.as = function (e) {
              if (!this.isValid()) return NaN;
              var t,
                r,
                n = this._milliseconds;
              if ("month" === (e = B(e)) || "quarter" === e || "year" === e) switch (t = this._days + n / 864e5, r = this._months + Mr(t), e) {
                case "month":
                  return r;
                case "quarter":
                  return r / 3;
                case "year":
                  return r / 12;
              } else switch (t = this._days + Math.round(Ur(this._months)), e) {
                case "week":
                  return t / 7 + n / 6048e5;
                case "day":
                  return t + n / 864e5;
                case "hour":
                  return 24 * t + n / 36e5;
                case "minute":
                  return 1440 * t + n / 6e4;
                case "second":
                  return 86400 * t + n / 1e3;
                case "millisecond":
                  return Math.floor(864e5 * t) + n;
                default:
                  throw new Error("Unknown unit " + e);
              }
            }, cn.asMilliseconds = Fr, cn.asSeconds = Br, cn.asMinutes = Vr, cn.asHours = Gr, cn.asDays = Yr, cn.asWeeks = jr, cn.asMonths = Hr, cn.asQuarters = Wr, cn.asYears = zr, cn.valueOf = function () {
              return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * W(this._months / 12) : NaN;
            }, cn._bubble = function () {
              var e,
                t,
                r,
                n,
                a,
                s = this._milliseconds,
                o = this._days,
                i = this._months,
                u = this._data;
              return s >= 0 && o >= 0 && i >= 0 || s <= 0 && o <= 0 && i <= 0 || (s += 864e5 * Ar(Ur(i) + o), o = 0, i = 0), u.milliseconds = s % 1e3, e = H(s / 1e3), u.seconds = e % 60, t = H(e / 60), u.minutes = t % 60, r = H(t / 60), u.hours = r % 24, o += H(r / 24), i += a = H(Mr(o)), o -= Ar(Ur(a)), n = H(i / 12), i %= 12, u.days = o, u.months = i, u.years = n, this;
            }, cn.clone = function () {
              return Jt(this);
            }, cn.get = function (e) {
              return e = B(e), this.isValid() ? this[e + "s"]() : NaN;
            }, cn.milliseconds = Zr, cn.seconds = Jr, cn.minutes = Xr, cn.hours = Kr, cn.days = Qr, cn.weeks = function () {
              return H(this.days() / 7);
            }, cn.months = en, cn.years = tn, cn.humanize = function (e, t) {
              if (!this.isValid()) return this.localeData().invalidDate();
              var r,
                n,
                a = !1,
                s = nn;
              return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (a = e), "object" == typeof t && (s = Object.assign({}, nn, t), null != t.s && null == t.ss && (s.ss = t.s - 1)), n = function (e, t, r, n) {
                var a = Jt(e).abs(),
                  s = rn(a.as("s")),
                  o = rn(a.as("m")),
                  i = rn(a.as("h")),
                  u = rn(a.as("d")),
                  c = rn(a.as("M")),
                  f = rn(a.as("w")),
                  d = rn(a.as("y")),
                  p = s <= r.ss && ["s", s] || s < r.s && ["ss", s] || o <= 1 && ["m"] || o < r.m && ["mm", o] || i <= 1 && ["h"] || i < r.h && ["hh", i] || u <= 1 && ["d"] || u < r.d && ["dd", u];
                return null != r.w && (p = p || f <= 1 && ["w"] || f < r.w && ["ww", f]), (p = p || c <= 1 && ["M"] || c < r.M && ["MM", c] || d <= 1 && ["y"] || ["yy", d])[2] = t, p[3] = +e > 0, p[4] = n, an.apply(null, p);
              }(this, !a, s, r = this.localeData()), a && (n = r.pastFuture(+this, n)), r.postformat(n);
            }, cn.toISOString = un, cn.toString = un, cn.toJSON = un, cn.locale = or, cn.localeData = ur, cn.toIsoString = T("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", un), cn.lang = ir, A("X", 0, 0, "unix"), A("x", 0, 0, "valueOf"), le("x", ce), le("X", /[+-]?\d+(\.\d{1,3})?/), we("X", function (e, t, r) {
              r._d = new Date(1e3 * parseFloat(e));
            }), we("x", function (e, t, r) {
              r._d = new Date(W(e));
            }), n.version = "2.29.4", t = qt, n.fn = Sr, n.min = function () {
              return Ut("isBefore", [].slice.call(arguments, 0));
            }, n.max = function () {
              return Ut("isAfter", [].slice.call(arguments, 0));
            }, n.now = function () {
              return Date.now ? Date.now() : +new Date();
            }, n.utc = l, n.unix = function (e) {
              return qt(1e3 * e);
            }, n.months = function (e, t) {
              return Ir(e, t, "months");
            }, n.isDate = f, n.locale = ht, n.invalid = v, n.duration = Jt, n.isMoment = k, n.weekdays = function (e, t, r) {
              return Or(e, t, r, "weekdays");
            }, n.parseZone = function () {
              return qt.apply(null, arguments).parseZone();
            }, n.localeData = vt, n.isDuration = Bt, n.monthsShort = function (e, t) {
              return Ir(e, t, "monthsShort");
            }, n.weekdaysMin = function (e, t, r) {
              return Or(e, t, r, "weekdaysMin");
            }, n.defineLocale = mt, n.updateLocale = function (e, t) {
              if (null != t) {
                var r,
                  n,
                  a = ut;
                null != ct[e] && null != ct[e].parentLocale ? ct[e].set(R(ct[e]._config, t)) : (null != (n = lt(e)) && (a = n._config), t = R(a, t), null == n && (t.abbr = e), (r = new D(t)).parentLocale = ct[e], ct[e] = r), ht(e);
              } else null != ct[e] && (null != ct[e].parentLocale ? (ct[e] = ct[e].parentLocale, e === ht() && ht(e)) : null != ct[e] && delete ct[e]);
              return ct[e];
            }, n.locales = function () {
              return E(ct);
            }, n.weekdaysShort = function (e, t, r) {
              return Or(e, t, r, "weekdaysShort");
            }, n.normalizeUnits = B, n.relativeTimeRounding = function (e) {
              return void 0 === e ? rn : "function" == typeof e && (rn = e, !0);
            }, n.relativeTimeThreshold = function (e, t) {
              return void 0 !== nn[e] && (void 0 === t ? nn[e] : (nn[e] = t, "s" === e && (nn.ss = t - 1), !0));
            }, n.calendarFormat = function (e, t) {
              var r = e.diff(t, "days", !0);
              return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
            }, n.prototype = Sr, n.HTML5_FMT = {
              DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
              DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
              DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
              DATE: "YYYY-MM-DD",
              TIME: "HH:mm",
              TIME_SECONDS: "HH:mm:ss",
              TIME_MS: "HH:mm:ss.SSS",
              WEEK: "GGGG-[W]WW",
              MONTH: "YYYY-MM"
            }, n;
          }();
        },
        7824: function _(e) {
          var t = 1e3,
            r = 60 * t,
            n = 60 * r,
            a = 24 * n;
          function s(e, t, r, n) {
            var a = t >= 1.5 * r;
            return Math.round(e / r) + " " + n + (a ? "s" : "");
          }
          e.exports = function (e, o) {
            o = o || {};
            var i,
              u,
              c = typeof e;
            if ("string" === c && e.length > 0) return function (e) {
              if (!((e = String(e)).length > 100)) {
                var s = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);
                if (s) {
                  var o = parseFloat(s[1]);
                  switch ((s[2] || "ms").toLowerCase()) {
                    case "years":
                    case "year":
                    case "yrs":
                    case "yr":
                    case "y":
                      return 315576e5 * o;
                    case "weeks":
                    case "week":
                    case "w":
                      return 6048e5 * o;
                    case "days":
                    case "day":
                    case "d":
                      return o * a;
                    case "hours":
                    case "hour":
                    case "hrs":
                    case "hr":
                    case "h":
                      return o * n;
                    case "minutes":
                    case "minute":
                    case "mins":
                    case "min":
                    case "m":
                      return o * r;
                    case "seconds":
                    case "second":
                    case "secs":
                    case "sec":
                    case "s":
                      return o * t;
                    case "milliseconds":
                    case "millisecond":
                    case "msecs":
                    case "msec":
                    case "ms":
                      return o;
                    default:
                      return;
                  }
                }
              }
            }(e);
            if ("number" === c && isFinite(e)) return o["long"] ? (i = e, (u = Math.abs(i)) >= a ? s(i, u, a, "day") : u >= n ? s(i, u, n, "hour") : u >= r ? s(i, u, r, "minute") : u >= t ? s(i, u, t, "second") : i + " ms") : function (e) {
              var s = Math.abs(e);
              return s >= a ? Math.round(e / a) + "d" : s >= n ? Math.round(e / n) + "h" : s >= r ? Math.round(e / r) + "m" : s >= t ? Math.round(e / t) + "s" : e + "ms";
            }(e);
            throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
          };
        },
        8322: function _(e) {
          e.exports = function (e) {
            "use strict";

            var t = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
            function r(e, t) {
              var r = e[0],
                n = e[1],
                a = e[2],
                s = e[3];
              n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & a | ~n & s) + t[0] - 680876936 | 0) << 7 | r >>> 25) + n | 0) & n | ~r & a) + t[1] - 389564586 | 0) << 12 | s >>> 20) + r | 0) & r | ~s & n) + t[2] + 606105819 | 0) << 17 | a >>> 15) + s | 0) & s | ~a & r) + t[3] - 1044525330 | 0) << 22 | n >>> 10) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & a | ~n & s) + t[4] - 176418897 | 0) << 7 | r >>> 25) + n | 0) & n | ~r & a) + t[5] + 1200080426 | 0) << 12 | s >>> 20) + r | 0) & r | ~s & n) + t[6] - 1473231341 | 0) << 17 | a >>> 15) + s | 0) & s | ~a & r) + t[7] - 45705983 | 0) << 22 | n >>> 10) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & a | ~n & s) + t[8] + 1770035416 | 0) << 7 | r >>> 25) + n | 0) & n | ~r & a) + t[9] - 1958414417 | 0) << 12 | s >>> 20) + r | 0) & r | ~s & n) + t[10] - 42063 | 0) << 17 | a >>> 15) + s | 0) & s | ~a & r) + t[11] - 1990404162 | 0) << 22 | n >>> 10) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & a | ~n & s) + t[12] + 1804603682 | 0) << 7 | r >>> 25) + n | 0) & n | ~r & a) + t[13] - 40341101 | 0) << 12 | s >>> 20) + r | 0) & r | ~s & n) + t[14] - 1502002290 | 0) << 17 | a >>> 15) + s | 0) & s | ~a & r) + t[15] + 1236535329 | 0) << 22 | n >>> 10) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & s | a & ~s) + t[1] - 165796510 | 0) << 5 | r >>> 27) + n | 0) & a | n & ~a) + t[6] - 1069501632 | 0) << 9 | s >>> 23) + r | 0) & n | r & ~n) + t[11] + 643717713 | 0) << 14 | a >>> 18) + s | 0) & r | s & ~r) + t[0] - 373897302 | 0) << 20 | n >>> 12) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & s | a & ~s) + t[5] - 701558691 | 0) << 5 | r >>> 27) + n | 0) & a | n & ~a) + t[10] + 38016083 | 0) << 9 | s >>> 23) + r | 0) & n | r & ~n) + t[15] - 660478335 | 0) << 14 | a >>> 18) + s | 0) & r | s & ~r) + t[4] - 405537848 | 0) << 20 | n >>> 12) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & s | a & ~s) + t[9] + 568446438 | 0) << 5 | r >>> 27) + n | 0) & a | n & ~a) + t[14] - 1019803690 | 0) << 9 | s >>> 23) + r | 0) & n | r & ~n) + t[3] - 187363961 | 0) << 14 | a >>> 18) + s | 0) & r | s & ~r) + t[8] + 1163531501 | 0) << 20 | n >>> 12) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n & s | a & ~s) + t[13] - 1444681467 | 0) << 5 | r >>> 27) + n | 0) & a | n & ~a) + t[2] - 51403784 | 0) << 9 | s >>> 23) + r | 0) & n | r & ~n) + t[7] + 1735328473 | 0) << 14 | a >>> 18) + s | 0) & r | s & ~r) + t[12] - 1926607734 | 0) << 20 | n >>> 12) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n ^ a ^ s) + t[5] - 378558 | 0) << 4 | r >>> 28) + n | 0) ^ n ^ a) + t[8] - 2022574463 | 0) << 11 | s >>> 21) + r | 0) ^ r ^ n) + t[11] + 1839030562 | 0) << 16 | a >>> 16) + s | 0) ^ s ^ r) + t[14] - 35309556 | 0) << 23 | n >>> 9) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n ^ a ^ s) + t[1] - 1530992060 | 0) << 4 | r >>> 28) + n | 0) ^ n ^ a) + t[4] + 1272893353 | 0) << 11 | s >>> 21) + r | 0) ^ r ^ n) + t[7] - 155497632 | 0) << 16 | a >>> 16) + s | 0) ^ s ^ r) + t[10] - 1094730640 | 0) << 23 | n >>> 9) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n ^ a ^ s) + t[13] + 681279174 | 0) << 4 | r >>> 28) + n | 0) ^ n ^ a) + t[0] - 358537222 | 0) << 11 | s >>> 21) + r | 0) ^ r ^ n) + t[3] - 722521979 | 0) << 16 | a >>> 16) + s | 0) ^ s ^ r) + t[6] + 76029189 | 0) << 23 | n >>> 9) + a | 0, n = ((n += ((a = ((a += ((s = ((s += ((r = ((r += (n ^ a ^ s) + t[9] - 640364487 | 0) << 4 | r >>> 28) + n | 0) ^ n ^ a) + t[12] - 421815835 | 0) << 11 | s >>> 21) + r | 0) ^ r ^ n) + t[15] + 530742520 | 0) << 16 | a >>> 16) + s | 0) ^ s ^ r) + t[2] - 995338651 | 0) << 23 | n >>> 9) + a | 0, n = ((n += ((s = ((s += (n ^ ((r = ((r += (a ^ (n | ~s)) + t[0] - 198630844 | 0) << 6 | r >>> 26) + n | 0) | ~a)) + t[7] + 1126891415 | 0) << 10 | s >>> 22) + r | 0) ^ ((a = ((a += (r ^ (s | ~n)) + t[14] - 1416354905 | 0) << 15 | a >>> 17) + s | 0) | ~r)) + t[5] - 57434055 | 0) << 21 | n >>> 11) + a | 0, n = ((n += ((s = ((s += (n ^ ((r = ((r += (a ^ (n | ~s)) + t[12] + 1700485571 | 0) << 6 | r >>> 26) + n | 0) | ~a)) + t[3] - 1894986606 | 0) << 10 | s >>> 22) + r | 0) ^ ((a = ((a += (r ^ (s | ~n)) + t[10] - 1051523 | 0) << 15 | a >>> 17) + s | 0) | ~r)) + t[1] - 2054922799 | 0) << 21 | n >>> 11) + a | 0, n = ((n += ((s = ((s += (n ^ ((r = ((r += (a ^ (n | ~s)) + t[8] + 1873313359 | 0) << 6 | r >>> 26) + n | 0) | ~a)) + t[15] - 30611744 | 0) << 10 | s >>> 22) + r | 0) ^ ((a = ((a += (r ^ (s | ~n)) + t[6] - 1560198380 | 0) << 15 | a >>> 17) + s | 0) | ~r)) + t[13] + 1309151649 | 0) << 21 | n >>> 11) + a | 0, n = ((n += ((s = ((s += (n ^ ((r = ((r += (a ^ (n | ~s)) + t[4] - 145523070 | 0) << 6 | r >>> 26) + n | 0) | ~a)) + t[11] - 1120210379 | 0) << 10 | s >>> 22) + r | 0) ^ ((a = ((a += (r ^ (s | ~n)) + t[2] + 718787259 | 0) << 15 | a >>> 17) + s | 0) | ~r)) + t[9] - 343485551 | 0) << 21 | n >>> 11) + a | 0, e[0] = r + e[0] | 0, e[1] = n + e[1] | 0, e[2] = a + e[2] | 0, e[3] = s + e[3] | 0;
            }
            function n(e) {
              var t,
                r = [];
              for (t = 0; t < 64; t += 4) r[t >> 2] = e.charCodeAt(t) + (e.charCodeAt(t + 1) << 8) + (e.charCodeAt(t + 2) << 16) + (e.charCodeAt(t + 3) << 24);
              return r;
            }
            function a(e) {
              var t,
                r = [];
              for (t = 0; t < 64; t += 4) r[t >> 2] = e[t] + (e[t + 1] << 8) + (e[t + 2] << 16) + (e[t + 3] << 24);
              return r;
            }
            function s(e) {
              var t,
                a,
                s,
                o,
                i,
                u,
                c = e.length,
                f = [1732584193, -271733879, -1732584194, 271733878];
              for (t = 64; t <= c; t += 64) r(f, n(e.substring(t - 64, t)));
              for (a = (e = e.substring(t - 64)).length, s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], t = 0; t < a; t += 1) s[t >> 2] |= e.charCodeAt(t) << (t % 4 << 3);
              if (s[t >> 2] |= 128 << (t % 4 << 3), t > 55) for (r(f, s), t = 0; t < 16; t += 1) s[t] = 0;
              return o = (o = 8 * c).toString(16).match(/(.*?)(.{0,8})$/), i = parseInt(o[2], 16), u = parseInt(o[1], 16) || 0, s[14] = i, s[15] = u, r(f, s), f;
            }
            function o(e) {
              var r,
                n = "";
              for (r = 0; r < 4; r += 1) n += t[e >> 8 * r + 4 & 15] + t[e >> 8 * r & 15];
              return n;
            }
            function i(e) {
              var t;
              for (t = 0; t < e.length; t += 1) e[t] = o(e[t]);
              return e.join("");
            }
            function u(e) {
              return /[\u0080-\uFFFF]/.test(e) && (e = unescape(encodeURIComponent(e))), e;
            }
            function c(e) {
              var t,
                r = [],
                n = e.length;
              for (t = 0; t < n - 1; t += 2) r.push(parseInt(e.substr(t, 2), 16));
              return String.fromCharCode.apply(String, r);
            }
            function f() {
              this.reset();
            }
            return i(s("hello")), "undefined" == typeof ArrayBuffer || ArrayBuffer.prototype.slice || function () {
              function e(e, t) {
                return (e = 0 | e || 0) < 0 ? Math.max(e + t, 0) : Math.min(e, t);
              }
              ArrayBuffer.prototype.slice = function (t, r) {
                var n,
                  a,
                  s,
                  o,
                  i = this.byteLength,
                  u = e(t, i),
                  c = i;
                return undefined !== r && (c = e(r, i)), u > c ? new ArrayBuffer(0) : (n = c - u, a = new ArrayBuffer(n), s = new Uint8Array(a), o = new Uint8Array(this, u, n), s.set(o), a);
              };
            }(), f.prototype.append = function (e) {
              return this.appendBinary(u(e)), this;
            }, f.prototype.appendBinary = function (e) {
              this._buff += e, this._length += e.length;
              var t,
                a = this._buff.length;
              for (t = 64; t <= a; t += 64) r(this._hash, n(this._buff.substring(t - 64, t)));
              return this._buff = this._buff.substring(t - 64), this;
            }, f.prototype.end = function (e) {
              var t,
                r,
                n = this._buff,
                a = n.length,
                s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              for (t = 0; t < a; t += 1) s[t >> 2] |= n.charCodeAt(t) << (t % 4 << 3);
              return this._finish(s, a), r = i(this._hash), e && (r = c(r)), this.reset(), r;
            }, f.prototype.reset = function () {
              return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
            }, f.prototype.getState = function () {
              return {
                buff: this._buff,
                length: this._length,
                hash: this._hash.slice()
              };
            }, f.prototype.setState = function (e) {
              return this._buff = e.buff, this._length = e.length, this._hash = e.hash, this;
            }, f.prototype.destroy = function () {
              delete this._hash, delete this._buff, delete this._length;
            }, f.prototype._finish = function (e, t) {
              var n,
                a,
                s,
                o = t;
              if (e[o >> 2] |= 128 << (o % 4 << 3), o > 55) for (r(this._hash, e), o = 0; o < 16; o += 1) e[o] = 0;
              n = (n = 8 * this._length).toString(16).match(/(.*?)(.{0,8})$/), a = parseInt(n[2], 16), s = parseInt(n[1], 16) || 0, e[14] = a, e[15] = s, r(this._hash, e);
            }, f.hash = function (e, t) {
              return f.hashBinary(u(e), t);
            }, f.hashBinary = function (e, t) {
              var r = i(s(e));
              return t ? c(r) : r;
            }, f.ArrayBuffer = function () {
              this.reset();
            }, f.ArrayBuffer.prototype.append = function (e) {
              var t,
                n,
                s,
                o,
                i,
                u = (n = this._buff.buffer, s = e, o = !0, (i = new Uint8Array(n.byteLength + s.byteLength)).set(new Uint8Array(n)), i.set(new Uint8Array(s), n.byteLength), o ? i : i.buffer),
                c = u.length;
              for (this._length += e.byteLength, t = 64; t <= c; t += 64) r(this._hash, a(u.subarray(t - 64, t)));
              return this._buff = t - 64 < c ? new Uint8Array(u.buffer.slice(t - 64)) : new Uint8Array(0), this;
            }, f.ArrayBuffer.prototype.end = function (e) {
              var t,
                r,
                n = this._buff,
                a = n.length,
                s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              for (t = 0; t < a; t += 1) s[t >> 2] |= n[t] << (t % 4 << 3);
              return this._finish(s, a), r = i(this._hash), e && (r = c(r)), this.reset(), r;
            }, f.ArrayBuffer.prototype.reset = function () {
              return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
            }, f.ArrayBuffer.prototype.getState = function () {
              var e,
                t = f.prototype.getState.call(this);
              return t.buff = (e = t.buff, String.fromCharCode.apply(null, new Uint8Array(e))), t;
            }, f.ArrayBuffer.prototype.setState = function (e) {
              return e.buff = function (e, t) {
                var r,
                  n = e.length,
                  a = new ArrayBuffer(n),
                  s = new Uint8Array(a);
                for (r = 0; r < n; r += 1) s[r] = e.charCodeAt(r);
                return t ? s : a;
              }(e.buff, !0), f.prototype.setState.call(this, e);
            }, f.ArrayBuffer.prototype.destroy = f.prototype.destroy, f.ArrayBuffer.prototype._finish = f.prototype._finish, f.ArrayBuffer.hash = function (e, t) {
              var n = i(function (e) {
                var t,
                  n,
                  s,
                  o,
                  i,
                  u,
                  c = e.length,
                  f = [1732584193, -271733879, -1732584194, 271733878];
                for (t = 64; t <= c; t += 64) r(f, a(e.subarray(t - 64, t)));
                for (n = (e = t - 64 < c ? e.subarray(t - 64) : new Uint8Array(0)).length, s = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], t = 0; t < n; t += 1) s[t >> 2] |= e[t] << (t % 4 << 3);
                if (s[t >> 2] |= 128 << (t % 4 << 3), t > 55) for (r(f, s), t = 0; t < 16; t += 1) s[t] = 0;
                return o = (o = 8 * c).toString(16).match(/(.*?)(.{0,8})$/), i = parseInt(o[2], 16), u = parseInt(o[1], 16) || 0, s[14] = i, s[15] = u, r(f, s), f;
              }(new Uint8Array(e)));
              return t ? c(n) : n;
            }, f;
          }();
        },
        2130: function _(e, t, r) {
          "use strict";

          var n = r(2037),
            a = r(6560),
            s = {
              TARGET_ENV: "PRODUCTION"
            };
          var o;
          function i(e) {
            var t = function (e) {
              if (!1 === o) return 0;
              if (a("color=16m") || a("color=full") || a("color=truecolor")) return 3;
              if (a("color=256")) return 2;
              if (e && !e.isTTY && !0 !== o) return 0;
              var t = o ? 1 : 0;
              if ("win32" === process.platform) {
                var _e3 = n.release().split(".");
                return Number(process.versions.node.split(".")[0]) >= 8 && Number(_e3[0]) >= 10 && Number(_e3[2]) >= 10586 ? Number(_e3[2]) >= 14931 ? 3 : 2 : 1;
              }
              if ("CI" in s) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(function (e) {
                return e in s;
              }) || "codeship" === s.CI_NAME ? 1 : t;
              if ("TEAMCITY_VERSION" in s) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(s.TEAMCITY_VERSION) ? 1 : 0;
              if ("truecolor" === s.COLORTERM) return 3;
              if ("TERM_PROGRAM" in s) {
                var _e4 = parseInt((s.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
                switch (s.TERM_PROGRAM) {
                  case "iTerm.app":
                    return _e4 >= 3 ? 3 : 2;
                  case "Apple_Terminal":
                    return 2;
                }
              }
              return /-256(color)?$/i.test(s.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(s.TERM) || "COLORTERM" in s ? 1 : t;
            }(e);
            return function (e) {
              return 0 !== e && {
                level: e,
                hasBasic: !0,
                has256: e >= 2,
                has16m: e >= 3
              };
            }(t);
          }
          a("no-color") || a("no-colors") || a("color=false") ? o = !1 : (a("color") || a("colors") || a("color=true") || a("color=always")) && (o = !0), "FORCE_COLOR" in s && (o = 0 === s.FORCE_COLOR.length || 0 !== parseInt(s.FORCE_COLOR, 10)), e.exports = {
            supportsColor: i,
            stdout: i(process.stdout),
            stderr: i(process.stderr)
          };
        },
        9491: function _(e) {
          "use strict";

          e.exports = require("assert");
        },
        3685: function _(e) {
          "use strict";

          e.exports = require("http");
        },
        5687: function _(e) {
          "use strict";

          e.exports = require("https");
        },
        2037: function _(e) {
          "use strict";

          e.exports = require("os");
        },
        2781: function _(e) {
          "use strict";

          e.exports = require("stream");
        },
        6224: function _(e) {
          "use strict";

          e.exports = require("tty");
        },
        7310: function _(e) {
          "use strict";

          e.exports = require("url");
        },
        3837: function _(e) {
          "use strict";

          e.exports = require("util");
        },
        9796: function _(e) {
          "use strict";

          e.exports = require("zlib");
        },
        3897: function _(e) {
          e.exports = function (e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
            return n;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3405: function _(e, t, r) {
          var n = r(3897);
          e.exports = function (e) {
            if (Array.isArray(e)) return n(e);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6115: function _(e) {
          e.exports = function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        7156: function _(e) {
          function t(e, t, r, n, a, s, o) {
            try {
              var i = e[s](o),
                u = i.value;
            } catch (e) {
              return void r(e);
            }
            i.done ? t(u) : Promise.resolve(u).then(n, a);
          }
          e.exports = function (e) {
            return function () {
              var r = this,
                n = arguments;
              return new Promise(function (a, s) {
                var o = e.apply(r, n);
                function i(e) {
                  t(o, a, s, i, u, "next", e);
                }
                function u(e) {
                  t(o, a, s, i, u, "throw", e);
                }
                i(void 0);
              });
            };
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6690: function _(e) {
          e.exports = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3515: function _(e, t, r) {
          var n = r(6015),
            a = r(9617);
          function s(t, r, o) {
            return a() ? (e.exports = s = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports["default"] = e.exports) : (e.exports = s = function s(e, t, r) {
              var a = [null];
              a.push.apply(a, t);
              var s = new (Function.bind.apply(e, a))();
              return r && n(s, r.prototype), s;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports), s.apply(null, arguments);
          }
          e.exports = s, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        9728: function _(e, t, r) {
          var n = r(4062);
          function a(e, t) {
            for (var r = 0; r < t.length; r++) {
              var a = t[r];
              a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, n(a.key), a);
            }
          }
          e.exports = function (e, t, r) {
            return t && a(e.prototype, t), r && a(e, r), Object.defineProperty(e, "prototype", {
              writable: !1
            }), e;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        8416: function _(e, t, r) {
          var n = r(4062);
          e.exports = function (e, t, r) {
            return (t = n(t)) in e ? Object.defineProperty(e, t, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = r, e;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3808: function _(e) {
          function t(r) {
            return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(r);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        1655: function _(e, t, r) {
          var n = r(6015);
          e.exports = function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && n(e, t);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6035: function _(e) {
          e.exports = function (e) {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        9617: function _(e) {
          e.exports = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        9498: function _(e) {
          e.exports = function (e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        2281: function _(e) {
          e.exports = function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        4993: function _(e, t, r) {
          var n = r(8698)["default"],
            a = r(6115);
          e.exports = function (e, t) {
            if (t && ("object" === n(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return a(e);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        7061: function _(e, t, r) {
          var n = r(8698)["default"];
          function a() {
            "use strict";

            e.exports = a = function a() {
              return t;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
            var t = {},
              r = Object.prototype,
              s = r.hasOwnProperty,
              o = Object.defineProperty || function (e, t, r) {
                e[t] = r.value;
              },
              i = "function" == typeof Symbol ? Symbol : {},
              u = i.iterator || "@@iterator",
              c = i.asyncIterator || "@@asyncIterator",
              f = i.toStringTag || "@@toStringTag";
            function d(e, t, r) {
              return Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), e[t];
            }
            try {
              d({}, "");
            } catch (e) {
              d = function d(e, t, r) {
                return e[t] = r;
              };
            }
            function p(e, t, r, n) {
              var a = t && t.prototype instanceof m ? t : m,
                s = Object.create(a.prototype),
                i = new R(n || []);
              return o(s, "_invoke", {
                value: E(e, r, i)
              }), s;
            }
            function l(e, t, r) {
              try {
                return {
                  type: "normal",
                  arg: e.call(t, r)
                };
              } catch (e) {
                return {
                  type: "throw",
                  arg: e
                };
              }
            }
            t.wrap = p;
            var h = {};
            function m() {}
            function v() {}
            function w() {}
            var g = {};
            d(g, u, function () {
              return this;
            });
            var y = Object.getPrototypeOf,
              b = y && y(y(D([])));
            b && b !== r && s.call(b, u) && (g = b);
            var k = w.prototype = m.prototype = Object.create(g);
            function x(e) {
              ["next", "throw", "return"].forEach(function (t) {
                d(e, t, function (e) {
                  return this._invoke(t, e);
                });
              });
            }
            function T(e, t) {
              function r(a, o, i, u) {
                var c = l(e[a], e, o);
                if ("throw" !== c.type) {
                  var f = c.arg,
                    d = f.value;
                  return d && "object" == n(d) && s.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
                    r("next", e, i, u);
                  }, function (e) {
                    r("throw", e, i, u);
                  }) : t.resolve(d).then(function (e) {
                    f.value = e, i(f);
                  }, function (e) {
                    return r("throw", e, i, u);
                  });
                }
                u(c.arg);
              }
              var a;
              o(this, "_invoke", {
                value: function value(e, n) {
                  function s() {
                    return new t(function (t, a) {
                      r(e, n, t, a);
                    });
                  }
                  return a = a ? a.then(s, s) : s();
                }
              });
            }
            function E(e, t, r) {
              var n = "suspendedStart";
              return function (a, s) {
                if ("executing" === n) throw new Error("Generator is already running");
                if ("completed" === n) {
                  if ("throw" === a) throw s;
                  return {
                    value: void 0,
                    done: !0
                  };
                }
                for (r.method = a, r.arg = s;;) {
                  var o = r.delegate;
                  if (o) {
                    var i = _(o, r);
                    if (i) {
                      if (i === h) continue;
                      return i;
                    }
                  }
                  if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                    r.dispatchException(r.arg);
                  } else "return" === r.method && r.abrupt("return", r.arg);
                  n = "executing";
                  var u = l(e, t, r);
                  if ("normal" === u.type) {
                    if (n = r.done ? "completed" : "suspendedYield", u.arg === h) continue;
                    return {
                      value: u.arg,
                      done: r.done
                    };
                  }
                  "throw" === u.type && (n = "completed", r.method = "throw", r.arg = u.arg);
                }
              };
            }
            function _(e, t) {
              var r = t.method,
                n = e.iterator[r];
              if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator["return"] && (t.method = "return", t.arg = void 0, _(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
              var a = l(n, e.iterator, t.arg);
              if ("throw" === a.type) return t.method = "throw", t.arg = a.arg, t.delegate = null, h;
              var s = a.arg;
              return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
            }
            function C(e) {
              var t = {
                tryLoc: e[0]
              };
              1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }
            function S(e) {
              var t = e.completion || {};
              t.type = "normal", delete t.arg, e.completion = t;
            }
            function R(e) {
              this.tryEntries = [{
                tryLoc: "root"
              }], e.forEach(C, this), this.reset(!0);
            }
            function D(e) {
              if (e) {
                var t = e[u];
                if (t) return t.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var r = -1,
                    n = function t() {
                      for (; ++r < e.length;) if (s.call(e, r)) return t.value = e[r], t.done = !1, t;
                      return t.value = void 0, t.done = !0, t;
                    };
                  return n.next = n;
                }
              }
              return {
                next: P
              };
            }
            function P() {
              return {
                value: void 0,
                done: !0
              };
            }
            return v.prototype = w, o(k, "constructor", {
              value: w,
              configurable: !0
            }), o(w, "constructor", {
              value: v,
              configurable: !0
            }), v.displayName = d(w, f, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
            }, t.mark = function (e) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e, w) : (e.__proto__ = w, d(e, f, "GeneratorFunction")), e.prototype = Object.create(k), e;
            }, t.awrap = function (e) {
              return {
                __await: e
              };
            }, x(T.prototype), d(T.prototype, c, function () {
              return this;
            }), t.AsyncIterator = T, t.async = function (e, r, n, a, s) {
              void 0 === s && (s = Promise);
              var o = new T(p(e, r, n, a), s);
              return t.isGeneratorFunction(r) ? o : o.next().then(function (e) {
                return e.done ? e.value : o.next();
              });
            }, x(k), d(k, f, "Generator"), d(k, u, function () {
              return this;
            }), d(k, "toString", function () {
              return "[object Generator]";
            }), t.keys = function (e) {
              var t = Object(e),
                r = [];
              for (var n in t) r.push(n);
              return r.reverse(), function e() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in t) return e.value = n, e.done = !1, e;
                }
                return e.done = !0, e;
              };
            }, t.values = D, R.prototype = {
              constructor: R,
              reset: function reset(e) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for (var t in this) "t" === t.charAt(0) && s.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
              },
              stop: function stop() {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var t = this;
                function r(r, n) {
                  return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                }
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var a = this.tryEntries[n],
                    o = a.completion;
                  if ("root" === a.tryLoc) return r("end");
                  if (a.tryLoc <= this.prev) {
                    var i = s.call(a, "catchLoc"),
                      u = s.call(a, "finallyLoc");
                    if (i && u) {
                      if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                      if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                    } else if (i) {
                      if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                    } else {
                      if (!u) throw new Error("try statement without catch or finally");
                      if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(e, t) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var n = this.tryEntries[r];
                  if (n.tryLoc <= this.prev && s.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                    var a = n;
                    break;
                  }
                }
                a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
                var o = a ? a.completion : {};
                return o.type = e, o.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, h) : this.complete(o);
              },
              complete: function complete(e, t) {
                if ("throw" === e.type) throw e.arg;
                return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
              },
              finish: function finish(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var r = this.tryEntries[t];
                  if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                }
              },
              "catch": function _catch(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var r = this.tryEntries[t];
                  if (r.tryLoc === e) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var a = n.arg;
                      S(r);
                    }
                    return a;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, t, r) {
                return this.delegate = {
                  iterator: D(e),
                  resultName: t,
                  nextLoc: r
                }, "next" === this.method && (this.arg = void 0), h;
              }
            }, t;
          }
          e.exports = a, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6015: function _(e) {
          function t(r, n) {
            return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
              return e.__proto__ = t, e;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(r, n);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        861: function _(e, t, r) {
          var n = r(3405),
            a = r(9498),
            s = r(6116),
            o = r(2281);
          e.exports = function (e) {
            return n(e) || a(e) || s(e) || o();
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        5036: function _(e, t, r) {
          var n = r(8698)["default"];
          e.exports = function (e, t) {
            if ("object" !== n(e) || null === e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
              var a = r.call(e, t || "default");
              if ("object" !== n(a)) return a;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        4062: function _(e, t, r) {
          var n = r(8698)["default"],
            a = r(5036);
          e.exports = function (e) {
            var t = a(e, "string");
            return "symbol" === n(t) ? t : String(t);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        8698: function _(e) {
          function t(r) {
            return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(r);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6116: function _(e, t, r) {
          var n = r(3897);
          e.exports = function (e, t) {
            if (e) {
              if ("string" == typeof e) return n(e, t);
              var r = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
            }
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3496: function _(e, t, r) {
          var n = r(3808),
            a = r(6015),
            s = r(6035),
            o = r(3515);
          function i(t) {
            var r = "function" == typeof Map ? new Map() : void 0;
            return e.exports = i = function i(e) {
              if (null === e || !s(e)) return e;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== r) {
                if (r.has(e)) return r.get(e);
                r.set(e, t);
              }
              function t() {
                return o(e, arguments, n(this).constructor);
              }
              return t.prototype = Object.create(e.prototype, {
                constructor: {
                  value: t,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), a(t, e);
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, i(t);
          }
          e.exports = i, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        4687: function _(e, t, r) {
          var n = r(7061)();
          e.exports = n;
          try {
            regeneratorRuntime = n;
          } catch (e) {
            "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
          }
        },
        8593: function _(e) {
          "use strict";

          e.exports = JSON.parse('{"name":"axios","version":"0.19.2","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test && bundlesize","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://github.com/axios/axios","devDependencies":{"bundlesize":"^0.17.0","coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.0.2","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^20.1.0","grunt-karma":"^2.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^1.0.18","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^1.3.0","karma-chrome-launcher":"^2.2.0","karma-coverage":"^1.1.1","karma-firefox-launcher":"^1.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-opera-launcher":"^1.0.0","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^1.2.0","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.7","karma-webpack":"^1.7.0","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^5.2.0","sinon":"^4.5.0","typescript":"^2.8.1","url-search-params":"^0.10.0","webpack":"^1.13.1","webpack-dev-server":"^1.14.1"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"typings":"./index.d.ts","dependencies":{"follow-redirects":"1.5.10"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');
        }
      },
      t = {};
    function r(n) {
      var a = t[n];
      if (void 0 !== a) return a.exports;
      var s = t[n] = {
        id: n,
        loaded: !1,
        exports: {}
      };
      return e[n].call(s.exports, s, s.exports, r), s.loaded = !0, s.exports;
    }
    r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.nmd = function (e) {
      return e.paths = [], e.children || (e.children = []), e;
    };
    var n = {};
    return function () {
      "use strict";

      r.r(n), r.d(n, {
        asset: function asset() {
          return Ju;
        },
        axiosInstance: function axiosInstance() {
          return Xu;
        },
        bookings: function bookings() {
          return _u;
        },
        cameraControl: function cameraControl() {
          return Xa;
        },
        config: function config() {
          return M;
        },
        "default": function _default() {
          return Ku;
        },
        game: function game() {
          return Io;
        },
        liveProduction: function liveProduction() {
          return Pi;
        },
        liveStreamDashboard: function liveStreamDashboard() {
          return Hu;
        },
        monitor: function monitor() {
          return qi;
        },
        payments: function payments() {
          return Vu;
        },
        remoteProducer: function remoteProducer() {
          return Lu;
        },
        stats: function stats() {
          return Ho;
        },
        user: function user() {
          return wn;
        },
        utils: function utils() {
          return Wn;
        }
      });
      var e = {};
      r.r(e), r.d(e, {
        checkResetTokenIsValid: function checkResetTokenIsValid() {
          return gt;
        },
        checkVerifyPhone: function checkVerifyPhone() {
          return lt;
        },
        completeExternalRegistration: function completeExternalRegistration() {
          return ot;
        },
        getAccessToken: function getAccessToken() {
          return Pt;
        },
        getPreRegisteredUser: function getPreRegisteredUser() {
          return it;
        },
        getRefreshToken: function getRefreshToken() {
          return It;
        },
        getTeamLogoByCode: function getTeamLogoByCode() {
          return wt;
        },
        getTermsAndCondition: function getTermsAndCondition() {
          return ut;
        },
        getUserData: function getUserData() {
          return st;
        },
        isEmailExist: function isEmailExist() {
          return _t;
        },
        isPhoneOrEmailExists: function isPhoneOrEmailExists() {
          return Et;
        },
        isValidTeamCode: function isValidTeamCode() {
          return vt;
        },
        login: function login() {
          return ct;
        },
        loginWithAppleId: function loginWithAppleId() {
          return dt;
        },
        loginWithFacebook: function loginWithFacebook() {
          return ft;
        },
        logout: function logout() {
          return St;
        },
        refreshAccessToken: function refreshAccessToken() {
          return Tt;
        },
        register: function register() {
          return ht;
        },
        registerUserDevice: function registerUserDevice() {
          return Ct;
        },
        requestPasswordRecovery: function requestPasswordRecovery() {
          return kt;
        },
        resetPassword: function resetPassword() {
          return yt;
        },
        sendOttRegisterEmail: function sendOttRegisterEmail() {
          return At;
        },
        sendResetPasswordMail: function sendResetPasswordMail() {
          return bt;
        },
        sendUserInvitation: function sendUserInvitation() {
          return Nt;
        },
        setAccessToken: function setAccessToken() {
          return Rt;
        },
        setLoginUri: function setLoginUri() {
          return Ot;
        },
        setRefreshToken: function setRefreshToken() {
          return Dt;
        },
        updateLastSeen: function updateLastSeen() {
          return xt;
        },
        verifyOttUser: function verifyOttUser() {
          return Mt;
        },
        verifyPhone: function verifyPhone() {
          return pt;
        },
        verifyUserCodeFromEmail: function verifyUserCodeFromEmail() {
          return qt;
        }
      });
      var t = {};
      r.r(t), r.d(t, {
        cancelTask: function cancelTask() {
          return zt;
        },
        getActiveTasks: function getActiveTasks() {
          return Gt;
        },
        getNotifications: function getNotifications() {
          return Yt;
        },
        getUnreadCount: function getUnreadCount() {
          return jt;
        },
        markAllAsRead: function markAllAsRead() {
          return Ht;
        },
        markNotificationAsRead: function markNotificationAsRead() {
          return Wt;
        },
        sendSmsToUsers: function sendSmsToUsers() {
          return $t;
        }
      });
      var a = {};
      r.r(a), r.d(a, {
        addTeamToUser: function addTeamToUser() {
          return Tr;
        },
        attachUsersToTeam: function attachUsersToTeam() {
          return Br;
        },
        createTeamTag: function createTeamTag() {
          return Or;
        },
        getCountOfTeamVideos: function getCountOfTeamVideos() {
          return Ir;
        },
        getCreditsStatus: function getCreditsStatus() {
          return Wr;
        },
        getFundraisingData: function getFundraisingData() {
          return jr;
        },
        getLeanTeam: function getLeanTeam() {
          return zr;
        },
        getTeam: function getTeam() {
          return kr;
        },
        getTeamByCode: function getTeamByCode() {
          return xr;
        },
        getTeamCategory: function getTeamCategory() {
          return Dr;
        },
        getTeamHighlights: function getTeamHighlights() {
          return Sr;
        },
        getTeamMembers: function getTeamMembers() {
          return Cr;
        },
        getTeamPlayers: function getTeamPlayers() {
          return _r;
        },
        getTeamTags: function getTeamTags() {
          return Ar;
        },
        getTeamVideos: function getTeamVideos() {
          return Pr;
        },
        getTeamsByString: function getTeamsByString() {
          return Gr;
        },
        getTeamsByUser: function getTeamsByUser() {
          return Er;
        },
        getTeamsUserIsAdmin: function getTeamsUserIsAdmin() {
          return Hr;
        },
        refreshTeamCode: function refreshTeamCode() {
          return Mr;
        },
        removeTeamTag: function removeTeamTag() {
          return Nr;
        },
        removeTeamTagByTitle: function removeTeamTagByTitle() {
          return qr;
        },
        removeUserFromTeam: function removeUserFromTeam() {
          return Rr;
        },
        updateTeam: function updateTeam() {
          return Vr;
        },
        updateTeamCoverImage: function updateTeamCoverImage() {
          return Lr;
        },
        updateTeamImage: function updateTeamImage() {
          return Ur;
        },
        updateTeamName: function updateTeamName() {
          return Fr;
        },
        uploadSiteResource: function uploadSiteResource() {
          return Yr;
        }
      });
      var s = {};
      r.r(s), r.d(s, {
        changeToOperator: function changeToOperator() {
          return Xr;
        },
        createDummyUser: function createDummyUser() {
          return Qr;
        },
        getPlayerNumberByTeam: function getPlayerNumberByTeam() {
          return Kr;
        },
        getTaggerData: function getTaggerData() {
          return tn;
        },
        updateProfileImage: function updateProfileImage() {
          return Jr;
        },
        updateTaggerData: function updateTaggerData() {
          return en;
        },
        updateUserData: function updateUserData() {
          return Zr;
        }
      });
      var o = {};
      r.r(o), r.d(o, {
        checkClubSites: function checkClubSites() {
          return cn;
        },
        createNewTeam: function createNewTeam() {
          return an;
        },
        getAllClubsList: function getAllClubsList() {
          return vn;
        },
        getClubById: function getClubById() {
          return fn;
        },
        getClubFundraisingData: function getClubFundraisingData() {
          return mn;
        },
        getClubRunningLiveSessions: function getClubRunningLiveSessions() {
          return hn;
        },
        getClubTeams: function getClubTeams() {
          return on;
        },
        getClubVideos: function getClubVideos() {
          return un;
        },
        getClubsByUser: function getClubsByUser() {
          return nn;
        },
        getClubsList: function getClubsList() {
          return pn;
        },
        getOttClubData: function getOttClubData() {
          return ln;
        },
        removeTeam: function removeTeam() {
          return sn;
        },
        updateClubLogo: function updateClubLogo() {
          return dn;
        }
      });
      var i = {};
      r.r(i), r.d(i, {
        checkSite: function checkSite() {
          return na;
        },
        checkSiteBySiteId: function checkSiteBySiteId() {
          return aa;
        },
        getCurrentTime: function getCurrentTime() {
          return ta;
        },
        getSite: function getSite() {
          return ra;
        },
        getSiteSnapshot: function getSiteSnapshot() {
          return oa;
        },
        isSiteOnline: function isSiteOnline() {
          return sa;
        },
        rebootCamera: function rebootCamera() {
          return ca;
        },
        setCameraMode: function setCameraMode() {
          return ia;
        },
        setCameraPosition: function setCameraPosition() {
          return ua;
        }
      });
      var u = {};
      r.r(u), r.d(u, {
        allowRequestCamerasUntilReady: function allowRequestCamerasUntilReady() {
          return Na;
        },
        blockRequestCamerasUntilReady: function blockRequestCamerasUntilReady() {
          return Oa;
        },
        clearRequestCameras: function clearRequestCameras() {
          return qa;
        },
        getLiveSessionBySessionId: function getLiveSessionBySessionId() {
          return xa;
        },
        getLiveSessions: function getLiveSessions() {
          return Ta;
        },
        goPublic: function goPublic() {
          return Ra;
        },
        liveAuth: function liveAuth() {
          return Sa;
        },
        liveDone: function liveDone() {
          return ka;
        },
        requestCamerasUntilReady: function requestCamerasUntilReady() {
          return Pa;
        },
        requestCamerasUntilReadyWithCameras: function requestCamerasUntilReadyWithCameras() {
          return Aa;
        },
        setLiveTitle: function setLiveTitle() {
          return Da;
        },
        startLive: function startLive() {
          return Ea;
        },
        stopLive: function stopLive() {
          return _a;
        }
      });
      var c = {};
      r.r(c), r.d(c, {
        createTrackingFromFile: function createTrackingFromFile() {
          return Ya;
        },
        getMainRecordBySessionId: function getMainRecordBySessionId() {
          return Ga;
        },
        startRecord: function startRecord() {
          return Fa;
        },
        stopRecord: function stopRecord() {
          return Ba;
        }
      });
      var f = {};
      r.r(f), r.d(f, {
        cancelTask: function cancelTask() {
          return za;
        },
        getTasks: function getTasks() {
          return $a;
        },
        getTasksBySite: function getTasksBySite() {
          return Za;
        },
        startScheduledLive: function startScheduledLive() {
          return Wa;
        },
        startScheduledRecord: function startScheduledRecord() {
          return Ha;
        }
      });
      var d = {};
      r.r(d), r.d(d, {
        createEvent: function createEvent() {
          return ns;
        },
        createVideoClip: function createVideoClip() {
          return as;
        },
        filterGameEventsByEvent: function filterGameEventsByEvent() {
          return ds;
        },
        filterGameEventsByPlayer: function filterGameEventsByPlayer() {
          return fs;
        },
        getEventById: function getEventById() {
          return ss;
        },
        getGameEvents: function getGameEvents() {
          return rs;
        },
        removeEvent: function removeEvent() {
          return os;
        },
        sortEvents: function sortEvents() {
          return ps;
        },
        updateEventPlayers: function updateEventPlayers() {
          return is;
        },
        updateEventPrivacy: function updateEventPrivacy() {
          return cs;
        },
        updateEventText: function updateEventText() {
          return us;
        }
      });
      var p = {};
      r.r(p), r.d(p, {
        createVideoContainerFromLiveStream: function createVideoContainerFromLiveStream() {
          return Ss;
        },
        deleteVideoContainer: function deleteVideoContainer() {
          return xs;
        },
        downloadVideo: function downloadVideo() {
          return _s;
        },
        getAllStreamURISFromVideo: function getAllStreamURISFromVideo() {
          return Ds;
        },
        getGameVideos: function getGameVideos() {
          return ks;
        },
        getLiveSession: function getLiveSession() {
          return Fs;
        },
        getLiveSessionUploadRequests: function getLiveSessionUploadRequests() {
          return Ms;
        },
        getPublicVideoContainer: function getPublicVideoContainer() {
          return Ls;
        },
        getPublicVideoContainersByTeam: function getPublicVideoContainersByTeam() {
          return Us;
        },
        getPublicVideoToken: function getPublicVideoToken() {
          return Rs;
        },
        getVideoContainerByID: function getVideoContainerByID() {
          return Ts;
        },
        getVideoToUploadInfo: function getVideoToUploadInfo() {
          return Ps;
        },
        insertVideoFromShare: function insertVideoFromShare() {
          return Es;
        },
        setAwayTeamScore: function setAwayTeamScore() {
          return As;
        },
        setHomeTeamScore: function setHomeTeamScore() {
          return qs;
        },
        updateUploadVideoRequest: function updateUploadVideoRequest() {
          return Ns;
        },
        updateVideoContainer: function updateVideoContainer() {
          return Cs;
        },
        uploadDirectExternalVideo: function uploadDirectExternalVideo() {
          return Os;
        },
        uploadExternalVideo: function uploadExternalVideo() {
          return Is;
        }
      });
      var l = {};
      r.r(l), r.d(l, {
        checkForClipsInProcess: function checkForClipsInProcess() {
          return Xs;
        },
        checkForReadyClips: function checkForReadyClips() {
          return Js;
        },
        createClip: function createClip() {
          return Hs;
        },
        getClipOnWork: function getClipOnWork() {
          return js;
        },
        getGameClips: function getGameClips() {
          return Ys;
        },
        makeClipVideo: function makeClipVideo() {
          return $s;
        },
        makeClipVideoFromBreakdown: function makeClipVideoFromBreakdown() {
          return Zs;
        },
        removeClip: function removeClip() {
          return Ws;
        },
        updateClip: function updateClip() {
          return zs;
        }
      });
      var h = {};
      r.r(h), r.d(h, {
        addHighlight: function addHighlight() {
          return po;
        },
        allowToRecord: function allowToRecord() {
          return vo;
        },
        deleteHighlight: function deleteHighlight() {
          return co;
        },
        getGameHighlights: function getGameHighlights() {
          return uo;
        },
        getHighlightById: function getHighlightById() {
          return oo;
        },
        getPlayerGameHighlights: function getPlayerGameHighlights() {
          return io;
        },
        getPublicHighlightById: function getPublicHighlightById() {
          return so;
        },
        getTeamGameHighlights: function getTeamGameHighlights() {
          return ho;
        },
        getUserHighlights: function getUserHighlights() {
          return mo;
        },
        updateHighlight: function updateHighlight() {
          return lo;
        }
      });
      var m = {};
      r.r(m), r.d(m, {
        createGameTagTask: function createGameTagTask() {
          return Po;
        },
        getDoneTasks: function getDoneTasks() {
          return xo;
        },
        getInProgressTasks: function getInProgressTasks() {
          return Eo;
        },
        getTagTaskById: function getTagTaskById() {
          return Do;
        },
        getTaggerTaskCount: function getTaggerTaskCount() {
          return _o;
        },
        getTaggerTasks: function getTaggerTasks() {
          return ko;
        },
        getWaitingTasks: function getWaitingTasks() {
          return To;
        },
        markTagTaskAsDone: function markTagTaskAsDone() {
          return Co;
        },
        markTagTaskAsInProgress: function markTagTaskAsInProgress() {
          return So;
        },
        setGamePeriod: function setGamePeriod() {
          return Ro;
        }
      });
      var v = {};
      r.r(v), r.d(v, {
        getAllPlayersStats: function getAllPlayersStats() {
          return Fo;
        },
        getMappedEvents: function getMappedEvents() {
          return Vo;
        },
        getPlayerProfileStats: function getPlayerProfileStats() {
          return Bo;
        },
        getPlayerStats: function getPlayerStats() {
          return Lo;
        },
        getStatsTable: function getStatsTable() {
          return Yo;
        },
        getTeamSeasonStats: function getTeamSeasonStats() {
          return jo;
        },
        getTeamStats: function getTeamStats() {
          return Uo;
        },
        getVideoPeriods: function getVideoPeriods() {
          return Go;
        }
      });
      var w = {};
      r.r(w), r.d(w, {
        addBottomSponsor: function addBottomSponsor() {
          return gi;
        },
        addFilter: function addFilter() {
          return Ri;
        },
        changeScoreboardType: function changeScoreboardType() {
          return ki;
        },
        connectCommentator: function connectCommentator() {
          return pi;
        },
        deleteSiteResources: function deleteSiteResources() {
          return wi;
        },
        getCommentatorStatus: function getCommentatorStatus() {
          return Ti;
        },
        getInternalStreams: function getInternalStreams() {
          return _i;
        },
        getScoreDisplayResources: function getScoreDisplayResources() {
          return vi;
        },
        getScoreboardType: function getScoreboardType() {
          return xi;
        },
        getTeamFromLiveSession: function getTeamFromLiveSession() {
          return fi;
        },
        inviteCommentator: function inviteCommentator() {
          return di;
        },
        peerProducerCamera: function peerProducerCamera() {
          return Ei;
        },
        removeBottomSponsor: function removeBottomSponsor() {
          return yi;
        },
        removeFilter: function removeFilter() {
          return Di;
        },
        setCommentatorDelay: function setCommentatorDelay() {
          return Ci;
        },
        setMainVolume: function setMainVolume() {
          return Si;
        },
        startBroadcast: function startBroadcast() {
          return li;
        },
        stopBroadcast: function stopBroadcast() {
          return hi;
        },
        swapDigitalToStream: function swapDigitalToStream() {
          return bi;
        },
        updateScoreDisplay: function updateScoreDisplay() {
          return mi;
        }
      });
      var g = {};
      r.r(g), r.d(g, {
        assignProducer: function assignProducer() {
          return fu;
        },
        cancelAssign: function cancelAssign() {
          return mu;
        },
        cancelBooking: function cancelBooking() {
          return nu;
        },
        editBooking: function editBooking() {
          return ru;
        },
        getAllBookingsCount: function getAllBookingsCount() {
          return ku;
        },
        getAllProducers: function getAllProducers() {
          return pu;
        },
        getBookingsByClub: function getBookingsByClub() {
          return ou;
        },
        getBookingsById: function getBookingsById() {
          return su;
        },
        getBookingsByProducerCount: function getBookingsByProducerCount() {
          return bu;
        },
        getBookingsByStatus: function getBookingsByStatus() {
          return cu;
        },
        getBookingsByTeam: function getBookingsByTeam() {
          return iu;
        },
        getBookingsByUser: function getBookingsByUser() {
          return uu;
        },
        getBookingsCount: function getBookingsCount() {
          return au;
        },
        getLeanClubBookings: function getLeanClubBookings() {
          return xu;
        },
        getLeanTeamBookings: function getLeanTeamBookings() {
          return Tu;
        },
        getTeamCredits: function getTeamCredits() {
          return wu;
        },
        reassignProducer: function reassignProducer() {
          return du;
        },
        scheduleNewBooking: function scheduleNewBooking() {
          return Eu;
        },
        scheduledNewBooking: function scheduledNewBooking() {
          return tu;
        },
        setGameEndTime: function setGameEndTime() {
          return hu;
        },
        setGameStartTime: function setGameStartTime() {
          return lu;
        },
        startProducer: function startProducer() {
          return gu;
        },
        startVideoStream: function startVideoStream() {
          return vu;
        },
        stopVideoStream: function stopVideoStream() {
          return yu;
        }
      });
      var y = {};
      r.r(y), r.d(y, {
        getPtzCameraLimits: function getPtzCameraLimits() {
          return Pu;
        },
        isRemoteProducer: function isRemoteProducer() {
          return Au;
        },
        killDocker: function killDocker() {
          return Uu;
        },
        restartDocker: function restartDocker() {
          return Mu;
        },
        setPtzCameraLimits: function setPtzCameraLimits() {
          return Du;
        },
        setScore: function setScore() {
          return qu;
        },
        setScoreClock: function setScoreClock() {
          return Nu;
        },
        startScoreClock: function startScoreClock() {
          return Iu;
        },
        stopScoreClock: function stopScoreClock() {
          return Ou;
        }
      });
      var b = {};
      r.r(b), r.d(b, {
        createStripeCheckoutSession: function createStripeCheckoutSession() {
          return Bu;
        }
      });
      var k = {};
      r.r(k), r.d(k, {
        getSignedUrl: function getSignedUrl() {
          return Yu;
        },
        isAllowedToEdit: function isAllowedToEdit() {
          return ju;
        }
      });
      var x = {};
      r.r(x), r.d(x, {
        createAsset: function createAsset() {
          return $u;
        },
        getTeamAssets: function getTeamAssets() {
          return Zu;
        }
      });
      var T = r(9669),
        E = r.n(T),
        _ = r(7156),
        C = r.n(_),
        S = r(4687),
        R = r.n(S),
        D = r(8698),
        P = r.n(D),
        I = r(381),
        O = r.n(I);
      var N = {
          LOCAL: {
            NODE_CCAPI_URL: "http://localhost:3001/ccapi",
            NODE_API_URL: "http://localhost:3001/api",
            CC_V2_API_URL: "http://localhost:3001/ccapi",
            CC_API_URL: "http://localhost:4000/api",
            CLIENT_URL: "http://app.myplay.com",
            ENV: "LOCAL"
          },
          STAGING: {
            NODE_API_URL: "http://217.182.92.90:3001/api",
            NODE_CCAPI_URL: "http://217.182.92.90:3001/ccapi",
            CC_API_URL: "https://ccapi-v2.myplay.com/api",
            CC_V2_API_URL: "https://ccapi-v2.myplay.com/api",
            CLIENT_URL: "https://app.myplay.com",
            ENV: "STAGING"
          },
          PRODUCTION: {
            NODE_CCAPI_URL: "https://api.myplay.com/ccapi",
            NODE_API_URL: "https://api.myplay.com/api",
            CC_API_URL: "https://ccapi.myplay.com/api",
            CC_V2_API_URL: "https://ccapi-v2.myplay.com/api",
            CLIENT_URL: "https://app.myplay.com",
            ENV: "PRODUCTION"
          }
        },
        q = function q(e) {
          return -1 === [N.LOCAL.ENV, N.STAGING.ENV, N.PRODUCTION.ENV].indexOf(e) ? N.LOCAL : N[e];
        },
        A = "MYPLAY/";
      var M = {
        getEnvironment: q,
        addInterceptor: function addInterceptor(e, t) {
          return E().interceptors.response.use(e, t);
        },
        addHeader: function addHeader(e, t) {
          if (!e || void 0 === e) throw new Error("[api.setHeader] key is invalid / key is undefined");
          E().defaults.headers.common[e] = t;
        },
        localStoragePrefix: A
      };
      var U = r(8416),
        L = r.n(U),
        F = r(6690),
        B = r.n(F),
        V = r(9728),
        G = r.n(V),
        Y = "__gcsBrowserUpload",
        j = function () {
          function e(t, r, n, a) {
            B()(this, e), this.id = t, this.fileSize = r, this.chunkSize = n, this.storage = a;
          }
          return G()(e, [{
            key: "getMeta",
            value: function value() {
              var e = this.storage.getItem("".concat(Y, ".").concat(this.id));
              return e ? JSON.parse(e) : {
                checksums: [],
                chunkSize: this.chunkSize,
                started: !1,
                fileSize: this.fileSize
              };
            }
          }, {
            key: "setMeta",
            value: function value(e) {
              var t = "".concat(Y, ".").concat(this.id);
              e ? this.storage.setItem(t, JSON.stringify(e)) : this.storage.removeItem(t);
            }
          }, {
            key: "isResumable",
            value: function value() {
              var e = this.getMeta();
              return e.started && this.chunkSize === e.chunkSize;
            }
          }, {
            key: "getResumeIndex",
            value: function value() {
              return this.getMeta().checksums.length;
            }
          }, {
            key: "getFileSize",
            value: function value() {
              return this.getMeta().fileSize;
            }
          }, {
            key: "addChecksum",
            value: function value(e, t) {
              var r = this.getMeta();
              r.checksums[e] = t, r.started = !0, this.setMeta(r);
            }
          }, {
            key: "getChecksum",
            value: function value(e) {
              return this.getMeta().checksums[e];
            }
          }, {
            key: "reset",
            value: function value() {
              this.setMeta(null);
            }
          }]), e;
        }(),
        H = r(2702),
        W = r(8322),
        z = r.n(W),
        $ = r(5158);
      var Z = r.n($)()("gcs-browser-upload");
      var J = function () {
        function e(t, r) {
          B()(this, e), this.paused = !1, this.file = t, this.chunkSize = r, this.unpauseHandlers = [];
        }
        var t;
        return G()(e, [{
          key: "run",
          value: (t = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s,
              o,
              i,
              u,
              c,
              f = this,
              d = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = d.length > 1 && void 0 !== d[1] ? d[1] : 0, n = d.length > 2 ? d[2] : void 0, a = this.file, s = this.chunkSize, o = Math.ceil(a.size / s), i = new (z().ArrayBuffer)(), Z("Starting run on file:"), Z(" - Total chunks: ".concat(o)), Z(" - Start index: ".concat(r)), Z(" - End index: ".concat(n || o)), u = function () {
                    var e = C()(R().mark(function e(r) {
                      var d, p, l, h;
                      return R().wrap(function (e) {
                        for (;;) switch (e.prev = e.next) {
                          case 0:
                            if (r !== o && r !== n) {
                              e.next = 3;
                              break;
                            }
                            return Z("File process complete"), e.abrupt("return");
                          case 3:
                            if (!f.paused) {
                              e.next = 6;
                              break;
                            }
                            return e.next = 6, c();
                          case 6:
                            return d = r * s, p = a.slice(d, d + s), e.next = 10, K(a, p);
                          case 10:
                            return l = e.sent, h = X(i, l), e.next = 14, t(h, r, l);
                          case 14:
                            if (!1 === e.sent) {
                              e.next = 18;
                              break;
                            }
                            return e.next = 18, u(r + 1);
                          case 18:
                          case "end":
                            return e.stop();
                        }
                      }, e);
                    }));
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  }(), c = function c() {
                    return new H.Promise(function (e) {
                      f.unpauseHandlers.push(e);
                    });
                  }, e.next = 13, u(r);
                case 13:
                case "end":
                  return e.stop();
              }
            }, e, this);
          })), function (e) {
            return t.apply(this, arguments);
          })
        }, {
          key: "pause",
          value: function value() {
            this.paused = !0;
          }
        }, {
          key: "unpause",
          value: function value() {
            this.paused = !1, this.unpauseHandlers.forEach(function (e) {
              return e();
            }), this.unpauseHandlers = [];
          }
        }]), e;
      }();
      function X(e, t) {
        e.append(t);
        var r = e.getState(),
          n = e.end();
        return e.setState(r), n;
      }
      function K(e, t) {
        return Q.apply(this, arguments);
      }
      function Q() {
        return (Q = C()(R().mark(function e(t, r) {
          return R().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", new H.Promise(function (e, t) {
                  var n = new window.FileReader();
                  n.onload = function () {
                    return e(n.result);
                  }, n.onerror = t, n.readAsArrayBuffer(r);
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }))).apply(this, arguments);
      }
      var ee = J;
      var te = r(1655),
        re = r.n(te),
        ne = r(4993),
        ae = r.n(ne),
        se = r(3808),
        oe = r.n(se);
      function ie(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }
      var ue = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var r = ie(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return Object.defineProperty(r, "message", {
            configurable: !0,
            enumerable: !1,
            value: e,
            writable: !0
          }), Object.defineProperty(r, "name", {
            configurable: !0,
            enumerable: !1,
            value: r.constructor.name,
            writable: !0
          }), Error.hasOwnProperty("captureStackTrace") ? (Error.captureStackTrace(r, r.constructor), ie(r)) : (Object.defineProperty(r, "stack", {
            configurable: !0,
            enumerable: !1,
            value: new Error(e).stack,
            writable: !0
          }), r);
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), t;
      }(function (e) {
        function t() {
          e.apply(this, arguments);
        }
        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e, t;
      }(Error));
      function ce(e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var r,
            n = oe()(e);
          if (t) {
            var a = oe()(this).constructor;
            r = Reflect.construct(n, arguments, a);
          } else r = n.apply(this, arguments);
          return ae()(this, r);
        };
      }
      var fe = function (e) {
          re()(r, e);
          var t = ce(r);
          function r(e, n) {
            return B()(this, r), t.call(this, "File '".concat(e, "' has already been uploaded to unique url '").concat(n, "'"));
          }
          return G()(r);
        }(ue),
        de = function (e) {
          re()(r, e);
          var t = ce(r);
          function r(e) {
            return B()(this, r), t.call(this, "Upload URL '".concat(e, "' has either expired or is invalid"));
          }
          return G()(r);
        }(ue),
        pe = function (e) {
          re()(r, e);
          var t = ce(r);
          function r(e) {
            return B()(this, r), t.call(this, "HTTP status ".concat(e, " received from GCS, consider retrying"));
          }
          return G()(r);
        }(ue),
        le = function (e) {
          re()(r, e);
          var t = ce(r);
          function r(e) {
            var n;
            return B()(this, r), (n = t.call(this, "Unknown response received from GCS")).res = e, n;
          }
          return G()(r);
        }(ue),
        he = function (e) {
          re()(r, e);
          var t = ce(r);
          function r() {
            return B()(this, r), t.call(this, "Missing options for Upload");
          }
          return G()(r);
        }(ue),
        me = function (e) {
          re()(r, e);
          var t = ce(r);
          function r() {
            return B()(this, r), t.call(this, "Upload is not complete");
          }
          return G()(r);
        }(ue),
        ve = function (e) {
          re()(r, e);
          var t = ce(r);
          function r(e) {
            return B()(this, r), t.call(this, "Invalid chunk size ".concat(e, ", must be a multiple of 262144"));
          }
          return G()(r);
        }(ue),
        we = function (e) {
          re()(r, e);
          var t = ce(r);
          function r() {
            return B()(this, r), t.call(this, "Upload instance has already finished");
          }
          return G()(r);
        }(ue);
      function ge(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      var ye = 262144,
        be = function () {
          function e(t, r) {
            B()(this, e);
            var n = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ge(Object(r), !0).forEach(function (t) {
                  L()(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ge(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }
              return e;
            }({
              chunkSize: ye,
              storage: window.localStorage,
              contentType: "video/mp4",
              onChunkUpload: function onChunkUpload() {},
              id: null,
              url: null,
              file: null
            }, t);
            if ((n.chunkSize % ye != 0 || 0 === n.chunkSize) && !r) throw new ve(n.chunkSize);
            if (!n.id || !n.url || !n.file) throw new he();
            Z("Creating new upload instance:"), Z(" - Url: ".concat(n.url)), Z(" - Id: ".concat(n.id)), Z(" - File size: ".concat(n.file.size)), Z(" - Chunk size: ".concat(n.chunkSize)), this.opts = n, this.meta = new j(n.id, n.file.size, n.chunkSize, n.storage), this.processor = new ee(n.file, n.chunkSize), this.lastResult = null, this.updateUploadProgress = n.updateUploadProgress;
          }
          var t;
          return G()(e, [{
            key: "start",
            value: (t = C()(R().mark(function e() {
              var t,
                r,
                n,
                a,
                s,
                o,
                i,
                u = this;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (t = this.meta, r = this.processor, n = this.opts, a = this.finished, console.log("START!"), s = function () {
                      var e = C()(R().mark(function e() {
                        var t;
                        return R().wrap(function (e) {
                          for (;;) switch (e.prev = e.next) {
                            case 0:
                              return e.next = 2, i();
                            case 2:
                              return t = e.sent, e.next = 5, r.run(o, t);
                            case 5:
                            case "end":
                              return e.stop();
                          }
                        }, e);
                      }));
                      return function () {
                        return e.apply(this, arguments);
                      };
                    }(), o = function () {
                      var e = C()(R().mark(function e(r, a, s) {
                        var o, i, c, f, d;
                        return R().wrap(function (e) {
                          for (;;) switch (e.prev = e.next) {
                            case 0:
                              return o = n.file.size, i = a * n.chunkSize, c = a * n.chunkSize + s.byteLength - 1, f = {
                                "Content-Type": n.contentType,
                                "Content-Range": "bytes ".concat(i, "-").concat(c, "/").concat(o)
                              }, Z("Uploading chunk ".concat(a, ":")), Z(" - Chunk length: ".concat(s.byteLength)), Z(" - Start: ".concat(i)), Z(" - End: ".concat(c)), e.next = 10, xe(n.url, s, {
                                headers: f
                              });
                            case 10:
                              if (d = e.sent, u.lastResult = d, !d.status) {
                                e.next = 19;
                                break;
                              }
                              ke(d, n, [200, 201, 308]), Z("Chunk upload succeeded, adding checksum ".concat(r)), t.addChecksum(a, r), n.onChunkUpload({
                                totalBytes: o,
                                uploadedBytes: c + 1,
                                chunkIndex: a,
                                chunkLength: s.byteLength
                              }), e.next = 20;
                              break;
                            case 19:
                              return e.abrupt("return", u.lastResult);
                            case 20:
                            case "end":
                              return e.stop();
                          }
                        }, e);
                      }));
                      return function (t, r, n) {
                        return e.apply(this, arguments);
                      };
                    }(), i = function () {
                      var e = C()(R().mark(function e() {
                        var t, r, a, s, o;
                        return R().wrap(function (e) {
                          for (;;) switch (e.prev = e.next) {
                            case 0:
                              return t = {
                                "Content-Type": n.contentType,
                                "Content-Range": "bytes */".concat(n.file.size)
                              }, Z("Retrieving upload status from GCS"), e.next = 4, xe(n.url, null, {
                                headers: t
                              });
                            case 4:
                              if (ke(r = e.sent, n, [308]), a = r.headers.range, Z("Received upload status from GCS: ".concat(a)), s = a ? a.match(/(\d+?)-(\d+?)$/) : null) {
                                e.next = 11;
                                break;
                              }
                              return e.abrupt("return");
                            case 11:
                              return o = parseInt(s[2]) + 1, e.abrupt("return", Math.floor(o / n.chunkSize));
                            case 13:
                            case "end":
                              return e.stop();
                          }
                        }, e);
                      }));
                      return function () {
                        return e.apply(this, arguments);
                      };
                    }(), !a) {
                      e.next = 7;
                      break;
                    }
                    throw new we();
                  case 7:
                    if (!t.isResumable() || t.getFileSize() !== n.file.size) {
                      e.next = 13;
                      break;
                    }
                    return Z("Upload might be resumable"), e.next = 11, s();
                  case 11:
                    e.next = 16;
                    break;
                  case 13:
                    return Z("Upload not resumable, starting from scratch"), e.next = 16, r.run(o);
                  case 16:
                    return console.log("Upload complete, resetting meta"), Z("Upload complete, resetting meta"), t.reset(), e.abrupt("return", this.lastResult);
                  case 20:
                  case "end":
                    return e.stop();
                }
              }, e, this);
            })), function () {
              return t.apply(this, arguments);
            })
          }, {
            key: "pause",
            value: function value() {
              this.processor.pause(), Z("Upload paused");
            }
          }, {
            key: "unpause",
            value: function value() {
              this.processor.unpause(), Z("Upload unpaused");
            }
          }, {
            key: "cancel",
            value: function value() {
              this.processor.pause(), this.meta.reset(), Z("Upload cancelled");
            }
          }]), e;
        }();
      function ke(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
          n = (e || {}).status;
        if (r.indexOf(n) > -1) return !0;
        switch (n) {
          case 308:
            throw new me();
          case 201:
          case 200:
            throw new fe(t.id, t.url);
          case 404:
            throw new de(t.url);
          case 500:
          case 502:
          case 503:
          case 504:
            throw new pe(n);
          default:
            throw new le(e);
        }
      }
      function xe() {
        return Te.apply(this, arguments);
      }
      function Te() {
        return Te = C()(R().mark(function e() {
          var t,
            r,
            n,
            a = arguments;
          return R().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, T.put.apply(null, a);
              case 3:
                return t = e.sent, r = t.response ? t.response : t, e.abrupt("return", r);
              case 8:
                return e.prev = 8, e.t0 = e["catch"](0), n = e.t0.response ? e.t0.response : e.t0, e.abrupt("return", n);
              case 12:
              case "end":
                return e.stop();
            }
          }, e, null, [[0, 8]]);
        })), Te.apply(this, arguments);
      }
      var Ee = "undefined" != typeof Blob && function () {
          try {
            return Boolean(new Blob());
          } catch (e) {
            return !1;
          }
        }(),
        _e = Ee && "undefined" != typeof Uint8Array && function () {
          try {
            return 100 === new Blob([new Uint8Array(100)]).size;
          } catch (e) {
            return !1;
          }
        }(),
        Ce = "undefined" != typeof HTMLCanvasElement && HTMLCanvasElement.prototype.toBlob,
        Se = Ce || "undefined" != typeof Uint8Array && "undefined" != typeof ArrayBuffer && "undefined" != typeof atob,
        Re = "undefined" != typeof FileReader || "undefined" != typeof URL,
        De = function () {
          function e() {
            B()(this, e);
          }
          return G()(e, null, [{
            key: "resize",
            value: function value(t, r, n) {
              if ("function" == typeof r && (n = r, r = {
                width: 640,
                height: 480
              }), r.width, r.height, !e.isSupported() || !t.type.match(/image.*/)) return n(t, !1), !1;
              if (t.type.match(/image\/gif/)) return n(t, !1), !1;
              var a = document.createElement("img");
              return a.onload = function (s) {
                var o = a.width,
                  i = a.height,
                  u = !1;
                if (o >= i && o > r.width ? (i *= r.width / o, o = r.width, u = !0) : i > r.height && (o *= r.height / i, i = r.height, u = !0), u) {
                  var c = document.createElement("canvas");
                  if (c.width = o, c.height = i, c.getContext("2d").drawImage(a, 0, 0, o, i), Ce) c.toBlob(function (e) {
                    n(e, !0);
                  }, t.type);else {
                    var f = e._toBlob(c, t.type);
                    n(f, !0);
                  }
                } else n(t, !1);
              }, e._loadImage(a, t), !0;
            }
          }, {
            key: "_toBlob",
            value: function value(e, t) {
              var r,
                n = e.toDataURL(t).split(",");
              r = n[0].indexOf("base64") >= 0 ? atob(n[1]) : decodeURIComponent(n[1]);
              for (var a = new ArrayBuffer(r.length), s = new Uint8Array(a), o = 0; o < r.length; o += 1) s[o] = r.charCodeAt(o);
              var i = n[0].split(":")[1].split(";")[0],
                u = null;
              if (Ee) u = new Blob([_e ? s : a], {
                type: i
              });else {
                var c = new BlobBuilder();
                c.append(a), u = c.getBlob(i);
              }
              return u;
            }
          }, {
            key: "_loadImage",
            value: function value(e, t, r) {
              if ("undefined" == typeof URL) {
                var n = new FileReader();
                n.onload = function (t) {
                  e.src = t.target.result, r && r();
                }, n.readAsDataURL(t);
              } else e.src = URL.createObjectURL(t), r && r();
            }
          }, {
            key: "isSupported",
            value: function value() {
              return "undefined" != typeof HTMLCanvasElement && Se && Re;
            }
          }]), e;
        }(),
        Pe = (r(3704), r(3496));
      var Ie = function (e) {
        re()(a, e);
        var t,
          r,
          n = (t = a, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              n = oe()(t);
            if (r) {
              var a = oe()(this).constructor;
              e = Reflect.construct(n, arguments, a);
            } else e = n.apply(this, arguments);
            return ae()(this, e);
          });
        function a(e) {
          var t;
          return B()(this, a), (t = n.call(this, e)).name = "VisibleError", t.message = e, t;
        }
        return G()(a);
      }(r.n(Pe)()(Error));
      function Oe(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function Ne(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Oe(Object(r), !0).forEach(function (t) {
            L()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Oe(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
      var qe = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.getUserData] request status is different from 200:\n      ".concat(r.status, " / No data returned"));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.getUserData] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ae = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/user"), {
                    loginMethod: t,
                    password: r
                  });
                case 3:
                  if (!(n = e.sent) || 401 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(n.data && n.data.error || "");
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.login] request status is different from 200:\n      ".concat(n.status));
                case 8:
                  if (!n || n.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[user.auth.api.login] no data returned form request");
                case 10:
                  return n.data.accessToken && (ze(n.data.accessToken), $e(n.data.refreshToken)), e.abrupt("return", n.data);
                case 12:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Me = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/facebook"), {
                    access_token: t
                  });
                case 3:
                  if (!(r = e.sent) || 401 !== r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(r.data && r.data.error || "");
                case 6:
                  if (!r || 200 === r.status || 201 === r.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.loginWithFacebook] request status is different from 200 or 201:\n      ".concat(r.status));
                case 8:
                  if (!r || r.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[user.auth.api.loginWithFacebook] no data returned form request");
                case 10:
                  return r.data.accessToken && (ze(r.data.accessToken), $e(r.data.userData.refreshToken)), r.data.status = r.status, e.abrupt("return", r.data);
                case 13:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ue = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/appleId"), {
                    code: t
                  });
                case 3:
                  if (!(r = e.sent) || 401 !== r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(r.data && r.data.error || "");
                case 6:
                  if (!r || 200 === r.status || 201 === r.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.loginWithAppleId] request status is different from 200 or 201:\n      ".concat(r.status));
                case 8:
                  if (!r || r.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[user.auth.api.loginWithAppleId] no data returned form request");
                case 10:
                  return r.data.accessToken && (ze(r.data.accessToken), $e(r.data.userData.refreshToken)), r.data.status = r.status, e.abrupt("return", r.data);
                case 13:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Le = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o, i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.code, n = t.requestID, a = t.userID, s = t.resetPassword, o = t.verifyPhone, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/auth/checkVerifyPhone"), {
                    code: r,
                    request_id: n,
                    userId: a,
                    resetPassword: s,
                    verifyPhone: o
                  });
                case 4:
                  if (!(i = e.sent) || 500 !== i.status && 403 !== i.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Ie(i.data.error);
                case 7:
                  if (!i || 200 === i.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[user.auth.api.checkVerifyPhone] request status is different from 200");
                case 9:
                  if (!s || !i.data || i.data.resetToken) {
                    e.next = 11;
                    break;
                  }
                  throw new Error("[user.auth.api.checkVerifyPhone] No resetToken returned");
                case 11:
                  return e.abrupt("return", !s || {
                    resetToken: i.data.resetToken
                  });
                case 12:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Fe = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/verifyPhone"), {
                    phone: t,
                    country: r
                  });
                case 3:
                  if (!(n = e.sent) || 500 !== n.status && 403 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(n.data.error);
                case 6:
                  if (n.data && n.data.request_id) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.verifyPhone] no request id returned from request");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Be = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return t.birthdate && (t.birthdate = O()(t.birthdate, "DD/MM/YYYY").toISOString()), e.next = 4, _n.sendRequest("POST", "".concat("v1", "/auth/user/register"), t);
                case 4:
                  if (!(r = e.sent) || 409 !== r.status && 400 !== r.status && 422 !== r.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Ie(r.data && r.data.error || "");
                case 7:
                  if (!r || 201 === r.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[user.auth.api.register] request status is different from 201:\n      ".concat(r.status));
                case 9:
                  return e.abrupt("return", r.data);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ve = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/checkIfValidTeamCode"), {
                    code: t
                  });
                case 3:
                  return r = e.sent, e.abrupt("return", r && 200 === r.status);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ge = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/teamLogoByCode"), {
                    code: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.getTeamLogoByCode] request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.getTeamLogoByCode] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ye = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/auth/passwordResetByToken"), {
                    token: t,
                    password: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.resetPassword] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        je = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/auth/checkPassRecoveryToken?token=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.checkResetTokenIsValid] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        He = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/sendPassRecoveryMail"), {
                    email: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.sendResetPasswordMail] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        We = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/logintime"), {
                    loginTime: Date.now()
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.updateLastSeen] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ze = function ze(e) {
          return _n.setAccessToken(e);
        },
        $e = function $e(e) {
          return _n.setRefreshToken(e);
        },
        Ze = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/auth/getPreRegisterUser/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.getPreRegisteredUser] request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.getPreRegisteredUser] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Je = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r.birthdate && (r.birthdate = O()(r.birthdate).toISOString()), e.next = 4, _n.sendRequest("PATCH", "".concat("v1", "/auth/user/completeExternalRegistration"), Ne(Ne({}, r), {}, {
                    _id: t
                  }));
                case 4:
                  if (!(n = e.sent) || 422 !== n.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Ie(n.data && n.data.error || "");
                case 7:
                  if (!n || 200 === n.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[user.auth.api.completeExternalRegistration] request status is different from 200:\n    ".concat(n.status));
                case 9:
                  return e.abrupt("return", n.data);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Xe = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/sendPassRecovery"), t);
                case 3:
                  if (r = e.sent, n = function n(e) {
                    return 400 === e || 403 === e || 404 === e;
                  }, !(r && r.data.error && n(r.status))) {
                    e.next = 7;
                    break;
                  }
                  throw new Ie(r.data.error);
                case 7:
                  if (!r || 200 === r.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[user.auth.api.requestPasswordRecovery] request status is different from 200:\n    ".concat(r.status));
                case 9:
                  return e.abrupt("return", r.data);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ke = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/getAccessToken"), {
                    accessToken: t,
                    refreshToken: r
                  });
                case 3:
                  if (!(n = e.sent) || 401 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(n.data && n.data.error || "");
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.auth.api.refershAccessToken] request status is different from 200:\n    ".concat(n.status));
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Qe = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/checkEmailOrPhoneExist"), {
                    phone: t,
                    email: n,
                    country: r
                  });
                case 3:
                  return a = e.sent, e.abrupt("return", a.data);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        et = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/checkEmailOrPhoneExist"), {
                    email: t
                  });
                case 3:
                  if (!(r = e.sent) || 403 !== r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(r.data && r.data.error || "");
                case 6:
                  if (!r || 409 !== r.status) {
                    e.next = 8;
                    break;
                  }
                  return e.abrupt("return", r.data);
                case 8:
                  if (!r || 200 === r.status) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[user.auth.api.isEmailExist] request status is different from 200:\n    ".concat(r.status));
                case 10:
                  return e.abrupt("return", r.data);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        tt = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/registerDevice"), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.registerUserDevice] request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        rt = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/logout"), {
                    uniqueId: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.logout] request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        nt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/auth/preRegisterUser"), t);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.auth.api.logout] request status is different from 200:\n    ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var at = {
        getUserData: qe,
        getPreRegisteredUser: Ze,
        getTeamLogoByCode: Ge,
        login: Ae,
        resetPassword: Ye,
        register: Be,
        sendResetPasswordMail: He,
        updateLastSeen: We,
        isValidTeamCode: Ve,
        setLoginUri: function setLoginUri(e) {
          return _n.setLoginUri(e);
        },
        setAccessToken: ze,
        setRefreshToken: $e,
        getAccessToken: function getAccessToken() {
          return _n.getAccessToken();
        },
        getRefreshToken: function getRefreshToken() {
          return _n.getRefreshToken();
        },
        loginWithFacebook: Me,
        loginWithAppleId: Ue,
        verifyPhone: Fe,
        checkVerifyPhone: Le,
        completeExternalRegistration: Je,
        requestPasswordRecovery: Xe,
        refreshAccessToken: Ke,
        isPhoneOrEmailExists: Qe,
        isEmailExist: et,
        registerUserDevice: tt,
        logout: rt,
        sendUserInvitation: nt,
        checkResetTokenIsValid: je,
        verifyUserCodeFromEmail: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.email, n = t.code, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/auth/verifyUserCodeFromEmail"), {
                    email: r,
                    code: n
                  });
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.auth.api.verifyUserCodeFromEmail] request status is different from 200:\n    ".concat(a.status));
                case 7:
                  return e.abrupt("return", a.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        sendOttRegisterEmail: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.email, n = t.clubSlug, e.next = 4, _n.sendRequest("PATCH", "".concat("v1", "/unsecure/sendOttRegisterEmail"), {
                    email: r,
                    clubSlug: n
                  });
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.auth.api.verifyUserCodeFromEmail] response status is different from 200:\n    ".concat(a.status));
                case 7:
                  return e.abrupt("return", a.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        verifyOttUser: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.token, n = t.password, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/unsecure/verifyOttUser"), {
                    token: r,
                    password: n
                  });
                case 4:
                  return a = e.sent, e.abrupt("return", a.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var st = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.getUserData] No userID provided /\n      ".concat(t, " is not a string"));
                case 2:
                  return e.abrupt("return", at.getUserData(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ot = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.completeExternalRegistration] No userID provided / invalid userID");
                case 2:
                  return e.abrupt("return", at.completeExternalRegistration(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        it = function it(e) {
          if (!e) throw new Error("[user.auth.getPreRegisteredUser] Token not provided");
          return at.getPreRegisteredUser(e);
        },
        ut = function ut(e) {
          var t = e;
          if (!e) throw new Error("[user.auth.getTermsAndCondition] No age provided");
          return "string" != typeof e || isNaN(parseInt(e, 10)) || (t = parseInt(e, 10)), t > 13 ? "https://myplay-assets.gcdn.co/terms-of-use/terms-and-conditions-over-13.pdf" : "https://myplay-assets.gcdn.co/terms-of-use/terms-and-conditions-under-13.pdf";
        },
        ct = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && (Rn(t) || Dn(t))) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.login] No identity provided / ".concat(t, " not valid"));
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.login] No password provided / password is not a string");
                case 4:
                  return e.abrupt("return", at.login(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ft = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.loginWithFacebook] No access token provided / access token is not a string");
                case 2:
                  return e.abrupt("return", at.loginWithFacebook(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        dt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.loginWithAppleId] No code is not a string");
                case 2:
                  return e.abrupt("return", at.loginWithAppleId(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        pt = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Dn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.verifyPhone] No phone provided provided / unvalid phone");
                case 2:
                  return e.abrupt("return", at.verifyPhone(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        lt = function lt(e) {
          var t = e.code,
            r = e.requestID,
            n = e.userID,
            a = e.resetPassword,
            s = e.verifyPhone;
          if (!t || !r) throw new Error("[user.auth.checkVerifyPhone] No code or requestID provided");
          return at.checkVerifyPhone({
            code: t,
            requestID: r,
            userID: n,
            resetPassword: a,
            verifyPhone: s
          });
        },
        ht = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o, i, u, c, f;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.email, n = t.password, a = t.teamCode, s = t.birthdate, o = t.country, i = t.phone, u = t.profilePicture, c = t.firstName, f = t.lastName, mt({
                    email: r,
                    password: n,
                    teamCode: a,
                    phone: i,
                    birthdate: s,
                    country: o
                  }), e.abrupt("return", at.register({
                    email: r,
                    password: n,
                    teamCode: a,
                    phone: i,
                    birthdate: s,
                    country: o,
                    avatar: u,
                    firstName: c,
                    lastName: f
                  }));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        mt = function mt(e) {
          var t = e.email,
            r = e.password,
            n = e.teamCode,
            a = e.phone,
            s = e.birthdate;
          if (t && !Rn(t)) throw new Error("[user.auth.register] Email not provided / invalid Email");
          if (!r || !Pn(r)) throw new Error("[user.auth.register] Password not provided / invalid password");
          if (!n || !vt(n)) throw new Error("[user.auth.register] TeamCode not provided / invalid teamCode");
          if (!s || !Pn(s)) throw new Error("[user.auth.register] Birthdate not provided / invalid birthdate");
          if (!(a && Pn(a) || t)) throw new Error("[user.auth.register] phone not provided / phone country");
        },
        vt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("\n      [user.auth.isValidTeamCode] No code provided / invalid code\n    ");
                case 2:
                  return e.abrupt("return", at.isValidTeamCode(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        wt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("\n      [user.auth.getTeamLogoByCode] No code provided / invalid code\n    ");
                case 2:
                  return e.abrupt("return", at.getTeamLogoByCode(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        gt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.checkResetTokenIsValid] No provided token / Token is not a string");
                case 2:
                  return e.abrupt("return", at.checkResetTokenIsValid(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        yt = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.resetPassword] No provided token / Token is not a string");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.resetPassword] No provided password / Password is not a string");
                case 4:
                  return e.abrupt("return", at.resetPassword(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        bt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Rn(t) && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.sendResetPasswordMail] E-mail ".concat(t, " is not valid"));
                case 2:
                  return e.abrupt("return", at.sendResetPasswordMail(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        kt = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r && t && Pn(r) && Pn(t) && (Rn(t) || Dn(t))) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.requestPasswordRecovery] Identity not provided / invalid identity");
                case 2:
                  return e.abrupt("return", at.requestPasswordRecovery((a = {}, L()(a, r, t), L()(a, "country", n), a)));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        xt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.updateLastSeen] No userID provided /\n      ".concat(t, " is not a string"));
                case 2:
                  return e.abrupt("return", at.updateLastSeen(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Tt = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.refreshAccessToken] No refreshToken provided /\n      ".concat(r, " is not a string"));
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.refreshAccessToken] No accessToken provided /\n      ".concat(t, " is not a string"));
                case 4:
                  return e.abrupt("return", at.refreshAccessToken(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Et = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.isPhoneExist] No phone provided /\n      ".concat(t, " is not a string"));
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.isPhoneExist] No country provided /\n      ".concat(r, " is not a string"));
                case 4:
                  return e.abrupt("return", at.isPhoneOrEmailExists(t, r, n));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        _t = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.isPhoneExist] No phone provided /\n      ".concat(t, " is not a string"));
                case 2:
                  if (Rn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.isPhoneExist] Invalid Email");
                case 4:
                  return e.abrupt("return", at.isEmailExist(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ct = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = n.length > 1 && void 0 !== n[1] ? n[1] : {}, Pn(t)) {
                    e.next = 3;
                    break;
                  }
                  throw new Error("[user.auth.registerUserDevice] No userID provided /\n      ".concat(t, " is not a string"));
                case 3:
                  return e.abrupt("return", at.registerUserDevice(t, r));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        St = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.auth.logout] No userID provided /\n      ".concat(t, " is not a string"));
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.auth.logout] No uniqueDeviceId provided /\n      ".concat(r, " is not a string"));
                case 4:
                  return e.abrupt("return", at.logout(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Rt = at.setAccessToken,
        Dt = at.setRefreshToken,
        Pt = at.getAccessToken,
        It = at.getRefreshToken,
        Ot = at.setLoginUri,
        Nt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = t.team, Pn(r)) {
                    e.next = 3;
                    break;
                  }
                  throw new Error("[user.auth.sendUserInvitation] No userID provided /\n      ".concat(r, " is not a string"));
                case 3:
                  return e.abrupt("return", at.sendUserInvitation(t));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        qt = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = t.email, n = t.code, Pn(r)) {
                    e.next = 3;
                    break;
                  }
                  throw new Error("[user.auth.verifyUserCodeFromEmail] No userID provided /\n      ".concat(r, " is not a string"));
                case 3:
                  return e.abrupt("return", at.verifyUserCodeFromEmail({
                    email: r,
                    code: n
                  }));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        At = function At(e) {
          var t = e.email,
            r = e.clubSlug;
          if (!Rn(t) || !Pn(r)) throw new Error("[user.auth.sendOttRegisterEmail] email provided /\n      ".concat(t, " is not a valid Email or clubSlug was not provided"));
          return at.sendOttRegisterEmail({
            email: t,
            clubSlug: r
          });
        },
        Mt = function Mt(e) {
          var t = e.token,
            r = e.password;
          if (!Pn(t) || !Pn(r)) throw new Error("[user.auth.verifyOttUser] should get token and password strings but got ".concat(t, " and ").concat(r));
          return at.verifyOttUser({
            token: t,
            password: r
          });
        },
        Ut = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/activeTasks"));
                case 3:
                  if (!(r = e.sent) || !r.data) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return", r.data);
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Lt = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = a.length > 1 && void 0 !== a[1] ? a[1] : 0, e.next = 4, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/notifications?skip=").concat(r));
                case 4:
                  if (!(n = e.sent) || !n.data) {
                    e.next = 7;
                    break;
                  }
                  return e.abrupt("return", n.data);
                case 7:
                  return e.abrupt("return", null);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ft = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/notification/").concat(t, "/read"));
                case 3:
                  if ((r = e.sent) && 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.notifications.api.markNotificationsAsRead] request status is different 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Bt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/markNotificationsAsRead"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.notifications.api.markAllAsRead] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var Vt = {
        getActiveTasks: Ut,
        getUnreadCount: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/unreadnotifications/count"));
                case 3:
                  if (!(r = e.sent) || !r.data && 0 !== r.data) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return", r.data);
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        markAllAsRead: Bt,
        getNotifications: Lt,
        markNotificationAsRead: Ft,
        cancelTask: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/notification/cancelTask"), {
                    taskId: t,
                    subType: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.notifications.api.cancelTask] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        sendSmsToUsers: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/notifyUser"), {
                    users: t,
                    message: {
                      sms: r
                    }
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.notifications.api.sendSmsToUsers] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Gt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.notifications.getActiveTasks] No user ID");
                case 2:
                  return e.abrupt("return", Vt.getActiveTasks(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Yt = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.notifications.getAllNotifications] No user ID");
                case 2:
                  return e.abrupt("return", Vt.getNotifications(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        jt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.notifications.getAllNotifications] No user ID");
                case 2:
                  return e.abrupt("return", Vt.getUnreadCount(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ht = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.notifications.getAllNotifications] No user ID");
                case 2:
                  return e.abrupt("return", Vt.markAllAsRead(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Wt = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.notifications.markAsRead] No notification ID");
                case 2:
                  return e.abrupt("return", Vt.markNotificationAsRead(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        zt = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Vt.cancelTask(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        $t = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Vt.sendSmsToUsers(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }();
      function Zt(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function Jt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Zt(Object(r), !0).forEach(function (t) {
            L()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zt(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
      var Xt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t));
                case 3:
                  if (200 === (r = e.sent).status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getTeam] No team returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Kt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t));
                case 3:
                  if ((r = e.sent) && 200 === r.status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getTeamsByUser] No teams returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data && r.data.teams);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Qt = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/players"));
                case 3:
                  if ((r = e.sent) && 200 === r.status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getTeamPlayers] No players returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        er = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/players"));
                case 3:
                  if ((r = e.sent) && 200 === r.status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getTeamMembers] No members returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        tr = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = s.length > 1 && void 0 !== s[1] ? s[1] : 0, n = s.length > 2 && void 0 !== s[2] ? s[2] : 0, e.next = 5, _n.sendRequest("GET", "".concat("v1", "/videoContainer/?teamId=").concat(t, "&limit=").concat(r, "&skip=").concat(n));
                case 5:
                  if ((a = e.sent) && 200 === a.status && a.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.api.getTeamVideos] No videos returned, failed with status:\n      ".concat(a.status));
                case 8:
                  return e.abrupt("return", a.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        rr = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = s.length > 1 && void 0 !== s[1] ? s[1] : 0, n = s.length > 2 && void 0 !== s[2] ? s[2] : 0, e.next = 5, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/highlights?limit=").concat(r, "&skip=").concat(n));
                case 5:
                  if ((a = e.sent) && 200 === a.status && a.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.api.getTeamHighlights] No highlights returned, failed with status:\n      ".concat(a.status));
                case 8:
                  return e.abrupt("return", a.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        nr = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/count?teamId=").concat(t));
                case 3:
                  if ((r = e.sent) && 200 === r.status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getCountOfTeamVideos] No count returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ar = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/commentsTypes/add"), r);
                case 3:
                  if ((n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.createTeamTag] Status returned is different from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        sr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/commentsTypes/remove"), {
                    index: r
                  });
                case 3:
                  if ((n = e.sent) && 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.removeTeamTag] Status returned is different from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        or = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/commentsTypes/removeByTitle"), {
                    tag: r
                  });
                case 3:
                  if ((n = e.sent) && 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.removeTeamTag] Status returned is different from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ir = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/checkTeamCode?code=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getTeamByCode] Status returned is different from 200. status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ur = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/teams/").concat(r, "/add"));
                case 3:
                  if (!(n = e.sent) || 409 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(n.data.error);
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.api.addTeamToUser] Status returned is different from 200. status:\n      ".concat(n.status));
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        cr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/teams/").concat(r, "/remove"));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.removeUserFromTeam] Status returned is different from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        fr = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/refreshCode"));
                case 3:
                  if (200 === (r = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.refreshTeamCode] Status returned is different from 200. status:\n      ".concat(r.status));
                case 6:
                  if ((!r || r.data) && r.data.code) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.api.refreshTeamCode] No data / code returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        dr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/updateTeamImage"), {
                    teamImage: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateTeamImage] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        pr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/updateTeamCoverImage"), {
                    teamCoverImage: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateTeamImage] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        lr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t), {
                    name: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateTeamName] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        hr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/attachUsers"), {
                    users: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.attachUsersToTeam] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        mr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t), Jt({}, r));
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateTeam] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        vr = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/siteResource"), {
                    fileName: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.uploadSiteResource] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        wr = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a, s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return a = "".concat("v1", "/team?populate=").concat(r.join(), '&query={"$or":[{"name":{"$regex":"').concat(t, '","$options":"i"}},{"code":{"$regex":"').concat(t, '","$options":"i"}}]}&limit=').concat(n), e.next = 4, _n.sendRequest("GET", a);
                case 4:
                  if (200 === (s = e.sent).status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.updateTeam] Status returned is from 200. status:\n      ".concat(s.status));
                case 7:
                  return e.abrupt("return", s.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        gr = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = "".concat("v1", "/unsecure/team/").concat(t, "/getFundraisingData"), e.next = 4, _n.sendRequest("GET", r);
                case 4:
                  if (200 === (n = e.sent).status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.getFundraisingData] Status returned is from 200. status:\n      ".concat(n.status));
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        yr = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = "".concat("v1", "/insecure/team/").concat(t, "/creditStatus"), e.next = 4, _n.sendRequest("GET", r);
                case 4:
                  if (200 === (n = e.sent).status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.getFundraisingData] Status returned is from 200. status:\n      ".concat(n.status));
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var br = {
        addTeamToUser: ur,
        getTeam: Xt,
        getTeamByCode: ir,
        getTeamPlayers: Qt,
        getTeamMembers: er,
        getTeamsByUser: Kt,
        getTeamVideos: tr,
        getCountOfTeamVideos: nr,
        removeTeamTag: sr,
        removeTeamTagByTitle: or,
        createTeamTag: ar,
        removeUserFromTeam: cr,
        refreshTeamCode: fr,
        updateTeamImage: dr,
        updateTeamName: lr,
        updateTeamCoverImage: pr,
        attachUsersToTeam: hr,
        updateTeam: mr,
        getTeamHighlights: rr,
        getTeamsByString: wr,
        uploadSiteResource: vr,
        getFundraisingData: gr,
        getTeamsUserIsAdmin: function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = "".concat("v1", "/user/").concat(t, "/adminTeams"), e.next = 4, _n.sendRequest("GET", r);
                case 4:
                  if (200 === (n = e.sent).status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.getTeamsUserIsAdmin] Status returned is from 200. status:\n      ".concat(n.status));
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getCreditsStatus: yr,
        getLeanTeam: function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = "".concat("v1", "/insecure/team/").concat(t, "/lean"), e.next = 4, _n.sendRequest("GET", r);
                case 4:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.getLeanTeam] Status returned is from 200. status:\n      ".concat(n.status));
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var kr = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeam] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeam(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        xr = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamByCode] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeamByCode(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Tr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.addTeamToUser] No team ID provided / invalid team ID");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.addTeamToUser] No user ID provided / invalid user ID");
                case 4:
                  return e.abrupt("return", br.addTeamToUser(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Er = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamsByUser] No user ID provided / invalid user ID");
                case 2:
                  return e.abrupt("return", br.getTeamsByUser(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        _r = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamPlayers] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeamPlayers(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Cr = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamMembers] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeamMembers(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Sr = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamHighlights] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeamHighlights(t, r, n));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Rr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.removeUserFromTeam] No team ID provided / invalid team ID");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.removeUserFromTeam] No user ID provided / invalid user ID");
                case 4:
                  return e.abrupt("return", br.removeUserFromTeam(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Dr = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, kr(t);
                case 2:
                  return r = e.sent, e.abrupt("return", r && r.category && r.category.name);
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Pr = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamVideos] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getTeamVideos(t, r, n));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Ir = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.getTeamVideos] No team ID provided / invalid team ID");
                case 2:
                  return e.abrupt("return", br.getCountOfTeamVideos(t, r, n));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Or = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.createTeamTag] No team ID provided");
                case 2:
                  return e.abrupt("return", br.createTeamTag(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Nr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.removeTeamTag] No team ID provided");
                case 2:
                  if (r && "number" == typeof r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.removeTeamTag] No tag provided / tag is not a number");
                case 4:
                  return e.abrupt("return", br.removeTeamTag(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        qr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.removeTeamTag] No team ID provided");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.removeTeamTag] No tag provided");
                case 4:
                  return e.abrupt("return", br.removeTeamTagByTitle(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ar = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.getGameTags] No teamID provided / invalid teamID");
                case 2:
                  return e.next = 4, kr(t);
                case 4:
                  return r = e.sent, n = r.category, a = r.commentsTypes, s = n.defaultTags, e.abrupt("return", {
                    defaults: s || [],
                    customs: a || []
                  });
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Mr = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.getGameTags] No teamID provided / invalid teamID");
                case 2:
                  return e.abrupt("return", br.refreshTeamCode(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ur = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamImage] teamID not provided / teamID not a string");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamImage] No image provided");
                case 4:
                  return e.abrupt("return", br.updateTeamImage(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Lr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamCoverImage] teamID not provided / teamID not a string");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamImage] No image provided");
                case 4:
                  return e.abrupt("return", br.updateTeamCoverImage(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Fr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamName] teamID not provided / teamID not a string");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.updateTeamName] No image provided");
                case 4:
                  return e.abrupt("return", br.updateTeamName(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Br = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.attachUsersToTeam] teamID not provided / teamID not a string");
                case 2:
                  if (!(r.length <= 0)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.attachUsersToTeam] no users provided");
                case 4:
                  return e.abrupt("return", br.attachUsersToTeam(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Vr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.updateTeam] teamID not provided / teamID not a string");
                case 2:
                  return e.abrupt("return", br.updateTeam(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Gr = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = a.length > 1 && void 0 !== a[1] ? a[1] : [], n = a.length > 2 && void 0 !== a[2] ? a[2] : 100, t) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.teams.getTeamsByString] query string not provided");
                case 4:
                  if (Array.isArray(r)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.teams.getTeamsByString] populate must be an array of strings");
                case 6:
                  return e.abrupt("return", br.getTeamsByString(t, r, n));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Yr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.teams.updateTeam] teamID not provided / teamID not a string");
                case 2:
                  return e.abrupt("return", br.uploadSiteResource(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        jr = function jr(e) {
          if (!Pn(e)) throw new Error("[user.teams.getFundraisingData] teamId not provided / teamID not a string");
          return br.getFundraisingData(e);
        },
        Hr = function Hr(e) {
          if (!Pn(e)) throw new Error("[user.teams.getTeamsUserIsAdmin] userId not provided / userId not a string");
          return br.getTeamsUserIsAdmin(e);
        },
        Wr = function Wr(e) {
          if (!Pn(e)) throw new Error("[user.teams.getCreditsStatus] teamId not a string");
          return br.getCreditsStatus(e);
        },
        zr = function zr(e) {
          if (!Pn(e)) throw new Error("[user.teams.getLeanTeam] teamId not a string");
          return br.getLeanTeam(e);
        };
      var $r = {
        updateUserData: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t), r);
                case 3:
                  if (!(n = e.sent) || 409 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(n.data && n.data.error || "");
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.settings.api.updateUserData] request status is different from 200:\n      ".concat(n.status));
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        updateProfileImage: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/updateImage"), {
                    avatar: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.settings.api.updateProfileImage] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        changeToOperator: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/markAsOperator"), {});
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.settings.api.changeToOperator] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getPlayerNumberByTeam: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(r, "/teams/").concat(t, "/playerNumber"), {});
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.settings.api.getPlayerNumberByTeam] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.settings.api.getPlayerNumberByTeam] No data returned");
                case 8:
                  return e.abrupt("return", n.data.playerNumber);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        createDummyUser: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/user/dummy"), {
                    playerNumber: t,
                    teamId: r
                  });
                case 3:
                  if (!(n = e.sent) || 409 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error(n.error);
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.settings.api.createDummyUser] request status is different from 200:\n      ".concat(n.status));
                case 8:
                  if (!n || n.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[user.settings.api.createDummyUser] No data returned");
                case 10:
                  return e.abrupt("return", null);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        updateTaggerData: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/user/").concat(t, "/taggerData"), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.settings.api.updateTaggerData] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getTaggerData: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/taggerData"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.settings.api.getTaggerData] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[user.settings.api.getTaggerData] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Zr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.updateUserData] userID not provided / userID not a string");
                case 2:
                  if (r && "object" === P()(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.settings.updateUserData] data not provided / data is not a string");
                case 4:
                  return e.abrupt("return", $r.updateUserData(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Jr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.updateProfileImage] userID not provided / userID not a string");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.settings.updateProfileImage] No image provided");
                case 4:
                  return e.abrupt("return", $r.updateProfileImage(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Xr = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.changeToOperator] userId not provided / userId not a string");
                case 2:
                  return e.abrupt("return", $r.changeToOperator(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Kr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.getPlayerNumberByTeam] teamId not provided / teamId not a string");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.settings.getPlayerNumberByTeam] userId not provided / userId not a string");
                case 4:
                  return e.abrupt("return", $r.getPlayerNumberByTeam(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Qr = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.createDummyUser] teamId not provided / teamId not a string");
                case 2:
                  return e.abrupt("return", $r.createDummyUser(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        en = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.updateTaggerData] userId not provided / userId not a string");
                case 2:
                  return e.abrupt("return", $r.updateTaggerData(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        tn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.settings.getTaggerData] userId not provided / userId not a string");
                case 2:
                  return e.abrupt("return", $r.getTaggerData(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var rn = {
        getClubsByUser: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/clubs"));
                case 3:
                  if (200 === (r = e.sent).status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getClubsByUser] No club returned, failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        createNewTeam: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/club/").concat(t, "/team"), {
                    team: r
                  });
                case 3:
                  if (200 === (n = e.sent).status && n.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.createNewTeam] failed with status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getClubTeams: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/club/").concat(t, "/team"));
                case 3:
                  if (200 === (r = e.sent).status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getClubTeams] failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getClubVideos: function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s, o;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return s = JSON.stringify(a || {}), e.next = 4, _n.sendRequest("GET", "".concat("v1", "/club/").concat(t, "/videoContainers?limit=").concat(r, "&skip=").concat(n, "&filters=").concat(s));
                case 4:
                  if (200 === (o = e.sent).status && o.data) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[user.api.getClubVideos] failed with status:\n      ".concat(o.status));
                case 7:
                  return e.abrupt("return", o.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        checkClubSites: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/club/").concat(t, "/checkSites"));
                case 3:
                  if (200 === (r = e.sent).status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.checkClubSites] failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        removeTeam: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/club/").concat(t, "/team/").concat(r, "/remove"));
                case 3:
                  if (204 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.removeTeam] failed with status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getClubById: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/club/").concat(t));
                case 3:
                  if (200 === (r = e.sent).status && r.data) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.checkClubSites] failed with status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateClubLogo: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/club/").concat(t, "/updateClubLogo"), {
                    clubLogo: r
                  });
                case 3:
                  if (200 === (n = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateClubLogo] Status returned is from 200. status:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getClubsList: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/clubsList"));
                case 3:
                  if (200 === (r = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.updateClubLogo] Status returned is from 200. status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getOttClubData: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/club/").concat(t));
                case 3:
                  if (200 === (r = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getOttClubData] Status returned is from 200. status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getClubRunningLiveSessions: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/club/").concat(t, "/runningLiveSessions"));
                case 3:
                  if (200 === (r = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getClubRunningLiveSessions] Status returned is from 200. status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getClubFundraisingData: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/club/").concat(t, "/fundraisingData"));
                case 3:
                  if (200 === (r = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getClubFundraisingData] Status returned is from 200. status:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getAllClubsList: function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/club"));
                case 3:
                  if (200 === (t = e.sent).status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[user.api.getAllClubsList] Status returned is from 200. status:\n      ".concat(t.status));
                case 6:
                  return e.abrupt("return", t.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      };
      var nn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubsByUser] No user ID provided / invalid user ID");
                case 2:
                  return e.abrupt("return", rn.getClubsByUser(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        an = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.createNewTeam] No club ID provided / invalid club ID");
                case 2:
                  return e.abrupt("return", rn.createNewTeam(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        sn = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.removeTeam] No club ID provided / invalid club ID");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.clubs.removeTeam] No team ID provided / invalid team ID");
                case 4:
                  return e.abrupt("return", rn.removeTeam(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        on = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubTeam] No club ID provided / invalid club ID");
                case 2:
                  return e.abrupt("return", rn.getClubTeams(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        un = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubVideos] No club ID provided / invalid club ID");
                case 2:
                  return e.abrupt("return", rn.getClubVideos(t, r, n, a));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        cn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.checkClubSites] No club ID provided / invalid club ID");
                case 2:
                  return e.abrupt("return", rn.checkClubSites(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        fn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubsByUser] No user ID provided / invalid user ID");
                case 2:
                  return e.abrupt("return", rn.getClubById(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        dn = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.updateClubLogo] clubId not provided / clubId not a string");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[user.clubs.updateClubLogo] No image provided");
                case 4:
                  return e.abrupt("return", rn.updateClubLogo(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        pn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubsList] no valid userId provided");
                case 2:
                  return e.abrupt("return", rn.getClubsList(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ln = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getOttClubData] no valid club identifier");
                case 2:
                  return e.abrupt("return", rn.getOttClubData(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        hn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubRunningLiveSessions] no valid club identifier");
                case 2:
                  return e.abrupt("return", rn.getClubRunningLiveSessions(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        mn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[user.clubs.getClubFundraisingData] no valid club identifier");
                case 2:
                  return e.abrupt("return", rn.getClubFundraisingData(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        vn = function vn() {
          return rn.getAllClubsList();
        };
      var wn = {
        auth: e,
        notifications: t,
        teams: a,
        settings: s,
        clubs: o
      };
      var gn = "".concat(A, "accessToken"),
        yn = "".concat(A, "refreshToken");
      var bn = function () {
        function e() {
          B()(this, e), this.accessToken = "", this.refreshToken = "", "undefined" != typeof window && window.localStorage && (this.accessToken = localStorage.getItem(gn) || "", this.refreshToken = localStorage.getItem(yn) || ""), this.loginUri = "https://id.myplay.com";
        }
        return G()(e, [{
          key: "_isLocalStorageAvailable",
          get: function get() {
            return "undefined" != typeof window && window && window.localStorage;
          }
        }, {
          key: "setLoginUri",
          value: function value(e) {
            this._loginUri = e;
          }
        }, {
          key: "getLoginUri",
          value: function value() {
            return this._loginUri;
          }
        }, {
          key: "setAccessToken",
          value: function value(e) {
            Hn(e) && !jn(e) && (this._accessToken = e, this._isLocalStorageAvailable && localStorage.setItem(gn, '"'.concat(e, '"')));
          }
        }, {
          key: "getAccessToken",
          value: function value() {
            return this._accessToken;
          }
        }, {
          key: "getRefreshToken",
          value: function value() {
            return this._refreshToken;
          }
        }, {
          key: "setRefreshToken",
          value: function value(e) {
            Hn(e) && !jn(e) && (this._refreshToken = e, this._isLocalStorageAvailable && localStorage.setItem(yn, '"'.concat(e, '"')));
          }
        }]), e;
      }();
      function kn(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function xn(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? kn(Object(r), !0).forEach(function (t) {
            L()(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kn(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
      var Tn = q("PRODUCTION"),
        En = ["unsecure", "auth", "liveProduction"];
      var _n = new (function (e) {
        re()(s, e);
        var t,
          r,
          n,
          a = (r = s, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = oe()(r);
            if (n) {
              var a = oe()(this).constructor;
              e = Reflect.construct(t, arguments, a);
            } else e = t.apply(this, arguments);
            return ae()(this, e);
          });
        function s() {
          var e;
          return B()(this, s), (e = a.call(this)).BASE_URL = Tn.NODE_API_URL, e;
        }
        return G()(s, [{
          key: "sendRequest",
          value: (t = C()(R().mark(function e(t, r, n, a) {
            var s,
              o,
              i,
              u,
              c,
              f,
              d,
              p = this,
              l = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return s = l.length > 4 && void 0 !== l[4] && l[4], o = l.length > 5 ? l[5] : void 0, i = l.length > 6 ? l[6] : void 0, u = this, c = "".concat(this.BASE_URL, "/").concat(r), f = Object.assign({}, a, {
                    Authorization: "Bearer ".concat(this.getAccessToken())
                  }), d = xn(xn({}, d = {
                    url: s ? r : c,
                    method: t,
                    data: n,
                    headers: f,
                    timeout: o || 0,
                    validateStatus: function validateStatus(e) {
                      return e >= 200 && e < 300 || 409 === e;
                    }
                  }), i), "GET" === t && delete d.data, e.abrupt("return", E()(d)["catch"](function () {
                    var e = C()(R().mark(function e(t) {
                      var r, n, a, s, o, i;
                      return R().wrap(function (e) {
                        for (;;) switch (e.prev = e.next) {
                          case 0:
                            if (r = wn.auth, n = t.config, a = n.url.includes("api.myplay.com/ccapi/") ? p.BASE_URL.replace("com/api", "com/ccapi") : p.BASE_URL, s = n.url.split("".concat(a, "/v1/"))[1].split("/")[0], En.includes(s) || "undefined" == typeof window || !window || !jn(u.getAccessToken()) && !jn(u.getRefreshToken())) {
                              e.next = 7;
                              break;
                            }
                            return e.abrupt("return");
                          case 7:
                            if (!t.response || 401 !== t.response.status) {
                              e.next = 30;
                              break;
                            }
                            if (401 !== t.response.status || -1 !== t.config.url.indexOf("auth/user") || -1 !== t.config.url.indexOf("getAccessToken")) {
                              e.next = 25;
                              break;
                            }
                            return e.prev = 9, e.next = 12, r.refreshAccessToken(u.getAccessToken(), u.getRefreshToken());
                          case 12:
                            return (o = e.sent).accessToken !== localStorage.getItem("MYPLAY/accessToken") && u.setAccessToken(o.accessToken), n.headers.Authorization = "Bearer ".concat(o.accessToken), e.next = 17, Gn(n);
                          case 17:
                            return i = e.sent, e.abrupt("return", Promise.resolve(i));
                          case 21:
                            throw e.prev = 21, e.t0 = e["catch"](9), console.error(e.t0), new Error(e.t0);
                          case 25:
                            if (!(t && t.response && t.response.data)) {
                              e.next = 27;
                              break;
                            }
                            return e.abrupt("return", Promise.reject(t.response.data));
                          case 27:
                            throw new Error("Should Logout");
                          case 30:
                            if (!t.response || 403 !== t.response.status || !t.response.data || "Not allowed" !== t.response.data.message) {
                              e.next = 32;
                              break;
                            }
                            return e.abrupt("return", Promise.reject(t));
                          case 32:
                            if (!(t && t.response && t.response.data && t.response.data.error)) {
                              e.next = 34;
                              break;
                            }
                            return e.abrupt("return", Promise.resolve(t.response));
                          case 34:
                            return e.abrupt("return", Promise.reject(t));
                          case 35:
                          case "end":
                            return e.stop();
                        }
                      }, e, null, [[9, 21]]);
                    }));
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  }()));
                case 10:
                case "end":
                  return e.stop();
              }
            }, e, this);
          })), function (e, r, n, a) {
            return t.apply(this, arguments);
          })
        }]), s;
      }(bn))();
      var Cn = q("PRODUCTION");
      var Sn = new (function (e) {
        re()(s, e);
        var t,
          r,
          n,
          a = (r = s, n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = oe()(r);
            if (n) {
              var a = oe()(this).constructor;
              e = Reflect.construct(t, arguments, a);
            } else e = t.apply(this, arguments);
            return ae()(this, e);
          });
        function s() {
          var e;
          return B()(this, s), (e = a.call(this)).BASE_URL = Cn.CC_API_URL, e;
        }
        return G()(s, [{
          key: "sendRequest",
          value: (t = C()(R().mark(function e(t, r, n, a) {
            var s,
              o,
              i,
              u = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return s = u.length > 4 && void 0 !== u[4] && u[4], o = "".concat(this.BASE_URL, "/").concat(r), i = Object.assign({}, a, {
                    Authorization: "Bearer ".concat(this.getAccessToken())
                  }), e.abrupt("return", E()({
                    url: s ? r : o,
                    data: n,
                    method: t,
                    headers: i
                  })["catch"](function (e) {
                    if (e.response) return e.response;
                    throw e.request ? new Error(e) : new Error(e.message);
                  }));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e, this);
          })), function (e, r, n, a) {
            return t.apply(this, arguments);
          })
        }, {
          key: "setBaseUrl",
          value: function value(e) {
            if (e !== Cn.CC_API_URL && e !== Cn.CC_V2_API_URL) throw new Error("[BaseApi.setBaseUrl] Not setting new ccApiUrl because its not includes with whitelist urls");
            if (e === this.BASE_URL) throw new Error("[BaseApi.setBaseUrl] desired Url equal the current Url");
            this.BASE_URL = e;
          }
        }]), s;
      }(bn))();
      var Rn = function Rn(e) {
          if ("string" != typeof e || "" !== e && !e) throw new Error("[utils.isValidEmail] No email provided");
          return new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(e);
        },
        Dn = function Dn(e) {
          if ("string" != typeof e || "" !== e && !e) throw new Error("[utils.isValidPhone] No phone provided");
          return new RegExp(/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{8}))/g).test(e);
        },
        Pn = function Pn(e) {
          return Boolean(e && e.length && "string" == typeof e);
        },
        In = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, E().get("http://ipinfo.io/ip");
                case 2:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.getIP] request status is different from 200:\n      ".concat(t.status));
                case 5:
                  return e.abrupt("return", t.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        On = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/getCountriesList"));
                case 3:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[utils.getCountriesList] request status is different from 200:\n      ".concat(t.status));
                case 6:
                  if (!t || t.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[utils.getCountriesList] No data returned");
                case 8:
                  return e.abrupt("return", t.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        Nn = function Nn(e) {
          return !(!e || !Array.isArray(e)) && e.every(function (e) {
            return Pn(e);
          });
        },
        qn = function qn(e) {
          return !(!e || !Array.isArray(e)) && e.every(function (e) {
            return Number.isInteger(e);
          });
        },
        An = function e(t) {
          var r = new Error("Required paramater ".concat(t, " is missing"));
          throw "function" == typeof Error.captureStackTrace && Error.captureStackTrace(r, e), r;
        },
        Mn = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "v1/unsecure/invisibleUsers");
                case 2:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.getInvisibleUsers] request status is different from 200:\n      ".concat(t.status));
                case 5:
                  return e.abrupt("return", t.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        Un = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "v1/unsecure/parseMobilePath", {
                    path: t
                  });
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.parseMobilePath] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ln = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "v1/sharedItem/".concat(t));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.getShareItem] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Fn = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "v1/sharedItem", {
                    sharedType: t,
                    sharedItemId: r
                  });
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.createShareItem] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Bn = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "v1/sharedItem/".concat(t, "/invalid"), {
                    linkId: t
                  });
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.setInvalidStatusForShareItem] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Vn = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "v1/unsecure/mobileApp/init");
                case 2:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[utils.getMobileAppInitData] request status is different from 200:\n      ".concat(t.status));
                case 5:
                  return e.abrupt("return", t.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        Gn = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", E()(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Yn = function Yn(e) {
          return null !== e && ("function" == typeof e || "object" === P()(e));
        },
        jn = function jn(e) {
          return Yn(e) && Object && 0 === Object.keys(e).length;
        },
        Hn = function Hn(e) {
          return !(null == e || void 0 === e);
        };
      var Wn = {
        isValidString: Pn,
        isValidEmail: Rn,
        isValidPhone: Dn,
        getIP: In,
        getCountriesList: On,
        isArrayOfStrings: Nn,
        createDurationFromSeconds: function createDurationFromSeconds(e) {
          if (!e || "number" != typeof e || Number.isNaN(e)) throw new Error("[utils.createDurationFromSceonds] No seconds provided / invalid seconds");
          return O().duration(e, "seconds").format("hh:mm:ss", {
            trim: !1
          });
        },
        createDurationFromStartAndEndMilliseconds: function createDurationFromStartAndEndMilliseconds(e, t) {
          if (!e || "number" != typeof e || Number.isNaN(e)) throw new Error("[utils.createDurationFromStartAndEndMilliseconds] No start provided / invalid start");
          if (!t || "number" != typeof t || Number.isNaN(t)) throw new Error("[utils.createDurationFromStartAndEndMilliseconds] No end provided / invalid end");
          var r = O()(e),
            n = O()(t);
          return O().duration(n.diff(r), "seconds").format("mm:ss", {
            trim: !1
          });
        },
        isHebrew: function isHebrew(e) {
          return e.search(/[\u0590-\u05FF]/) >= 0;
        },
        requiredParam: An,
        getInvisibleUsers: Mn,
        sendRequest: Gn,
        parseMobilePath: Un,
        getShareItem: Ln,
        setShareItem: Fn,
        setInvalidStatusForShareItem: Bn,
        setCcApiBaseUrl: function setCcApiBaseUrl(e) {
          try {
            var t = q("PRODUCTION");
            e || (e = t.CC_API_URL), Sn.setBaseUrl(e);
          } catch (e) {
            console.log(e);
          }
        },
        copyToClipboard: function copyToClipboard(e) {
          if (document && window) {
            var t = document.createElement("textarea");
            t.style.maxHeight = "0px", t.style.height = "0px", t.style.opacity = 0, t.value = e, document.body.appendChild(t), t.select(), window.document.execCommand("copy"), document.body.removeChild(t);
          }
        },
        healthCheck: function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, e.next = 3, _n.sendRequest("GET", "https://api.myplay.com/", null, null, !0);
                case 3:
                  return t = e.sent, e.abrupt("return", t && 200 === t.status);
                case 7:
                  return e.prev = 7, e.t0 = e["catch"](0), e.abrupt("return", !1);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 7]]);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getCategories: function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 1, e.next = 4, _n.sendRequest("GET", "".concat("v1", "/category"));
                case 4:
                  return t = e.sent, e.abrupt("return", t.data);
                case 8:
                  e.prev = 8, e.t0 = e["catch"](1), console.log(e.t0);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e, null, [[1, 8]]);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        Upload: be,
        ImageTools: De,
        checkInternetConnection: function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.prev = 0, t = "https://app.myplay.com?rand=".concat(Date.now()), e.next = 4, fetch(t, {
                    method: "HEAD",
                    mode: "no-cors"
                  });
                case 4:
                  return e.abrupt("return", !0);
                case 7:
                  return e.prev = 7, e.t0 = e["catch"](0), console.log(e.t0), e.abrupt("return", !1);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 7]]);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        isEmpty: jn,
        isSet: Hn,
        isObject: Yn,
        isNumeric: function isNumeric(e) {
          return e - 0 === e && ("" + e).trim().length > 0;
        },
        getMobileAppInitData: Vn,
        extractTokensFromUrl: function extractTokensFromUrl() {
          var e = new URLSearchParams(window.location.search);
          return {
            accessToken: e.get("accessToken"),
            refreshToken: e.get("refreshToken"),
            userId: e.get("userId")
          };
        },
        base64ImgToFile: function base64ImgToFile(e, t) {
          try {
            for (var r = e.split(","), n = r[0].match(/:(.*?);/)[1], a = atob(r[1]), s = a.length, o = new Uint8Array(s); s--;) o[s] = a.charCodeAt(s);
            return new File([o], t, {
              type: n
            });
          } catch (e) {
            throw new Error(e.message);
          }
        },
        localStorageGet: function localStorageGet(e) {
          if (!e) throw new Error("[utils.localStorageGet] should get key argument but got ".concat(e));
          if ("undefined" != typeof window && window) {
            var t = window.localStorage.getItem(e);
            return t ? JSON.parse(t) : t;
          }
        },
        localStorageSet: function localStorageSet(e, t) {
          if (!e) throw new Error("[utils.localStorageSet] should get key as first argument but got ".concat(e));
          "undefined" != typeof window && window && window.localStorage.setItem(e, JSON.stringify(t));
        },
        generateNanoId: function generateNanoId(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 8;
          return "".concat(e).concat(function () {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8, t = "", r = 0; r < e; r++) {
              var n = Math.floor(64 * Math.random());
              t += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict".charAt(n);
            }
            return t;
          }(t));
        }
      };
      var zn = q("PRODUCTION"),
        $n = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/site"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getSite] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getSite] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Zn = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/currentTime"));
                case 3:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getCurrentTime] Request status is different from 200:\n    ".concat(t.status));
                case 6:
                  if (!t || t.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getCurrentTime] No data returned from request");
                case 8:
                  return e.abrupt("return", t.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        Jn = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/checkSite"), {});
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.site.api.checkSite] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.site.api.checkSite] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Xn = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat(zn.NODE_CCAPI_URL, "/").concat("v1", "/checkSite"), {
                    siteId: t
                  }, {}, !0);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.site.api.checkSiteBySiteId] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.site.api.checkSiteBySiteId] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Kn = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/site/").concat(t, "/snapshot"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getSiteSnapshot] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.site.api.getSiteSnapshot] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Qn = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.mode, a = t.shutterValue, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/team/").concat(r, "/setCameraMode"), {
                    mode: n,
                    shutterValue: a
                  });
                case 4:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.site.api.setCameraMode] Request status is different from 200:\n    ".concat(s.status));
                case 7:
                  return e.abrupt("return", s.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var ea = {
        getSite: $n,
        checkSite: Jn,
        getCurrentTime: Zn,
        checkSiteBySiteId: Xn,
        getSiteSnapshot: Kn,
        setCameraPosition: function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/team/").concat(r, "/setCameraPosition"));
                case 4:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.site.api.setCameraPosition] Request status is different from 200:\n    ".concat(n.status));
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        setCameraMode: Qn,
        rebootCamera: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.hasLive, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/team/").concat(r, "/rebootCamera"), {
                    hasLive: n
                  });
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.site.api.rebootCamera] Request status is different from 200:\n    ".concat(a.status));
                case 7:
                  return e.abrupt("return", a.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var ta = function ta() {
          return ea.getCurrentTime();
        },
        ra = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.site.getSiteData] No team id provided / invalid team id");
                case 2:
                  return e.abrupt("return", ea.getSite(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        na = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.site.checkSite] No team id provided / invalid team id");
                case 2:
                  return e.abrupt("return", ea.checkSite(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        aa = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.site.checkSiteBySiteId] No site id provided / invalid site id");
                case 2:
                  return e.abrupt("return", ea.checkSiteBySiteId(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        sa = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, ra(t);
                case 2:
                  return r = e.sent, e.abrupt("return", r && r.isOnline);
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        oa = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.site.getSiteSnapshot] No site id provided / invalid site id");
                case 2:
                  return e.next = 4, ea.getSiteSnapshot(t);
                case 4:
                  return r = e.sent, e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ia = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.mode, a = t.shutterValue, e.next = 3, ea.setCameraMode({
                    teamId: r,
                    mode: n,
                    shutterValue: a
                  });
                case 3:
                  return s = e.sent, e.abrupt("return", s && s.isOnline);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ua = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, e.next = 3, ea.setCameraPosition({
                    teamId: r
                  });
                case 3:
                  return n = e.sent, e.abrupt("return", n && n.isOnline);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ca = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.hasLive, e.next = 3, ea.rebootCamera({
                    teamId: r,
                    hasLive: n
                  });
                case 3:
                  return a = e.sent, e.abrupt("return", a && a.isOnline);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        fa = r(861),
        da = r.n(fa),
        pa = q("PRODUCTION"),
        la = function () {
          var e = C()(R().mark(function e(t, r) {
            var n,
              a,
              s,
              o,
              i,
              u,
              c,
              f = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return n = f.length > 2 && void 0 !== f[2] ? f[2] : 0, a = f.length > 3 ? f[3] : void 0, s = f.length > 4 ? f[4] : void 0, o = f.length > 5 ? f[5] : void 0, i = f.length > 6 ? f[6] : void 0, u = f.length > 7 ? f[7] : void 0, e.next = 9, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/startLiveBroadcast"), {
                    channel: 1,
                    recordDuration: r,
                    teamId: t,
                    senderId: a,
                    cameraIndex: n,
                    thirdPartyProxyUri: s || null,
                    youTubeShareLink: o || null,
                    videoContainerId: i || null,
                    bookingId: u || null
                  });
                case 9:
                  if (!(c = e.sent) || 200 === c.status) {
                    e.next = 12;
                    break;
                  }
                  throw new Error("[camera-control.live.api.startLive] Request status is different from 200:\n    ".concat(c.status));
                case 12:
                  if (!c || c.data && c.data.liveSessionId) {
                    e.next = 14;
                    break;
                  }
                  throw new Error("[camera-control.live.api.startLive] No data returned from request / no liveSessionsID present");
                case 14:
                  return e.abrupt("return", c.data.liveSessionId);
                case 15:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ha = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/stopLiveBroadcast"), {
                    closerId: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.startLive] Request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ma = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/liveAuth"), {
                    name: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.liveAuth] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.live.api.startLive] No data returned from request");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        va = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = new Date().getTime(), e.next = 4, _n.sendRequest("GET", "".concat(pa.NODE_CCAPI_URL, "/").concat("v1", "/isLiveReady/").concat(t, "?").concat(r), {}, {}, !0, 15e3);
                case 4:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.live.api.liveAuth] Request status is different from 200:\n    ".concat(n.status));
                case 7:
                  if (!n || "boolean" === P()(n.data)) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[camera-control.live.api.startLive] No data returned from request");
                case 9:
                  return e.abrupt("return", n.data);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        wa = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/goPublic"), {
                    liveId: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.goPublic] Request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ga = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/liveTitle"), {
                    liveId: r,
                    title: n
                  });
                case 3:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.setLiveTitle] Request status is different from 200:\n    ".concat(a.status));
                case 6:
                  return e.abrupt("return", a.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }();
      var ya = {
        startLive: la,
        stopLive: ha,
        liveAuth: ma,
        getCameraURLStatus: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, E().get(t, {
                    validateStatus: function validateStatus(e) {
                      return e >= 200 && e < 550;
                    }
                  });
                case 2:
                  return r = e.sent, e.abrupt("return", r.status);
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        goPublic: wa,
        setLiveTitle: ga,
        isLiveReady: va,
        getLiveSessions: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/liveSessions?skip=").concat(t, "&team=").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.getLiveSessions] Request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getLiveSessionBySessionId: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat(pa.NODE_CCAPI_URL, "/").concat("v1", "/getLiveBySessionId/").concat(t), {}, {}, !0);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.getLiveSessionBySessionId] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        liveDone: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat(pa.NODE_CCAPI_URL, "/").concat("v1", "/liveDone/"), {
                    name: t
                  }, {}, !0);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.live.api.liveDone] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var ba,
        ka = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ya.liveDone(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        xa = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ya.getLiveSessionBySessionId(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ta = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ya.getLiveSessions(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ea = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s,
              o,
              i,
              u,
              c = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = c.length > 1 && void 0 !== c[1] ? c[1] : 10800, n = c.length > 2 ? c[2] : void 0, a = c.length > 3 ? c[3] : void 0, s = c.length > 4 ? c[4] : void 0, o = c.length > 5 ? c[5] : void 0, i = c.length > 6 ? c[6] : void 0, u = c.length > 7 ? c[7] : void 0, Pn(t)) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[camera-control.live.startLive] No teamID provided / invalid teamID");
                case 9:
                  if (Pn(a)) {
                    e.next = 11;
                    break;
                  }
                  throw new Error("[camera-control.live.startLive] No senderID provided / invalid senderID");
                case 11:
                  return e.abrupt("return", ya.startLive(t, r, n, a, s, o, i, u));
                case 12:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        _a = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.live.stopLive] No siteID provided / invalid siteID");
                case 2:
                  return e.abrupt("return", ya.stopLive(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ca = [],
        Sa = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.live.getLiveCamerasStatus] No liveID provided / invalid liveID");
                case 2:
                  return e.abrupt("return", ya.liveAuth(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ra = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.live.goPublic] No liveID provided / invalid liveID");
                case 2:
                  return e.abrupt("return", ya.goPublic(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Da = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.live.goPublic] No liveID provided / invalid liveID");
                case 2:
                  if (Pn(n)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[camera-control.live.goPublic] No title provided / invalid title");
                case 4:
                  return e.abrupt("return", ya.setLiveTitle(t, r, n));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Pa = function Pa(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 60,
            r = arguments.length > 2 ? arguments[2] : void 0,
            n = da()(e);
          return new Promise(function (a, s) {
            e.forEach(function () {
              var s = C()(R().mark(function s(o, i) {
                return R().wrap(function (s) {
                  for (;;) switch (s.prev = s.next) {
                    case 0:
                      return s.next = 2, Ma(o, t, r, function () {
                        if (n[i] = !0, n.every(function (e) {
                          return !0 === e;
                        })) return Ca.map(function (e) {
                          return clearTimeout(e);
                        }), a(e);
                      });
                    case 2:
                    case "end":
                      return s.stop();
                  }
                }, s);
              }));
              return function (e, t) {
                return s.apply(this, arguments);
              };
            }());
          });
        },
        Ia = !0,
        Oa = function Oa() {
          Ia = !1;
        },
        Na = function Na() {
          Ia = !0;
        },
        qa = function qa() {
          return Ca.map(function (e) {
            return clearTimeout(e);
          });
        },
        Aa = function Aa(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 60,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2e3,
            n = da()(e),
            a = !1,
            s = n.filter(function (e) {
              return !0 === e.isMain;
            })[0];
          return "TRACKING" === s.cameraType && (t = 90), Na(), new Promise(function (o, i) {
            e.forEach(function () {
              var e = C()(R().mark(function e(i, u) {
                return R().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, Ma(i.broadcastId, t, r, function (e) {
                        if (n[u].isReady = e, n[u].readyCheck = !0, a = n.every(function (e) {
                          return !0 === e.readyCheck;
                        }), a) return Ca.map(function (e) {
                          return clearTimeout(e);
                        }), o(s.isReady);
                      });
                    case 2:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, r) {
                return e.apply(this, arguments);
              };
            }());
          });
        },
        Ma = (ba = 0, function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s, o, i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (e.prev = 0, Ia) {
                    e.next = 3;
                    break;
                  }
                  return e.abrupt("return", a(!1));
                case 3:
                  return e.next = 5, ya.isLiveReady(t);
                case 5:
                  if (e.t0 = e.sent, e.t0) {
                    e.next = 8;
                    break;
                  }
                  e.t0 = !1;
                case 8:
                  if (!(s = e.t0)) {
                    e.next = 12;
                    break;
                  }
                  return ba = 0, e.abrupt("return", a(s));
                case 12:
                  if (!(ba++ < r)) {
                    e.next = 16;
                    break;
                  }
                  return o = setTimeout(function () {
                    Ma(t, r, n, a);
                  }, n), Ca.push(o), e.abrupt("return", o);
                case 16:
                  e.next = 25;
                  break;
                case 18:
                  if (e.prev = 18, e.t1 = e["catch"](0), console.log(e.t1), !(ba++ < r)) {
                    e.next = 25;
                    break;
                  }
                  return i = setTimeout(function () {
                    Ma(t, r, n, a);
                  }, n), Ca.push(i), e.abrupt("return", i);
                case 25:
                case "end":
                  return e.stop();
              }
            }, e, null, [[0, 18]]);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }()),
        Ua = q("PRODUCTION");
      var La = {
        startRecord: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o, i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.senderID, n = t.teamID, a = t.videoTitle, s = t.recordType, o = t.maxRecordTime, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/team/").concat(n, "/startRecording"), {
                    senderId: r,
                    homeTeam: n,
                    videoTitle: a,
                    recordType: s,
                    maxRecordTime: o
                  });
                case 4:
                  if (!(i = e.sent) || 409 !== i.status) {
                    e.next = 7;
                    break;
                  }
                  return e.abrupt("return", i);
                case 7:
                  if (!i || 200 === i.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[camera-control.record.api.startRecord] Request status is different from 200:\n    ".concat(i.status));
                case 9:
                  if (!i || i.data) {
                    e.next = 11;
                    break;
                  }
                  throw new Error("[camera-control.record.api.startRecord] No data returned");
                case 11:
                  return e.abrupt("return", i.data);
                case 12:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        stopRecord: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/stopRecording"), {
                    senderId: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.record.api.stopRecord] Request status is different from 200:\n    ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.record.api.stopRecord] No data returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getMainRecordBySessionId: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat(Ua.NODE_CCAPI_URL, "/").concat("v1", "/getMainRecordBySessionId/").concat(t), {}, {}, !0);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.record.api.getMainRecordBySessionId] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.record.api.getMainRecordBySessionId] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        createTrackingFromFile: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.recordId, n = t.params, e.next = 4, _n.sendRequest("POST", "".concat(Ua.NODE_CCAPI_URL, "/").concat("v1", "/createTrackingFromFile/").concat(r), n, {}, !0);
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.record.api.createTrackingFromFile] Request status is different from 200:\n    ".concat(a.status));
                case 7:
                  return e.abrupt("return", a);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Fa = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.senderID, n = t.teamID, a = t.videoTitle, s = t.recordType, o = t.maxRecordTime, Va(r, n), e.abrupt("return", La.startRecord({
                    senderID: r,
                    teamID: n,
                    videoTitle: a,
                    recordType: s,
                    maxRecordTime: o
                  }));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ba = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.record.stopRecord] No siteID provided / invalid siteID");
                case 2:
                  if (r && Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[camera-control.record.stopRecord] No senderID provided / invalid senderID");
                case 4:
                  return e.abrupt("return", La.stopRecord(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Va = function Va(e, t) {
          if (!e || !Pn(e)) throw new Error("[camera-control.record.startRecord] No senderID provided / invalid senderID");
          if (!t || !Pn(t)) throw new Error("[camera-control.record.startRecord] No teamID provided / invalid teamID");
        },
        Ga = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.record.getMainRecordBySessionId] No sessionId provided");
                case 2:
                  return e.abrupt("return", La.getMainRecordBySessionId(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ya = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r = t.recordId, n = t.params, r) {
                    e.next = 3;
                    break;
                  }
                  throw new Error("[camera-control.record.createTrackingFromFile] No recrodId provided");
                case 3:
                  if (n) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[camera-control.record.createTrackingFromFile] No params provided");
                case 5:
                  return e.abrupt("return", La.createTrackingFromFile({
                    recordId: r,
                    params: n
                  }));
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var ja = {
        startScheduledRecord: function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o, i, u;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.senderID, n = t.teamID, a = t.title, s = t.recordType, o = t.startTime, i = t.duration, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/scheduledTask"), {
                    type: "Record",
                    creator: r,
                    team: n,
                    title: a,
                    recordType: s,
                    startTime: o,
                    duration: i
                  });
                case 4:
                  if (!(u = e.sent) || 409 !== u.status && 400 !== u.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Ie(u.data.error);
                case 7:
                  if (!u || 201 === u.status) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.startScheduledRecord] Request status is different from 200:\n    ".concat(u.status));
                case 9:
                  if (!u || u.data) {
                    e.next = 11;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.startScheduledRecord] No data returned");
                case 11:
                  return e.abrupt("return", u.data);
                case 12:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        startScheduledLive: function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a,
              s,
              o,
              i = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return a = i.length > 3 && void 0 !== i[3] ? i[3] : 0, s = i.length > 4 ? i[4] : void 0, e.next = 5, _n.sendRequest("POST", "".concat("v1", "/scheduledTask"), {
                    type: "Live",
                    channel: 1,
                    duration: n,
                    team: t,
                    creator: r,
                    cameraIndex: a,
                    startTime: s
                  });
                case 5:
                  if (!(o = e.sent) || 409 !== o.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Ie(o.data.error);
                case 8:
                  if (!o || 201 === o.status) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.startScheduledLive] Request status is different from 200:\n    ".concat(o.status));
                case 10:
                  if (!o || o.data) {
                    e.next = 12;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.startScheduledLive] No data returned");
                case 12:
                  return e.abrupt("return", o.data);
                case 13:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        cancelTask: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/scheduledTask/").concat(r, "/cancel"), {
                    canceler: t
                  });
                case 3:
                  if (!(n = e.sent) || 204 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.cancelTask] Request status is different from 200:\n    ".concat(n.status));
                case 6:
                  return e.abrupt("return", n);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getScheduledTasks: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/scheduledTasks"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.getScheduledTasks] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.getScheduledTasks] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getScheduledTasksBySite: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/site/").concat(t, "/scheduledTasks"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.getScheduledTasks] Request status is different from 200:\n    ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.api.getScheduledTasksBySite] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Ha = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o, i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.senderID, n = t.teamID, a = t.title, s = t.recordType, o = t.startTime, i = t.duration, Ja(r, n), e.abrupt("return", ja.startScheduledRecord({
                    senderID: r,
                    teamID: n,
                    title: a,
                    recordType: s,
                    startTime: o,
                    duration: i
                  }));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Wa = function () {
          var e = C()(R().mark(function e(t, r) {
            var n,
              a,
              s,
              o = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (n = o.length > 2 && void 0 !== o[2] ? o[2] : 10800, a = o.length > 3 ? o[3] : void 0, s = o.length > 4 ? o[4] : void 0, Pn(t)) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.startScheduledLive] No teamID provided / invalid teamID");
                case 5:
                  if (Pn(r)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.startScheduledLive] No senderID provided / invalid senderID");
                case 7:
                  return e.abrupt("return", ja.startScheduledLive(t, r, n, a, s));
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        za = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.cancelTask] No taskId provided / invalid taskId");
                case 2:
                  if (r && Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.cancelTask] No senderID provided / invalid senderID");
                case 4:
                  return e.abrupt("return", ja.cancelTask(r, t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        $a = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.getTasks] No teamId provided / invalid teamId");
                case 2:
                  return e.abrupt("return", ja.getScheduledTasks(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Za = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[camera-control.scheduledTask.getTasksBySite] No siteId provided / invalid siteId");
                case 2:
                  return e.abrupt("return", ja.getScheduledTasksBySite(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ja = function Ja(e, t) {
          if (!e || !Pn(e)) throw new Error("[camera-control.record.startRecord] No senderID provided / invalid senderID");
          if (!t || !Pn(t)) throw new Error("[camera-control.record.startRecord] No teamID provided / invalid teamID");
        };
      var Xa = {
        site: i,
        record: c,
        live: u,
        scheduler: f
      };
      var Ka = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/comment/?teamId=").concat(r, "&userId=").concat(n, "&").concat(t));
                case 3:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.getGameEvents] request status is different from 200:\n      ".concat(a.status));
                case 6:
                  if (!a || a.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.events.api.getGameEvents] No data returned");
                case 8:
                  return e.abrupt("return", a.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Qa = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/comment"), t);
                case 3:
                  if (!(r = e.sent) || 201 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.createEvent] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        es = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/comment/").concat(t, "/videoClip"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.createVideoClip] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var ts = {
        getGameEvents: Ka,
        createEvent: Qa,
        removeEvent: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("DELETE", "".concat("v1", "/comment/").concat(t));
                case 3:
                  if (!(r = e.sent) || 204 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.removeEvent] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateEvent: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/comment/").concat(t), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.updateEvent] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n && n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getEvent: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/comment/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.getEvent] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r && r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        createVideoClip: es
      };
      var rs = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t && t.length && Array.isArray(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.getGameEvents] videoIDs not provided / is empty / is not valid array");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.getGameEvents] teamID not provided / is not valid string");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.getGameEvents] userID not provided / is not valid string");
                case 6:
                  return a = t.map(function (e) {
                    return "&videoIds[$in][]=".concat(e);
                  }), e.abrupt("return", ts.getGameEvents(a.join(""), r, n));
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        ns = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.createEvent] No event provided");
                case 2:
                  if (t.seekTime && t.sender && t.video && t.team) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("\n      [game.events.createEvent] 1 or more of the following is missing in the event bject:\n      video, seekTime, sender, team\n    ");
                case 4:
                  return e.abrupt("return", ts.createEvent(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        as = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.createVideoClip] No eventId");
                case 2:
                  return e.abrupt("return", ts.createVideoClip(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ss = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.getEvent] No event provided");
                case 2:
                  return e.abrupt("return", ts.getEvent(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        os = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.removeEvent] No event provided");
                case 2:
                  return e.abrupt("return", ts.removeEvent(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        is = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.updateEventPlayers] No eventID provided / invalid eventID");
                case 2:
                  if (r && Array.isArray(r) && Nn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.updateEventPlayers] No players provided / players is not an array");
                case 4:
                  return e.abrupt("return", ts.updateEvent(t, {
                    tagedUsers: r
                  }));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        us = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.updateEventText] No eventID provided / invalid eventID");
                case 2:
                  if (void 0 !== r && "string" == typeof r && null !== r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.updateEventText] No text provided / invalid text");
                case 4:
                  return e.abrupt("return", ts.updateEvent(t, {
                    text: r
                  }));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        cs = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (null != r) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.events.updateEventPrivacy] No isPrivate provided");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.updateEventPrivacy] No eventID provided / invalid eventID");
                case 4:
                  return e.abrupt("return", ts.updateEvent(t, {
                    isPrivate: r
                  }));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        fs = function fs(e, t) {
          var r = [];
          if (!e) throw new Error("[game.events.filterGameEventsByPlayer] No events provided");
          if (!Pn(t)) throw new Error("[game.events.filterGameEventsByPlayer] No playerID provided / invalid playerID");
          return e.map(function (e) {
            if (e.taggedUsers && e.taggedUsers.length) {
              var n = e.taggedUsers.find(function (e) {
                return e.id === t;
              });
              n && r.push(e);
            }
          }), r;
        },
        ds = function ds(e, t) {
          var r = [];
          if (!e) throw new Error("[game.events.filterGameEventsByEvent] No events provided");
          if (!Pn(t)) throw new Error("[game.events.filterGameEventsByEvent] No title provided / invalid title");
          return e.map(function (e) {
            e && e.title && e.title === t && r.push(e);
          }), r;
        },
        ps = function ps(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "asc",
            r = t;
          if (!e || !e.length || !Array.isArray(e)) throw new Error("[game.events.sortEvents] No events provided / Events is not an array");
          switch (-1 === ["asc", "desc"].indexOf(t) && (r = "asc"), r) {
            case "asc":
              return function (e) {
                return e && e.sort(function (e, t) {
                  return e.seekTime - t.seekTime;
                });
              }(e);
            case "desc":
              return function (e) {
                return e && e.sort(function (e, t) {
                  return t.seekTime - e.seekTime;
                });
              }(e);
            default:
              return e;
          }
        },
        ls = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.getVideoContainerByID] request status is different from 200:\n      ".concat(r.status, " / No data returned"));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.events.api.getVideoContainerByID] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        hs = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer?teamId=").concat(r, "&vid=").concat(t));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.getGameVideos] request status is different from 200:\n      ".concat(n.status, " / No data returned"));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.events.api.getGameVideos] No data returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ms = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("DELETE", "".concat("v1", "/videoContainer/").concat(t));
                case 3:
                  if (!(r = e.sent) || 204 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.api.getGameEvents] request status is different from 204:\n      ".concat(r.status, " / No data returned"));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        vs = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/videoContainer/").concat(r, "/download"), {
                    userId: n,
                    videoId: r,
                    videoContainerId: t
                  });
                case 3:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.downloadVideo] request status is different from 204:\n      ".concat(a.status));
                case 6:
                  return e.abrupt("return", a.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        ws = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/videoContainer/").concat(t), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.updateVideoContainer] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        gs = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/videoContainer/").concat(t, "/score/home"), {
                    score: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.setHomeTeamScore] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ys = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/videoContainer/").concat(t, "/score/away"), {
                    score: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.setAwayTeamScore] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }();
      var bs = {
        getVideoContainerByID: ls,
        getGameVideos: hs,
        deleteVideoContainer: ms,
        insertVideoFromShare: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/sharedItem/video"), {
                    teamId: r,
                    shareId: t
                  });
                case 3:
                  return n = e.sent, e.abrupt("return", n);
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        downloadVideo: vs,
        updateVideoContainer: ws,
        getVideoToUploadInfo: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/externalVideoInfo/?videoUrl=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.getVideoToUploadInfo] request status is different from 200:\n      ".concat(r.status, " / No data returned"));
                case 6:
                  if (!r || !r.data.error) {
                    e.next = 8;
                    break;
                  }
                  throw new Ie("Check video url is valid or video is not private");
                case 8:
                  if (!r || r.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[game.videos.api.getVideoToUploadInfo] No data returned");
                case 10:
                  return e.abrupt("return", r.data);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        uploadExternalVideo: function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/uploadExternalVideo"), {
                    team: t,
                    user: r,
                    videoUrl: n
                  });
                case 3:
                  if (!(a = e.sent) || 409 !== a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(a.data.responseText);
                case 6:
                  if (!a || 200 === a.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.videos.api.uploadExternalVideo] request status is different from 200:\n      ".concat(a.status, " "));
                case 8:
                  return e.abrupt("return", a.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        setHomeTeamScore: gs,
        setAwayTeamScore: ys,
        getPublicVideoToken: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/auth/").concat(t, "/getPublicVideoToken"));
                case 3:
                  if (!(r = e.sent) || 403 !== r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Ie(r.data);
                case 6:
                  if (!r || 200 === r.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.videos.api.getIsPublicVideo] request status is different from 200:\n      ".concat(r.status, " "));
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        uploadDirectExternalVideo: function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/unsecure/uploadDirectExternalVideo"), {
                    team: t,
                    user: r,
                    fileName: n,
                    checksum: a
                  });
                case 3:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.uploadExternalVideo] request status is different from 200:\n      ".concat(s.status, " "));
                case 6:
                  return e.abrupt("return", s.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        updateUploadVideoRequest: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/unsecure/updateUploadRequest/").concat(t), {
                    status: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.updateUploadVideoRequest] request status is different from 200:\n      ".concat(n.status, " "));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        createVideoContainerFromLiveStream: function () {
          var e = C()(R().mark(function e(t, r, n, a, s, o) {
            var i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/videoContainer/").concat(t, "/createFromLiveStream"), {
                    streamUri: r,
                    start: n,
                    end: a,
                    liveStartTime: s,
                    liveSessionId: o
                  });
                case 3:
                  if (!(i = e.sent) || 200 === i.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.updateUploadVideoRequest] request status is different from 200:\n      ".concat(i.status, " "));
                case 6:
                  return e.abrupt("return", i.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a, s, o) {
            return e.apply(this, arguments);
          };
        }(),
        getLiveSessionUploadRequests: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", '/uploadRequest?query={"liveSessionId":"').concat(t, '"}'));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.getLiveSessionUploadRequests] request status is different from 200:\n      ".concat(r.status, " "));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getPublicVideoContainersByTeam: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/videocontainer?teamId=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.getPublicVideoContainersByTeam] request status is different from 200:\n      ".concat(r.status, " "));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getPublicVideoContainer: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/videocontainer/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.getPublicVideoContainer] request status is different from 200:\n      ".concat(r.status, " "));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getLiveSession: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/insecure/live/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.api.getLiveSession] request status is different from 200:\n      ".concat(r.status, " "));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var ks = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.getGameVideos] No videoID provided / invalid videoID");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.getGameVideos] No teamID provided / invalid teamID");
                case 4:
                  return e.abrupt("return", bs.getGameVideos(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        xs = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.getGameVideos] No videoID provided / invalid videoID");
                case 2:
                  return e.abrupt("return", bs.deleteVideoContainer(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ts = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.getVideoContainerByID] No videoID provided / invalid videoID");
                case 2:
                  return e.abrupt("return", bs.getVideoContainerByID(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Es = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t) && Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.insertVideoFromShare] No shareID provided / invalid teamID");
                case 2:
                  return e.abrupt("return", bs.insertVideoFromShare(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        _s = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.downloadVide] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.downloadVide] No videoId provided / invalid videoId");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.downloadVide] No userId provided / invalid userId");
                case 6:
                  return e.abrupt("return", bs.downloadVideo(t, r, n));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Cs = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.downloadVide] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.downloadVide] No data provided / invalid data");
                case 4:
                  return e.abrupt("return", bs.updateVideoContainer(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ss = function () {
          var e = C()(R().mark(function e(t, r, n, a, s, o) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.createVideoContainerFromLiveStream] No teamId provided / invalid teamId");
                case 2:
                  return e.abrupt("return", bs.createVideoContainerFromLiveStream(t, r, n, a, s, o));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a, s, o) {
            return e.apply(this, arguments);
          };
        }(),
        Rs = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.isPublicGame] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  return e.abrupt("return", bs.getPublicVideoToken(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ds = function Ds(e) {
          var t = e.fullStreamUri,
            r = void 0 === t ? An("fullStreamUri") : t,
            n = e.moreCameras,
            a = void 0 === n ? [] : n;
          return [r].concat(da()(a.map(function (e) {
            return e.fullStreamUri;
          })));
        },
        Ps = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", bs.getVideoToUploadInfo(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Is = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.uploadExternalVideo] No userID provided / invalid useId");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.uploadExternalVideo] No teamId provided / invalid teamId");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.uploadExternalVideo] No videoUrl provided / invalid videoUrl");
                case 6:
                  return e.abrupt("return", bs.uploadExternalVideo(t, r, n));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Os = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No userID provided / invalid useId");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No teamId provided / invalid teamId");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No fileName provided / invalid fileName");
                case 6:
                  if (Pn(a)) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No checksum provided / invalid checksum");
                case 8:
                  return e.abrupt("return", bs.uploadDirectExternalVideo(t, r, n, a));
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Ns = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No requestId provided / invalid requestId");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.uploadDirectExternalVideo] No status provided / invalid status");
                case 4:
                  return e.abrupt("return", bs.updateUploadVideoRequest(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        qs = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.setHomeTeamScore] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  if (r || Number.isInteger(r) || null === r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.setHomeTeamScore] No score provided / invalid score");
                case 4:
                  return e.abrupt("return", bs.setHomeTeamScore(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        As = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.setHomeTeamScore] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  if (r || Number.isInteger(r) || null === r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.videos.setHomeTeamScore] No score provided / invalid score");
                case 4:
                  return e.abrupt("return", bs.setAwayTeamScore(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ms = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.videos.getLiveSessionUploadRequests] No liveSessionId was provided");
                case 2:
                  return e.abrupt("return", bs.getLiveSessionUploadRequests(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Us = function Us(e) {
          if (!Pn(e)) throw new Error("[game.videos.getPublicVideoContainersByTeam] no teamId provided");
          return bs.getPublicVideoContainersByTeam(e);
        },
        Ls = function Ls(e) {
          if (!Pn(e)) throw new Error("[game.videos.getPublicVideoContainer] no id provided");
          return bs.getPublicVideoContainer(e);
        },
        Fs = function Fs(e) {
          if (!Pn(e)) throw new Error("[game.videos.getLiveSession] no sessionId provided");
          return bs.getLiveSession(e);
        },
        Bs = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/clips"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clip.api.getGameClips] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.clips.api.getGameClips] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Vs = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/clipOnWork"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clip.api.getClipOnWork] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.clips.api.getClipOnWork] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var Gs = {
        getGameClips: Bs,
        createClip: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/clip"), {
                    clip: t
                  });
                case 3:
                  if (!(r = e.sent) || 201 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.createClip] request status is different from 201:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r && r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        removeClip: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("DELETE", "".concat("v1", "/clip/").concat(t));
                case 3:
                  if (!(r = e.sent) || 204 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.removeClip] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", null);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateClip: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/clip/").concat(t), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.updateClip] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n && n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        makeClipVideo: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/clip/").concat(t, "/make"), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.makeClipVideo] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n && n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        makeClipVideoFromBreakdown: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/clip/makeFromBreakdowns"), t);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.makeClipVideoFromBreakdown] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r && r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getClipOnWork: Vs,
        checkForReadyClips: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/clips/ready"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.checkForReadyClips] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r && r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        checkForClipsInProcess: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/clips/inprocess"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.api.checkForClipsInProcess] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r && r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Ys = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.getGameClips] videoContainerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", Gs.getGameClips(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        js = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.getClipOnWork] videoContainerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", Gs.getClipOnWork(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Hs = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.createClip] No clip provided");
                case 2:
                  if (t.title && t.team) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("\n      [game.clips.createClip] 1 or more of the following is missing in the clip object:\n      title, team\n    ");
                case 4:
                  return e.abrupt("return", Gs.createClip(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ws = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.removeClip] No clip provided");
                case 2:
                  return e.abrupt("return", Gs.removeClip(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        zs = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.updateClip] No clipID provided / invalid clipID");
                case 2:
                  return e.abrupt("return", Gs.updateClip(t, r));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        $s = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.updateClip] No clipID provided / invalid clipID");
                case 2:
                  return e.abrupt("return", Gs.makeClipVideo(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Zs = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.makeClipVideoFromBreakdown] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.clips.makeClipVideoFromBreakdown] No teamId provided / invalid teamId");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.clips.makeClipVideoFromBreakdown] No senderId provided / invalid senderId");
                case 6:
                  if (Nn(a)) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.clips.makeClipVideoFromBreakdown] No breakdownsIds provided / invalid breakdownsIds");
                case 8:
                  return s = {
                    videoContainer: t,
                    team: r,
                    sender: n,
                    breakdownsIds: a
                  }, e.abrupt("return", Gs.makeClipVideoFromBreakdown(s));
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Js = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.checkForReadyClips] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  return e.abrupt("return", Gs.checkForReadyClips(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Xs = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.clips.checkForClipsInProcess] No videoContainerId provided / invalid videoContainerId");
                case 2:
                  return e.abrupt("return", Gs.checkForClipsInProcess(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ks = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/publicHighlight/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getPublicHighlightById] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getPublicHighlightById] No highlights returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Qs = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/comment/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getHighlightById] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getHighlightById] No highlights returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        eo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/highlight/?userId=").concat(t, "&videoIds=").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getPlayerGameHighlights] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getPlayerGameHighlights] No highlights returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        to = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/highlights/"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getGameHighlights] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getPlayerGameHighlights] No highlights returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ro = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/highlight/?teamComments=true&videoContainerId=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getTeamGameHighlights] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getTeamGameHighlights] No highlights returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        no = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/").concat(t, "/publicHighlights"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.getTeamGameHighlights] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!(r && !r.data || r && r.data && !r.data.moreHighlights)) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.getTeamGameHighlights] No highlights returned");
                case 8:
                  return e.abrupt("return", r.data.moreHighlights);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var ao = {
        getPublicHighlightById: Ks,
        getHighlightById: Qs,
        addHighlight: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/highlight"), t);
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.addHighlight] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.addHighlight] No comments returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateHighlight: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PUT", "".concat("v1", "/comment/").concat(t), r);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.updateHighlights] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.highlights.api.addHighlight] No comments returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getPlayerGameHighlights: eo,
        getTeamGameHighlights: ro,
        deleteHighlight: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("DELETE", "".concat("v1", "/comment/").concat(t));
                case 3:
                  if (!(r = e.sent) || 204 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.updateHighlights] request status is different from 204:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getUserHighlights: no,
        allowToRecord: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/allowToRecord"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.highlights.api.allowToRecord] request status is different from 204:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getGameHighlights: to
      };
      var so = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getPublicHighlightById] highlightId not provided / is not valid string");
                case 2:
                  return e.abrupt("return", ao.getPublicHighlightById(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        oo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getHighlightById] highlightId not provided / is not valid string");
                case 2:
                  return e.abrupt("return", ao.getHighlightById(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        io = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (r && r.length && Array.isArray(r)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getGameHighlights] videoIDs not provided / is empty / is not valid array");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.highlights.getPlayerGameHighlights] userID not provided / is not valid string");
                case 4:
                  return e.abrupt("return", ao.getPlayerGameHighlights(t, r.join(",")));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        uo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getGameEvents] videoContainerId not provided / is not valid string");
                case 2:
                  return e.abrupt("return", ao.getGameHighlights(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        co = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.deleteHighlight] highlightID not provided / invalid highlightID");
                case 2:
                  return e.abrupt("return", ao.deleteHighlight(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        fo = function fo(e) {
          var t = e.videoId,
            r = e.sender,
            n = e.team,
            a = e.seekTime,
            s = e.endSeekTime,
            o = e.cameraIndex,
            i = e.userId;
          if (!Pn(t)) throw new Error("[game.highlights.addHighlight] videoId not provided / invalid videoId");
          if (!Pn(i)) throw new Error("[game.highlights.addHighlight] userId not provided / invalid userId");
          if (!Pn(n)) throw new Error("[game.highlights.addHighlight] team not provided / invalid team");
          if (!Pn(r)) throw new Error("[game.highlights.addHighlight] sender not provided / invalid sender");
          if ("number" != typeof a) throw new Error("[game.highlights.addHighlight] seekTime not provided / invalid seekTime");
          if (!s || "number" != typeof s) throw new Error("[game.highlights.addHighlight] endSeekTime not provided / invalid endSeekTime");
          if ("number" != typeof o) throw new Error("[game.highlights.addHighlight] cameraIndex not provided / invalid cameraIndex");
        },
        po = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return fo(t), e.abrupt("return", ao.addHighlight(t));
                case 2:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        lo = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.updateHighlight] No Highlight ID");
                case 2:
                  if (r) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.highlights.updateHighlight] No data to update");
                case 4:
                  return e.abrupt("return", ao.updateHighlight(t, r));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ho = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getTeamGameHighlights] videoContainerId not provided");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.getTeamGameHighlights] videoContainerId is not valid string");
                case 4:
                  return e.abrupt("return", ao.getTeamGameHighlights(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        mo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.getUserHighlights] videoContainerId not provided");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.events.getUserHighlights] userId is not valid string");
                case 4:
                  return e.abrupt("return", ao.getUserHighlights(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        vo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (t) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.highlights.allowToRecord] userId not provided");
                case 2:
                  if (Pn(t)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.highlights.allowtoRecord] userId is not a valif string");
                case 4:
                  return e.abrupt("return", ao.allowToRecord(t));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        wo = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/tagTask/").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.getTaskById] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var go = {
        getTaggerTasks: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/tagTasks"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.getTaggerTasks] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getTaggerTasksByStatus: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/tagTasks/").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.getTaggerTasksByStatus] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getTaggerTasksCount: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/user/").concat(t, "/tagTasksCount"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.getTaggerTasks] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateTagTaskStatus: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/tagTask/").concat(t), {
                    status: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.updateTagTaskStatus] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n && n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        setGamePeriod: function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/tagTask/").concat(t, "/setPeriod"), {
                    periodNumber: r,
                    periodTime: n
                  });
                case 3:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.setGamePeriod] request status is different from 200:\n      ".concat(a.status));
                case 6:
                  return e.abrupt("return", a.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        getTagTaskById: wo,
        createGameTagTask: function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/tagTask"), {
                    assigner: t,
                    tagger: r,
                    videoContainer: n,
                    teamId: a
                  });
                case 3:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tagTasks.api.createGameTagTask] request status is different from 200:\n      ".concat(s.status));
                case 6:
                  return e.abrupt("return", s.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }()
      };
      var yo = "DONE",
        bo = "IN_PROGRESS",
        ko = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tagTasks.getTaggerTask] taggerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTaggerTasks(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        xo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.getDoneTasks] taggerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTaggerTasksByStatus(t, yo));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        To = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tagTasks.getWaitingTasks] taggerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTaggerTasksByStatus(t, "WAIT_FOR_TAGGING"));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Eo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tagTasks.getInProgressTasks] taggerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTaggerTasksByStatus(t, bo));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        _o = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tagTasks.getTaggerTaskCount] taggerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTaggerTasksCount(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Co = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.markTagTaskAsDone] taskID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.updateTagTaskStatus(t, yo));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        So = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.markTagTaskAsInProgress] taskID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.updateTagTaskStatus(t, bo));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ro = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.markTagTaskAsInProgress] taskID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.setGamePeriod(t, r, n));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Do = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.markTagTaskAsInProgress] taskID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", go.getTagTaskById(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Po = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.tag-tasks.createGameTagTask] assignerId not provided / is not valid string");
                case 2:
                  if (Pn(r)) {
                    e.next = 4;
                    break;
                  }
                  throw new Error("[game.tag-tasks.createGameTagTask] taggerId not provided / is not valid string");
                case 4:
                  if (Pn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.tag-tasks.createGameTagTask] videoContainer not provided / is not valid string");
                case 6:
                  return e.abrupt("return", go.createGameTagTask(t, r, n, a));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }();
      var Io = {
        clips: l,
        events: d,
        videos: p,
        highlights: h,
        tagTasks: m
      };
      var Oo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/stats?").concat(r));
                case 3:
                  if (!(n = e.sent) || 204 !== n.status) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return", n.data);
                case 6:
                  if (!n || 200 === n.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getTeamStats] request status is different from 200:\n      ".concat(n.status));
                case 8:
                  if (!n || n.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[game.stats.api.getTeamStats] No data returned");
                case 10:
                  return e.abrupt("return", n.data);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        No = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/personalStats/").concat(r, "?").concat(n));
                case 3:
                  if (!(a = e.sent) || 204 !== a.status) {
                    e.next = 6;
                    break;
                  }
                  return e.abrupt("return", a.data);
                case 6:
                  if (!a || 200 === a.status) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getPlayerStats] request status is different from 200:\n      ".concat(a.status));
                case 8:
                  if (!a || a.data) {
                    e.next = 10;
                    break;
                  }
                  throw new Error("[game.stats.api.getPlayerStats] No data returned");
                case 10:
                  return e.abrupt("return", a.data);
                case 11:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        qo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/allPersonalStats?\n    ").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getAllPlayersStats] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getAllPlayersStats] No data returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ao = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/unsecure/playerStats?userId=").concat(t, "&teamId=").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getPlayerProfileStats] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getPlayerProfileStats] No data returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }();
      var Mo = {
        getTeamStats: Oo,
        getPlayerStats: No,
        getMappedEvents: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/mappedEvents?").concat(r));
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getMappedEvents] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  if (!n || n.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getMappedEvents] No data returned");
                case 8:
                  return e.abrupt("return", n.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getVideoPeriods: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/videoPeriods"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getVideoPeriods] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getVideoPeriods] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getStatsTable: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/videoContainer/").concat(t, "/statsTable"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getStatsTable] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getStatsTable] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getPlayerProfileStats: Ao,
        getTeamSeasonStats: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/seasonStats"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.stats.api.getTeamSeasonStats] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.stats.api.getTeamSeasonStats] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getAllPlayersStats: qo
      };
      var Uo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getTeamStats] videoContainerID not provided / is not valid string");
                case 2:
                  return n = "", r && (n += "periods=[".concat(r, "]")), e.abrupt("return", Mo.getTeamStats(t, n));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Lo = function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getPlayerStats] videoContainerID not provided / is not valid string");
                case 2:
                  if (a = "", !n) {
                    e.next = 7;
                    break;
                  }
                  if (qn(n)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.getPlayerStats]  periods is not an array/ array of int");
                case 6:
                  a += "periods=".concat(n);
                case 7:
                  return e.abrupt("return", Mo.getPlayerStats(t, r, a));
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Fo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getPlayerStats] videoContainerID not provided / is not valid string");
                case 2:
                  if (n = "", !r) {
                    e.next = 7;
                    break;
                  }
                  if (qn(r)) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.events.getPlayerStats]  periods is not an array/ array of int");
                case 6:
                  n += "periods=".concat(r);
                case 7:
                  return e.abrupt("return", Mo.getAllPlayersStats(t, n));
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Bo = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Mo.getPlayerProfileStats(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Vo = function () {
          var e = C()(R().mark(function e(t, r) {
            var n, a, s, o, i;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getEventsCords] videoContainerID not provided / is not valid string");
                case 2:
                  return n = "", r && (a = r.periods, s = r.events, o = r.positions, i = r.userId, a && (n += "periods=[".concat(a, "]")), s && (n += "&events=".concat(JSON.stringify(s))), o && (n += "&positions=".concat(JSON.stringify(o))), i && (n += "&userId=".concat(i))), e.abrupt("return", Mo.getMappedEvents(t, n));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Go = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getVideoPeriods] videoContainerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", Mo.getVideoPeriods(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Yo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getTableStats] videoContainerID not provided / is not valid string");
                case 2:
                  return e.abrupt("return", Mo.getStatsTable(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        jo = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  if (Pn(t)) {
                    e.next = 2;
                    break;
                  }
                  throw new Error("[game.stats.getTeamSeasonStats] teamId not provided / is not valid string");
                case 2:
                  return e.abrupt("return", Mo.getTeamSeasonStats(t));
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var Ho = {
        stats: v
      };
      var Wo = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/broadcast/start"), {
                    inviteToken: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.startBroadcast] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        zo = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/broadcast/stop"), {
                    inviteToken: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.stopBroadcast] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        $o = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/commentator/connect"), {
                    inviteToken: t
                  });
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.connectCommentary] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (r && (!r || r.data)) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.connectCommentary] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Zo = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/liveProduction/team?inviteToken=").concat(t));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getTeamFromLiveSession] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  if (!r || r.data) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getTeamFromLiveSession] No data returned");
                case 8:
                  return e.abrupt("return", r.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Jo = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/").concat(n, "/inviteCommentator"), {
                    name: t,
                    email: r,
                    teamId: a
                  });
                case 3:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.inviteCommentator] request status is different from 200:\n      ".concat(s.status));
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Xo = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.location, e.next = 4, _n.sendRequest("PATCH", "".concat("v1", "/liveProduction/").concat(r, "/updateScoreDisplay"), {
                    location: n
                  });
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.updateScoreDisplay] request status is different from 200:\n      ".concat(a.status));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ko = function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, e.next = 4, _n.sendRequest("GET", "".concat("v1", "/liveProduction/").concat(r, "/scoreDisplayResources"));
                case 4:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getScoreDisplay] request status is different from 200:\n      ".concat(n.status));
                case 7:
                  if (n && (!n || n.data)) {
                    e.next = 9;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getScoreDisplay] No data returned");
                case 9:
                  return e.abrupt("return", n.data);
                case 10:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Qo = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.files, e.next = 4, _n.sendRequest("PATCH", "".concat("v1", "/liveProduction/").concat(r, "/deleteSiteResources"), n);
                case 4:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.updateScoreDisplay] request status is different from 200:\n      ".concat(a.status));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ei = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/score/swapDigitalToStream"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.swapDigitalToStream] request status is different from 200:\n      ".concat(r.status));
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ti = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/score/scoreboardType"), {
                    scoreboardType: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.changeScoreboardType] request status is different from 200:\n      ".concat(n.status));
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ri = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/score/scoreboardType"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getScoreboardType] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ni = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s, o;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.fileName, a = t.position, s = t.bounds, e.next = 4, _n.sendRequest("POST", "".concat("v1", "/team/").concat(r, "/bottomSponsor"), {
                    fileName: n,
                    position: a,
                    bounds: s
                  });
                case 4:
                  if (!(o = e.sent) || 200 === o.status) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.addBottomSponsor] request status is different from 200:\n      ".concat(o.status));
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ai = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/team/").concat(t, "/bottomSponsor"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.removeBottomSponsor] request status is different from 200:\n      ".concat(r.status));
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        si = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/liveProduction/").concat(t, "/commentator/status"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getCommentatorStatus] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        oi = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/team/").concat(t, "/remoteProducer/peerCamera"), {
                    offer: r
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.remoteProducer.peerCamera] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ii = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("GET", "".concat("v1", "/liveProduction/").concat(t, "/internalStreams"));
                case 3:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.getInternalStreams] request status is different from 200:\n      ".concat(r.status));
                case 6:
                  return e.abrupt("return", r.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ui = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/liveProduction/commentator/delay"), {
                    delay: r,
                    inviteToken: t
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.setCommentatorDelay] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }();
      var ci = {
        getTeamFromLiveSession: Zo,
        inviteCommentator: Jo,
        connectCommentator: $o,
        startBroadcast: Wo,
        stopBroadcast: zo,
        updateScoreDisplay: Xo,
        getScoreDisplayResources: Ko,
        deleteSiteResources: Qo,
        swapDigitalToStream: ei,
        addBottomSponsor: ni,
        removeBottomSponsor: ai,
        getCommentatorStatus: si,
        peerProducerCamera: oi,
        getInternalStreams: ii,
        setMainVolume: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("PATCH", "".concat("v1", "/liveProduction/main/volume"), {
                    volume: r,
                    inviteToken: t
                  });
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.setMainVolume] request status is different from 200:\n      ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        setCommentatorDelay: ui,
        addFilter: function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/").concat(t, "/filter"), {
                    sourceName: n,
                    sceneName: r,
                    filterObject: a
                  });
                case 3:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.addFilter] request status is different from 200:\n      ".concat(s.status));
                case 6:
                  return e.abrupt("return", s.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        removeFilter: function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 3, _n.sendRequest("POST", "".concat("v1", "/liveProduction/").concat(t, "/filter"), {
                    sourceName: n,
                    sceneName: r,
                    filterObject: a
                  });
                case 3:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[game.liveProduction.api.removeFilter] request status is different from 200:\n      ".concat(s.status));
                case 6:
                  return e.abrupt("return", s.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        changeScoreboardType: ti,
        getScoreboardType: ri
      };
      var fi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.getTeamFromLiveSession(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        di = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.inviteCommentator(t, r, n, a));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        pi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.connectCommentator(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        li = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.startBroadcast(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        hi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.stopBroadcast(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        mi = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.updateScoreDisplay({
                    teamId: t,
                    location: r
                  }));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        vi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.getScoreDisplayResources({
                    teamId: t
                  }));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        wi = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.deleteSiteResources({
                    teamId: t,
                    files: r
                  }));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        gi = function () {
          var e = C()(R().mark(function e(t) {
            var r, n, a, s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, n = t.fileName, a = t.position, s = t.bounds, e.abrupt("return", ci.addBottomSponsor({
                    teamId: r,
                    fileName: n,
                    position: a,
                    bounds: s
                  }));
                case 2:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        yi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.removeBottomSponsor(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        bi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.swapDigitalToStream(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ki = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.changeScoreboardType(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        xi = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.getScoreboardType(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ti = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.getCommentatorStatus(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ei = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.peerProducerCamera(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        _i = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.getInternalStreams(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ci = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.setCommentatorDelay(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Si = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.setMainVolume(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ri = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.addFilter(t, r, n, a));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Di = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", ci.removeFilter(t, r, n, a));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }();
      var Pi = w;
      var Ii = "monitorServer/api",
        Oi = "https://api.myplay.com";
      var Ni = {
          getOfflineMonitors: function () {
            var e = C()(R().mark(function e() {
              var t;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.next = 4, _n.sendRequest("GET", "".concat(Oi, "/").concat(Ii, "/").concat("v1", "/offlineMonitors"), null, null, !0);
                  case 4:
                    if (!(t = e.sent) || 200 === t.status) {
                      e.next = 7;
                      break;
                    }
                    throw new Error("[monitor.getOfflineMonitors] request status is different from 200:\n        ".concat(t.status, " / No data returned"));
                  case 7:
                    if (!t || t.data) {
                      e.next = 9;
                      break;
                    }
                    throw new Error("[monitor.getOfflineMonitors] No data returned");
                  case 9:
                    return e.abrupt("return", t.data);
                  case 12:
                    e.prev = 12, e.t0 = e["catch"](0), console.log(e.t0);
                  case 15:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[0, 12]]);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }(),
          onlineMonitorsWithOfflineCameras: function () {
            var e = C()(R().mark(function e() {
              var t;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.next = 4, _n.sendRequest("GET", "".concat(Oi, "/").concat(Ii, "/").concat("v1", "/onlineMonitorsWithOfflineCameras"), null, null, !0);
                  case 4:
                    if (!(t = e.sent) || 200 === t.status) {
                      e.next = 7;
                      break;
                    }
                    throw new Error("[monitor.onlineMonitorsWithOfflineCameras] request status is different from 200:\n        ".concat(t.status, " / No data returned"));
                  case 7:
                    if (!t || t.data) {
                      e.next = 9;
                      break;
                    }
                    throw new Error("[monitor.onlineMonitorsWithOfflineCameras] No data returned");
                  case 9:
                    return e.abrupt("return", t.data);
                  case 12:
                    e.prev = 12, e.t0 = e["catch"](0), console.log(e.t0);
                  case 15:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[0, 12]]);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }()
        },
        qi = {
          getOfflineMonitors: function () {
            var e = C()(R().mark(function e() {
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.abrupt("return", Ni.getOfflineMonitors());
                  case 4:
                    e.prev = 4, e.t0 = e["catch"](0), console.log(e.t0);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[0, 4]]);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }(),
          onlineMonitorsWithOfflineCameras: function () {
            var e = C()(R().mark(function e() {
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.abrupt("return", Ni.onlineMonitorsWithOfflineCameras());
                  case 4:
                    e.prev = 4, e.t0 = e["catch"](0), console.log(e.t0);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[0, 4]]);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }()
        };
      var Ai = "v1",
        Mi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Ai, "/booking/"), t);
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.scheduledNewBooking] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.scheduledNewBooking] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ui = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t.id, "/"), t);
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.editBooking] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Li = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/cancel"), {
                    cancelBy: r
                  });
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.cancelBooking] request status is different from 204:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Fi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/booking/ALL/count?query=").concat(t));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getAllBookingsCount] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getAllBookingsCount] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Bi = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/user/").concat(t, "/bookings/count?query=").concat(r));
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByProducerCount] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  if (n && (!n || n.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByProducerCount] No data returned");
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Vi = function () {
          var e = C()(R().mark(function e(t, r) {
            var n, a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return n = r ? "".concat(Ai, "/booking/").concat(t, "?lean=true") : "".concat(Ai, "/booking/").concat(t), e.next = 3, _n.sendRequest("GET", n);
                case 3:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsById] request status is different from 200:\n      ".concat(a.status));
                case 6:
                  if (a && (!a || a.data)) {
                    e.next = 8;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsById] No data returned");
                case 8:
                  return e.abrupt("return", a.data);
                case 9:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Gi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/team/").concat(t, "/bookings"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByTeam] request status is different from 204:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByTeam] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Yi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/club/").concat(t, "/bookings"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByClub] request status is different from 204:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByClub] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ji = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/user/").concat(t, "/bookings?limit=").concat(r, "&skip=").concat(n, "&query=").concat(a));
                case 2:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByUser] request status is different from 200:\n      ".concat(s.status));
                case 5:
                  if (s && (!s || s.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByUser] No data returned");
                case 7:
                  return e.abrupt("return", s.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Hi = function () {
          var e = C()(R().mark(function e(t, r, n, a) {
            var s;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/booking/").concat(t, "?limit=").concat(r, "&skip=").concat(n, "&query=").concat(a));
                case 2:
                  if (!(s = e.sent) || 200 === s.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByStatus] request status is different from 204:\n      ".concat(s.status));
                case 5:
                  if (s && (!s || s.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getBookingsByStatus] No data returned");
                case 7:
                  return e.abrupt("return", s.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n, a) {
            return e.apply(this, arguments);
          };
        }(),
        Wi = function () {
          var e = C()(R().mark(function e() {
            var t;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/booking/producers"));
                case 2:
                  if (!(t = e.sent) || 200 === t.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getAllProducers] request status is different from 200:\n      ".concat(t.status));
                case 5:
                  if (t && (!t || t.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getAllProducers] No data returned");
                case 7:
                  return e.abrupt("return", t.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        zi = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/assign"), {
                    producer: r
                  });
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.rescheduledBooking] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  if (n && (!n || n.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.rescheduledBooking] No data returned");
                case 7:
                  return e.abrupt("return", n.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        $i = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/reassign"), {
                    producer: r
                  });
                case 2:
                  if (!(n = e.sent) || 204 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.reassign] request status is different from 204:\n      ".concat(n.status));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Zi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/cancelAssign"));
                case 2:
                  if (!(r = e.sent) || 204 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.cancelAssign] request status is different from 204:\n      ".concat(r.status));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ji = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/gameTime"), {
                    gameStartTime: r
                  });
                case 2:
                  if (!(n = e.sent) || 204 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.reassign] request status is different from 204:\n      ".concat(n.status));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Xi = function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/gameTime"), {
                    gameEndTime: r
                  });
                case 2:
                  if (!(n = e.sent) || 204 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.reassign] request status is different from 204:\n      ".concat(n.status));
                case 5:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Ki = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Ai, "/booking/").concat(t, "/startVideoStream"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.startVideoStream] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.startVideoStream] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Qi = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Ai, "/booking/").concat(t, "/stopVideoStream"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.stopVideoStream] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var eu = {
        scheduledNewBooking: Mi,
        editBooking: Ui,
        cancelBooking: Li,
        getAllProducers: Wi,
        getBookingsByClub: Yi,
        getBookingsByTeam: Gi,
        getBookingsByStatus: Hi,
        getBookingsByUser: ji,
        assignProducer: zi,
        reassignProducer: $i,
        setGameStartTime: Ji,
        setGameEndTime: Xi,
        cancelAssign: Zi,
        startVideoStream: Ki,
        getTeamCredits: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/insecure/credits/").concat(t));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getTeamCredits] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[booking.api.getTeamCredits] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        startProducer: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Ai, "/booking/").concat(t, "/startProducer"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.startProducer] request status is different from 204:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        stopVideoStream: Qi,
        getBookingsById: Vi,
        getBookingsByProducerCount: Bi,
        getAllBookingsCount: Fi,
        getLeanClubBookings: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/insecure/club/").concat(t, "/bookings"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getLeanClubBookings] request status is different from 200: ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getLeanTeamBookings: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Ai, "/insecure/team/").concat(t, "/bookings"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[booking.api.getLeanTeamBookings] request status is different from 200: ".concat(r.status));
                case 5:
                  return e.abrupt("return", r.data);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        scheduleNewBooking: function () {
          var e = C()(R().mark(function e(t) {
            var r, n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = t.teamId, e.next = 3, _n.sendRequest("POST", "".concat(Ai, "/team/").concat(r, "/booking"), t);
                case 3:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 6;
                    break;
                  }
                  throw new Error("[booking.api.scheduleNewBooking] request status is different from 200: ".concat(n.status));
                case 6:
                  return e.abrupt("return", n.data);
                case 7:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
      var tu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.scheduledNewBooking(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ru = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.editBooking(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        nu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.cancelBooking(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        au = function () {
          var e = C()(R().mark(function e() {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getBookingsCount());
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        su = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = n.length > 1 && void 0 !== n[1] && n[1], e.abrupt("return", eu.getBookingsById(t, r));
                case 2:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ou = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getBookingsByClub(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        iu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getBookingsByTeam(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        uu = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = s.length > 1 && void 0 !== s[1] ? s[1] : 200, n = s.length > 2 && void 0 !== s[2] ? s[2] : 0, a = s.length > 3 ? s[3] : void 0, e.abrupt("return", eu.getBookingsByUser(t, r, n, a));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        cu = function () {
          var e = C()(R().mark(function e(t) {
            var r,
              n,
              a,
              s = arguments;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return r = s.length > 1 && void 0 !== s[1] ? s[1] : 200, n = s.length > 2 && void 0 !== s[2] ? s[2] : 0, a = s.length > 3 ? s[3] : void 0, e.abrupt("return", eu.getBookingsByStatus(t, r, n, a));
                case 4:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        fu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.assignProducer(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        du = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.reassignProducer(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        pu = function () {
          var e = C()(R().mark(function e() {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getAllProducers());
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        lu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.setGameStartTime(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        hu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.setGameEndTime(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        mu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.cancelAssign(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        vu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.startVideoStream(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        wu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getTeamCredits(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        gu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.startProducer(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        yu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.stopVideoStream(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        bu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getBookingsByProducerCount(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        ku = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", eu.getAllBookingsCount(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        xu = function xu(e) {
          if (!e) throw new Error("[bookings.getLeanClubBookings] no valid club identifier");
          return eu.getLeanClubBookings(e);
        },
        Tu = function Tu(e) {
          if (!e) throw new Error("[bookings.getLeanTeamBookings] no valid team id");
          return eu.getLeanTeamBookings(e);
        },
        Eu = function Eu(e) {
          var t = e.bookingDate,
            r = e.teamId;
          if (!r || !t) throw new Error("[bookings.scheduleNewBooking] should get teamId and bookingData but got ".concat(r, " and ").concat(t));
          return eu.scheduleNewBooking(e);
        };
      var _u = g;
      var Cu = "v1",
        Su = function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("GET", "".concat(Cu, "/team/").concat(t, "/isRemoteProducer"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.isRemoteProducer] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[remoteProducer.api.isRemoteProducer] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }();
      var Ru = {
        setPtzCameraLimits: function () {
          var e = C()(R().mark(function e(t, r, n) {
            var a;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Cu, "/team/").concat(t, "/remoteProducer/setLimits"), {
                    limitIndex: r,
                    value: n
                  });
                case 2:
                  if (!(a = e.sent) || 200 === a.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.setPtzCameraLimits] request status is different from 200:\n      ".concat(a.status));
                case 5:
                  return e.abrupt("return", a);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        getPtzCameraLimits: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Cu, "/team/").concat(t, "/remoteProducer/setLimits"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.getPtzCameraLimits] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  if (r && (!r || r.data)) {
                    e.next = 7;
                    break;
                  }
                  throw new Error("[remoteProducer.api.getPtzCameraLimits] No data returned");
                case 7:
                  return e.abrupt("return", r.data);
                case 8:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        startScoreClock: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Cu, "/booking/").concat(t, "/remoteProducer/clock/start"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.startScoreClock] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        stopScoreClock: function () {
          var e = C()(R().mark(function e(t) {
            var r;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Cu, "/booking/").concat(t, "/remoteProducer/clock/stop"));
                case 2:
                  if (!(r = e.sent) || 200 === r.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.stopScoreClock] request status is different from 200:\n      ".concat(r.status));
                case 5:
                  return e.abrupt("return", r);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        setScoreClock: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Cu, "/booking/").concat(t, "/remoteProducer/clock/set"), r);
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.setScoreClock] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        setScore: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("PATCH", "".concat(Cu, "/booking/").concat(t, "/remoteProducer/score"), r);
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.startScoreCamera] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        isRemoteProducer: Su,
        killDocker: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Cu, "/booking-maintenance/docker/kill"), {
                    teamId: t,
                    dockerName: r
                  });
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.killDocker] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        restartDocker: function () {
          var e = C()(R().mark(function e(t, r) {
            var n;
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, _n.sendRequest("POST", "".concat(Cu, "/booking-maintenance/docker/restart"), {
                    teamId: t,
                    dockerName: r
                  });
                case 2:
                  if (!(n = e.sent) || 200 === n.status) {
                    e.next = 5;
                    break;
                  }
                  throw new Error("[remoteProducer.api.restartDocker] request status is different from 200:\n      ".concat(n.status));
                case 5:
                  return e.abrupt("return", n);
                case 6:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }()
      };
      var Du = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.setPtzCameraLimits(t, r, n));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Pu = function () {
          var e = C()(R().mark(function e(t, r, n) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.getPtzCameraLimits(t, r, n));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        Iu = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.startScoreClock(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Ou = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.stopScoreClock(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Nu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.setScoreClock(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        qu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.setScore(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Au = function () {
          var e = C()(R().mark(function e(t) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.isRemoteProducer(t));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        Mu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.restartDocker(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        Uu = function () {
          var e = C()(R().mark(function e(t, r) {
            return R().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ru.killDocker(t, r));
                case 1:
                case "end":
                  return e.stop();
              }
            }, e);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }();
      var Lu = y,
        Fu = {
          createStripeCheckoutSession: function () {
            var e = C()(R().mark(function e(t) {
              var r, n, a, s, o, i, u, c, f;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = t.amount, n = t.successUrl, a = t.cancelUrl, s = t.currency, o = t.image, i = t.metadata, u = t.gameCount, c = "".concat("v1", "/insecure/payment/checkout"), e.next = 4, _n.sendRequest("PATCH", c, {
                      amount: r,
                      successUrl: n,
                      cancelUrl: a,
                      currency: s,
                      image: o,
                      metadata: i,
                      gameCount: u
                    });
                  case 4:
                    if (!(f = e.sent) || 200 === f.status) {
                      e.next = 7;
                      break;
                    }
                    throw new Error("[payments.api.createStripeCheckoutSession] response status is different from 200:\n      ".concat(f.status));
                  case 7:
                    return e.abrupt("return", f.data);
                  case 8:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        };
      var Bu = function Bu(e) {
        var t = e.amount,
          r = e.successUrl,
          n = e.cancelUrl,
          a = e.currency,
          s = e.image,
          o = e.metadata,
          i = e.gameCount;
        if (!t && !i || !r || !n) throw new Error("[payments.createStripeCheckoutSession]: must include:\n        either amount: ".concat(t, " or gameCount: ").concat(i, ", successUrl: ").concat(r, ", cancelUrl: ").concat(n, "\n      "));
        return Fu.createStripeCheckoutSession({
          amount: t,
          successUrl: r,
          cancelUrl: n,
          currency: a,
          image: s,
          metadata: o,
          gameCount: i
        });
      };
      var Vu = b,
        Gu = {
          getSignedUrl: function () {
            var e = C()(R().mark(function e(t) {
              var r, n, a;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = t.teamId, n = t.uniqueId, e.next = 3, _n.sendRequest("GET", "".concat("v1", "/team/").concat(r, "/overlayUploadUrl/").concat(n));
                  case 3:
                    if (!(a = e.sent) || 200 === a.status) {
                      e.next = 6;
                      break;
                    }
                    throw new Error("[liveStreamDashboard.api.getSignedUrl] request status is different from 200:\n      ".concat(a.status));
                  case 6:
                    return e.abrupt("return", a.data);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }(),
          isAllowedToEdit: function () {
            var e = C()(R().mark(function e(t) {
              var r;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, _n.sendRequest("GET", "".concat("v1", "/team/").concat(t, "/isAllowedToEditOverlay"));
                  case 2:
                    if (!(r = e.sent) || 200 === r.status) {
                      e.next = 5;
                      break;
                    }
                    throw new Error("[liveStreamDashboard.api.isAllowedToEdit] request status is different from 200:\n      ".concat(r.status));
                  case 5:
                    return e.abrupt("return", r.data);
                  case 6:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        };
      var Yu = function Yu(e) {
          var t = e.teamId,
            r = e.uniqueId;
          if (!t || !r) throw new Error("[liveStreamDashboard.getSignedUrl] must include teamId and uniqueId but got ".concat(t, " and ").concat(r));
          return Gu.getSignedUrl({
            teamId: t,
            uniqueId: r
          });
        },
        ju = function ju(e) {
          if (!e) throw new Error("[liveStreamDashboard.isAllowedToEdit] must include teamId but got ".concat(e));
          return Gu.isAllowedToEdit(e);
        };
      var Hu = k,
        Wu = {
          createAsset: function () {
            var e = C()(R().mark(function e(t) {
              var r, n, a, s, o;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = t.team, n = t.url, a = t.type, s = "".concat("v1", "/team/").concat(r, "/asset"), e.next = 5, _n.sendRequest("POST", s, {
                      url: n,
                      type: a
                    });
                  case 5:
                    return o = e.sent, e.abrupt("return", o.data);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }(),
          getTeamAssets: function () {
            var e = C()(R().mark(function e(t) {
              var r, n, a, s;
              return R().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = t.id, n = t.type, a = n ? "".concat("v1", "/team/").concat(r, "/asset?type=").concat(n) : "".concat("v1", "/team/").concat(r, "/asset"), e.next = 5, _n.sendRequest("GET", a);
                  case 5:
                    return s = e.sent, e.abrupt("return", s.data);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        };
      var zu = function zu(e) {
          var t = ["OVERLAY", "LOGO"];
          if (e && !t.includes(e)) throw new Error("[assets.getTeamAssets] type must be one of ".concat(t.join(", "), " but got: ").concat(e));
        },
        $u = function $u(e) {
          var t = e.team,
            r = e.url,
            n = e.type;
          if (!Pn(r) || !Pn(t)) throw new Error("[assets.createAsset] must provide valid url and team but got: ", r, t);
          return zu(n), Wu.createAsset({
            team: t,
            url: r,
            type: n
          });
        },
        Zu = function Zu(e) {
          var t = e.id,
            r = e.type;
          if (!Pn(t)) throw new Error("[assets.getTeamAssets] must provide valid id but got: ", t);
          return zu(r), Wu.getTeamAssets({
            id: t,
            type: r
          });
        };
      var Ju = x;
      var Xu = E();
      var Ku = {
        cameraControl: Xa,
        game: Io,
        user: wn,
        config: M,
        utils: Wn,
        stats: Ho,
        axiosInstance: Xu,
        liveProduction: Pi,
        monitor: qi,
        remoteProducer: Lu,
        payments: Vu,
        liveStreamDashboard: Hu,
        asset: Ju
      };
    }(), n;
  }();
});